import React, { useRef } from 'react'
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Tooltip from '@mui/material/Tooltip';
import Icons from "../../../components/Icons";
import Audit from "../../../components/Audit";
import Contability from "../../../components/Contability";
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import TimedAlert from "../../../components/TimedAlert";
import usePagination from "../../../components/Pagination";
import informationService from '../../../services/system';
import constantService from '../../../services/constant';
import auditService from '../../../services/audit';
import rolesService from "../../../services/roles"
import fundsIntegration from "../../../integrations/funds";
import valoIntegration from '../../../services/valo';
import MenuApp from '../../../components/Menu';
import AuthService from "../../../services/security/auth.service";
import TypographyComponent from '../../../components/Typography';
import TextFieldComponent from '../../../components/TextField';
import NumberComponent from '../../../components/Number';
import CurrencyComponent from '../../../components/Currency';
import CheckBoxComponent from '../../../components/CheckBox';
import SwitchComponent from '../../../components/Switch';
import SelectComponent from '../../../components/Select';
import DateComponent from '../../../components/Date';
import DateTimeComponent from '../../../components/DateTime';
import TimeComponent from '../../../components/Time';
import RadioComponent from '../../../components/Radio';
import LabelIcon from '@mui/icons-material/Label';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { ThemeProvider } from '@mui/material/styles';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import constantsDesign from '../../../utils/constants';
import uploadFile from '../../../utils/uploadFile';
import PercentageComponente from '../../../components/Percentage';
import Grid from '@mui/material/Grid';
import FileComponent from '../../../components/File';
import JsonComponent from '../../../components/Json';
import CssBaseline from '@mui/material/CssBaseline';
import constants from '../../../utils/constants';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Checkbox from '@mui/material/Checkbox';
import setCurrencyFxRate from '../../../utils/setCurrencyFxRate';
import setAccountId from '../../../utils/setAccountId';
import trxLine from '../../../utils/setTrxLine';
import initialDoc from '../../../utils/initialDoc';
import _ from 'lodash';
import globalFunctions from '../../../utils/globalFunctions';

var arrayFieldsSource = [];
var arrayFieldsSourceGroup = [];
const generateNumber = () => {
    const numeros = '0123456789';
    const nuevoValor = [];

    for (let i = 0; i < 3; i++) {
        nuevoValor.push(numeros[Math.floor(Math.random() * numeros.length)]);
    }

    return nuevoValor.join('');
};

const initialField = (data) => {
    let fieldInitial = {};
    for (let u = 0; u < data.list.filters.length; u++) {
        switch (data.list.filters[u].type) {
            case 'Select':
                fieldInitial[data.list.filters[u].id] = null;
                break;
            case 'MultipleSelect':
                fieldInitial[data.list.filters[u].id] = [];
                break;
            case 'Checkbox':
                fieldInitial[data.list.filters[u].id] = false;
                break;
            case 'Switch':
                fieldInitial[data.list.filters[u].id] = false;
                break;
            case 'TextField':
                fieldInitial[data.list.filters[u].id] = '';
                break;
            case 'Button':
                fieldInitial[data.list.filters[u].id] = '';
                break;
            case 'Password':
                fieldInitial[data.list.filters[u].id] = '';
                break;
            case 'Number':
                fieldInitial[data.list.filters[u].id] = '';
                break;
            case 'Currency':
                fieldInitial[data.list.filters[u].id] = '';
                break;
            case 'Date':
                fieldInitial[data.list.filters[u].id] = "";
                break;
            case 'List':
                fieldInitial[data.list.filters[u].id] = [];
                break;
            default:
                fieldInitial[data.list.filters[u].id] = "";
                break;
        }
    }

    for (let u = 0; u < data.list.fields.length; u++) {
        fieldInitial[data.list.fields[u].id] = '';
    }

    for (let r = 0; r < data.crud.boxes.length; r++) {
        for (let u = 0; u < data.crud.boxes[r].fields.length; u++) {
            switch (data.crud.boxes[r].fields[u].type) {
                case 'Select':
                    fieldInitial[data.crud.boxes[r].fields[u].id] = null;
                    break;
                case 'MultipleSelect':
                    fieldInitial[data.crud.boxes[r].fields[u].id] = [];
                    break;
                case 'Checkbox':
                    fieldInitial[data.crud.boxes[r].fields[u].id] = false;
                    break;
                case 'Switch':
                    fieldInitial[data.crud.boxes[r].fields[u].id] = false;
                    break;
                case 'TextField':
                    fieldInitial[data.crud.boxes[r].fields[u].id] = '';
                    break;
                case 'Button':
                    fieldInitial[data.crud.boxes[r].fields[u].id] = '';
                    break;
                case 'Password':
                    fieldInitial[data.crud.boxes[r].fields[u].id] = '';
                    break;
                case 'Number':
                    fieldInitial[data.crud.boxes[r].fields[u].id] = '';
                    break;
                case 'Currency':
                    fieldInitial[data.crud.boxes[r].fields[u].id] = '';
                    break;
                case 'Date':
                    fieldInitial[data.crud.boxes[r].fields[u].id] = "";
                    break;
                case 'List':
                    fieldInitial[data.crud.boxes[r].fields[u].id] = [];
                    break;
                default:
                    fieldInitial[data.crud.boxes[r].fields[u].id] = "";
                    break;
            }
            if (data.crud.boxes[r].fields[u].group !== null) {
                for (let g = 0; g < data.crud.boxes[r].fields[u].group.length; g++) {
                    for (let h = 0; h < data.crud.boxes[r].fields[u].group[g].fields.length; h++) {
                        switch (data.crud.boxes[r].fields[u].group[g].fields[h].type) {
                            case 'Select':
                                fieldInitial[data.crud.boxes[r].fields[u].group[g].fields[h].id] = null;
                                break;
                            case 'MultipleSelect':
                                fieldInitial[data.crud.boxes[r].fields[u].group[g].fields[h].id] = [];
                                break;
                            case 'Checkbox':
                                fieldInitial[data.crud.boxes[r].fields[u].group[g].fields[h].id] = false;
                                break;
                            case 'Switch':
                                fieldInitial[data.crud.boxes[r].fields[u].group[g].fields[h].id] = false;
                                break;
                            case 'TextField':
                                fieldInitial[data.crud.boxes[r].fields[u].group[g].fields[h].id] = '';
                                break;
                            case 'Button':
                                fieldInitial[data.crud.boxes[r].fields[u].group[g].fields[h].id] = '';
                                break;
                            case 'Password':
                                fieldInitial[data.crud.boxes[r].fields[u].group[g].fields[h].id] = '';
                                break;
                            case 'Number':
                                fieldInitial[data.crud.boxes[r].fields[u].group[g].fields[h].id] = '';
                                break;
                            case 'Currency':
                                fieldInitial[data.crud.boxes[r].fields[u].group[g].fields[h].id] = '';
                                break;
                            case 'Date':
                                fieldInitial[data.crud.boxes[r].fields[u].group[g].fields[h].id] = "";
                                break;
                            case 'List':
                                fieldInitial[data.crud.boxes[r].fields[u].group[g].fields[h].id] = [];
                                break;
                            default:
                                fieldInitial[data.crud.boxes[r].fields[u].group[g].fields[h].id] = "";
                                break;
                        }
                    }
                }
            }
        }
    }

    return fieldInitial;
}

const initialArrayGroup = (data) => {
    let fieldInitial = {};
    let arrayFlagGroup = [];

    for (let r = 0; r < data.boxes.length; r++) {
        for (let u = 0; u < data.boxes[r].fields.length; u++) {
            if (data.boxes[r].fields[u].group) {
                for (let t = 0; t < data.boxes[r].fields[u].group.length; t++) {
                    let existe = false;
                    for (let i = 0; i < arrayFlagGroup.length; i++) {
                        if (arrayFlagGroup[i] === data.boxes[r].fields[u].group[t].name) {
                            existe = true;
                        }
                    }
                    if (existe === false) {
                        let nameSubgroup;
                        for (let e = 0; e < data.boxes[r].fields[u].group[t].fields.length; e++) {
                            if (data.boxes[r].fields[u].group[t].fields[e].subGroup) {
                                for (let j = 0; j < data.boxes[r].fields[u].group[t].fields[e].subGroup.length; j++) {
                                    nameSubgroup = data.boxes[r].fields[u].group[t].fields[e].subGroup[j].name
                                };
                            }
                        }
                        arrayFlagGroup.push({
                            name: data.boxes[r].fields[u].group[t].name,
                            nameSubgroup
                        });
                    }
                }
            }
        }
    }

    for (var i = 0; i < arrayFlagGroup.length; i++) {
        if (arrayFlagGroup[i].nameSubgroup !== undefined)
            fieldInitial[arrayFlagGroup[i].name] = [{
                subGroup: [{
                    [arrayFlagGroup[i].nameSubgroup]: []
                }]
            }];
        else
            fieldInitial[arrayFlagGroup[i].name] = [];
    }
    return fieldInitial;
}

const SystemPages = ({ data, instance, pathParameter }) => {
    const location = useLocation()
    let navigate = useNavigate();
    const params = new URLSearchParams(location.search)
    let id = params.get("id");
    let mode = params.get("m");
    const [roles, setRoles] = useState([]);
    const [availabity, setAvailability] = useState(false);
    const [recordLoad, setRecordLoad] = useState(false);
    const [filterAvailable, setFilterAvailable] = useState(false);
    const [info, setInfo] = useState([]);
    const [list, setList] = useState([]);
    const [currencys, setCurrencys] = useState([]);
    const [paymentTerm, setPaymentTerm] = useState([]);
    const [field, setField] = useState(initialField(data));
    const [previousValue, setPreviousValue] = useState({});
    const [audit, setAudit] = useState([]);
    const [viewId, setViewId] = useState(false);
    const [posted, setPosted] = useState(false);
    const [title, setTitle] = useState('');
    const [load, setLoad] = useState(true);
    const [loadList, setLoadList] = useState(true);
    const [recortCountTotalLoad, setRecordCountLoad] = useState(false);
    const [totalFooterLoad, setTotalFooterLoad] = useState(false);
    const [totalSaldoAnteriorLoad, setTotalSaldoAnteriorLoad] = useState(false);
    const [loadIntegration, setLoadIntegration] = useState(false);
    const [loadButtonAction, setLoadButtonAction] = useState(false);
    const [loadGroup, setLoadGroup] = useState(true);
    const [message, setMessage] = useState({ error: false, message: '' });
    const [open, setOpen] = React.useState(false);
    const [path, setPath] = useState('');
    const [group, setGroup] = useState(initialArrayGroup(data.crud));
    const [arrayGroupsDelete, setArrayGroupDelete] = useState(initialArrayGroup(data.crud));
    const [modeFlag, setModeFlag] = useState('');
    const [errorSave, setErrorSave] = useState('');
    const [listSegmentSize, setListSegmentSize] = useState(0);
    const [page, setPage] = React.useState(1);
    const [error, setError] = useState({});
    const [helpText, setHelpText] = useState({});
    const [formatCurrency, setFormatCurrency] = useState({});
    const PER_PAGE = listSegmentSize;
    const [recordCount, setRecordCount] = useState(0);
    const [totalHeader, setTotalHeader] = useState(null);
    const [totalFooter, setTotalFooter] = useState(null);
    const count = Math.ceil(recordCount / PER_PAGE);
    const _DATA = usePagination(list, PER_PAGE);
    const [selectedIds, setSelectedIds] = useState([]);
    const [whereFields, setWhereFields] = useState([]);
    const [redirectId, setRedirectId] = useState([]);
    const boxRef = useRef(null);
    const [erroresIntegracion, setErroresIntegracion] = useState('');
    const [collapsedStates, setCollapsedStates] = useState(
        data.crud.boxes.map(box => box.isCollapsed)
    );
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
    const [messageFileUpload, setMessageFileUpload] = useState('');
    const [isTrxPropId, setIsTrxPropId] = useState(false);
    const [total, setTotal] = useState(false);
    const [zoom, setZoom] = useState(window.innerWidth * window.devicePixelRatio);

    useEffect(() => {
        const handleResize = () => {

            setIsMobile(window.innerWidth <= 600);
            setZoom(window.innerWidth * window.devicePixelRatio);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    //let fieldFilter = {};

    const handleToggleCollapse = (index) => {
        setCollapsedStates((prevStates) =>
            prevStates.map((collapsed, i) => (i === index ? !collapsed : collapsed))
        );
    };

    const handleChangePagination = (event, value) => {
        setPage(value);
        _DATA.jump(value);
        //call ws
        let fieldsArray = [];
        for (let p = 0; p < data.list.fields.length; p++) {
            if (data.list.fields[p].idFieldTable !== null) {
                fieldsArray.push(data.list.fields[p].idFieldTable);
            }
        }
        let fields = fieldsArray.join(",");
        setLoadList(true);
        //setLoad(true);
        let offset = (Number(value) - 1) * 100;

        let whereFieldsPF = JSON.parse(JSON.stringify(whereFields))
        filterByTradeAccountIdManagerId(whereFieldsPF);

        informationService.searchViewList(`${instance}.${data.list.view}`, data.id, fields, offset, Number(listSegmentSize), whereFieldsPF).then((response) => {
            let arrayResponse = [];
            for (let i = 0; i < info.length; i++) {
                if (info[i].source !== data.list.view) {
                    arrayResponse.push(info[i]);
                }
            }

            let arrayInitialList = [];
            for (let i = 0; i < response.data.length; i++) {
                arrayResponse.push(response.data[i]);
                arrayInitialList.push(response.data[i]);
            }
            //setInfo(arrayResponse);
            setList(arrayInitialList);
            //setLoad(false);
            setLoadList(false);

        }).catch((error) => {
            console.log(error);
        });
    };

    const parseQueryParams = () => {
        const params = new URLSearchParams(window.location.search);
        const operatorList = ['>=', '<=', '!=', 'like', '=', '>', '<']; // ordenado

        const result = [];

        for (const [key, value] of params.entries()) {
            if (key === 'm' || key === 'id') continue;

            let operator = '=';
            let field = key;
            let actualValue = value;

            for (const op of operatorList) {
                if (key.includes(op)) {
                    const parts = key.split(op);
                    field = parts[0];
                    operator = op;

                    if (operator === 'like' && !value) {
                        actualValue = parts[1] || '';
                    }
                    break;
                }
            }

            result.push({
                idField: field,
                operator: operator,
                value: actualValue
            });
        }
        return result;
    }

    const getFilteredParams = () => {
        const params = new URLSearchParams(window.location.search);
        const excludedKeys = ['m', 'id'];
        const newParams = new URLSearchParams();

        for (const [key, value] of params.entries()) {
            if (!excludedKeys.includes(key)) {
                newParams.append(key, value);
            }
        }

        const paramString = newParams.toString();

        return paramString ? `&${paramString}` : '';
    }

    const buildParam = (field, operator, value) => {
        return `${encodeURIComponent(field + operator)}=${encodeURIComponent(value)}`;
    };

    const filterByTradeAccountIdManagerId = (whereFieldParam) => {
        const user = AuthService.getCurrentUser();

        if (user.data.companyId) {
            let existe = false;
            whereFieldParam.forEach((item) => {
                if (item.idField === 'companyId') {
                    existe = true;
                    item.value = user.data.companyId
                }
            })
            if (existe === false) {
                whereFieldParam.push({
                    idField: 'companyId',
                    operator: '=',
                    value: user.data.companyId
                })
            }
        }

        if (user.data.tradeAccountId) {
            let existe = false;
            whereFieldParam.forEach((item) => {
                if (item.idField === 'tradeAccountId') {
                    existe = true;
                    item.value = user.data.tradeAccountId
                }
            })
            if (existe === false) {
                whereFieldParam.push({
                    idField: 'tradeAccountId',
                    operator: '=',
                    value: user.data.tradeAccountId
                })
            }
        } else {
            if (user.data.isManager === '1') {
                let existe = false;
                whereFieldParam.forEach((item) => {
                    if (item.idField === 'managerId') {
                        existe = true;
                        item.value = user.data.managerId
                    }
                })
                if (existe === false) {
                    whereFieldParam.push({
                        idField: 'managerId',
                        operator: '=',
                        value: user.data.managerId
                    })
                }
            }
        }
    }

    useEffect(() => {
        //FCI
        if (recordLoad && mode === 'r' && data.crud.route === 'funds') {
            fciConsulta(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recordLoad])

    useEffect(() => {
        setErroresIntegracion('');
        setLoadList(true);
        setLoad(true);
        setLoadGroup(true);
        setErrorSave('');
        setLoadIntegration(false);
        setLoadButtonAction(false);
        setFilterAvailable(false);
        setArrayGroupDelete(initialArrayGroup(data.crud));
        setMessageFileUpload('')
        setIsTrxPropId(false);
        setList([]);
        setRedirectId([]);
        setCollapsedStates(data.crud.boxes.map(box => box.isCollapsed));
        const user = AuthService.getCurrentUser();

        if (user) {
            rolesService.viewRoles(constants.CLIENT, user.data.instance).then((responseRoles) => {
                let arrayRoles = [];
                for (let d = 0; d < responseRoles.data.length; d++) {
                    if (user.data.role === responseRoles.data[d].id) {
                        for (let h = 0; h < responseRoles.data[d].docs.length; h++) {
                            arrayRoles.push(responseRoles.data[d].docs[h]);
                            if (responseRoles.data[d].docs[h].name === pathParameter) {

                                switch (responseRoles.data[d].docs[h].level) {
                                    case 'full':
                                        setAvailability(true);
                                        break;
                                    case 'edit':
                                        if (mode === 'c' || mode === 'u' || mode === 'r' || mode === 'l') {
                                            setAvailability(true);
                                        }
                                        break;
                                    case 'viewOnly':
                                        if (mode === 'r' || mode === 'l') {
                                            setAvailability(true);
                                        }
                                        break;
                                    default:
                                        setAvailability(false);
                                        break;
                                }
                            }

                        }
                    }
                }
                setRoles(arrayRoles)
            })


            informationService.searchView(`wbSys.currency`, data.id).then((response) => {
                setCurrencys(response.data);
            });

            informationService.searchView(`${instance}.argCvPaymentTermView`, data.id).then((response) => {
                setPaymentTerm(response.data);
            });

            if (mode === 'l') {
                document.title = `${data.list.title} - wBroker`;
                data.list.fields = orderArray(data.list.fields);
                data.list.buttonsHeader = orderArray(data.list.buttonsHeader);
                for (let p = 0; p < data.list.fields.length; p++) {
                    if ((data.list.fields[p].type === 'Currency' || data.list.fields[p].type.includes('Number')) && data.list.fields[p].display !== 'hidden' && (data.list.fields[p].idFieldTable.toUpperCase().includes('QTY') || data.list.fields[p].idFieldTable.toUpperCase().includes('AMOUNT'))) {
                        setTotal(true);
                    }
                }

                if (data.list.view !== null) {
                    if (user) {
                        constantService.viewConstantsFindAll(constants.CLIENT, user.data.instance).then((response) => {
                            setListSegmentSize(response.data.constants.listSegmentSize.value)
                            let limit = 50;
                            if (response.data.constants.listSegmentSize.value)
                                limit = response.data.constants.listSegmentSize.value;

                            let fieldsArray = [];
                            for (let p = 0; p < data.list.fields.length; p++) {
                                if (data.list.fields[p].idFieldTable !== null) {
                                    fieldsArray.push(data.list.fields[p].idFieldTable);
                                }
                            }
                            let fields = fieldsArray.join(",");

                            let whereFieldParam = parseQueryParams();

                            if (whereFieldParam.length === 0 && whereFields.length === 0) {
                                data.list.filters.forEach((itemFilters) => {
                                    if (itemFilters.function === 'addFilter') {
                                        whereFieldParam.push({
                                            idField: itemFilters.idFieldTable,
                                            operator: itemFilters.operator,
                                            value: '0'
                                        })
                                    }
                                })
                            } else {
                                if (whereFieldParam.length === 0 && whereFields.length !== 0) {
                                    whereFieldParam = whereFields;
                                }
                            }

                            setRecordCountLoad(true);
                            setTotalFooterLoad(true);
                            setTotalSaldoAnteriorLoad(true);

                            let whereFieldsPF = JSON.parse(JSON.stringify(whereFieldParam))
                            filterByTradeAccountIdManagerId(whereFieldsPF);

                            let arrayTables = [];
                            let whereFilters = [];
                            filterByTradeAccountIdManagerId(whereFilters);
                            for (let h = 0; h < data.list.filters.length; h++) {
                                if (data.list.filters[h].sourceSelect !== null) {
                                    let existe = false;
                                    for (let y = 0; y < arrayTables.length; y++) {
                                        if (data.list.filters[h].sourceSelect === arrayTables[y].table.split('.')[1]) {
                                            existe = true;
                                        }
                                    }

                                    if (existe === false) {
                                        let doc = [];
                                        if (data.list.filters[h].sourceSelectDoc !== null) {
                                            for (let n = 0; n < data.list.filters[h].sourceSelectDoc.length; n++) {
                                                doc.push(data.list.filters[h].sourceSelectDoc[n]);
                                            }
                                        }

                                        let selectFilters = [];
                                        arrayTables.push({
                                            table: `${user.data.instance}.${data.list.filters[h].sourceSelect}`,
                                            doc: [],
                                            selectFilters: selectFilters,
                                            whereFilters: whereFilters
                                        })
                                    }
                                }
                            }

                            informationService.viewTables().then((response) => {
                                for (let r = 0; r < response.data.length; r++) {
                                    for (let y = 0; y < arrayTables.length; y++) {
                                        let tableFlag = arrayTables[y].table.split('.');
                                        if (tableFlag[1] === response.data[r].name) {
                                            arrayTables[y].table = `wbSys.${tableFlag[1]}`
                                        }
                                    }
                                }


                                informationService.findSourceField(arrayTables).then((response) => {
                                    let arrayResponse = [];
                                    for (let i = 0; i < response.data.length; i++) {
                                        arrayResponse.push(response.data[i]);
                                    }
                                    setInfo(arrayResponse);

                                    //DEFAULT VALUE                        
                                    data.list.filters.forEach((itemFields) => {
                                        if (itemFields.defaultValue) {
                                            let idField = itemFields.id;
                                            switch (itemFields.type) {
                                                case 'Select':
                                                    arrayResponse.forEach((itemInfo) => {
                                                        if (itemInfo.source === itemFields.sourceSelect) {
                                                            if (Number(itemFields.defaultValue) === Number(itemInfo.id)) {
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [idField]: {
                                                                        id: itemInfo.id,
                                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                    }
                                                                }), []);
                                                                let existe = false;
                                                                for (let d = 0; d < whereFieldsPF.length; d++) {
                                                                    if (whereFieldsPF[d].idField === itemFields.idFieldTable)
                                                                        existe = true;
                                                                }
                                                                if (existe === false)
                                                                    whereFieldsPF.push({ idField: itemFields.idFieldTable, operator: itemFields.operator, value: `'${itemInfo.id}'`, idDom: itemFields.id, type: itemFields.type, sourceSelect: null })

                                                            }
                                                        }
                                                    })
                                                    break;
                                                case 'Date':
                                                    if (itemFields.defaultValue === 'CURDATE()') {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [idField]: new Date().toISOString().split('T')[0]
                                                        }), []);
                                                        let existe = false;
                                                        for (let d = 0; d < whereFieldsPF.length; d++) {
                                                            if (whereFieldsPF[d].idField === itemFields.idFieldTable)
                                                                existe = true;
                                                        }
                                                        if (existe === false)
                                                            whereFieldsPF.push({ idField: itemFields.idFieldTable, operator: itemFields.operator, value: `'${new Date().toISOString().split('T')[0]}'`, idDom: itemFields.id, type: itemFields.type, sourceSelect: null })

                                                    }
                                                    break;
                                                default:
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: itemFields.defaultValue
                                                    }), []);
                                                    let existe = false;
                                                    for (let d = 0; d < whereFieldsPF.length; d++) {
                                                        if (whereFieldsPF[d].idField === itemFields.idFieldTable)
                                                            existe = true;
                                                    }
                                                    if (existe === false)
                                                        whereFieldsPF.push({ idField: itemFields.idFieldTable, operator: itemFields.operator, value: `'${itemFields.defaultValue}'`, idDom: itemFields.id, type: itemFields.type, sourceSelect: null })


                                                    break;
                                            }
                                        }
                                    })
                                    setWhereFields(whereFieldsPF);

                                    informationService.searchViewList(`${instance}.${data.list.view}`, data.id, fields, 0, limit, whereFieldsPF).then((response) => {
                                        setFilterAvailable(true);
                                        //let arrayResponse = [];
                                        let arrayInitialList = [];
                                        for (let i = 0; i < response.data.length; i++) {
                                            //arrayResponse.push(response.data[i]);
                                            arrayInitialList.push(response.data[i]);
                                        }

                                        setList(arrayInitialList);
                                        for (let t = 0; t < whereFieldsPF.length; t++) {
                                            let idField = whereFieldsPF[t].idField;
                                            let value = whereFieldsPF[t].value.replace(/^'+|'+$/g, '');
                                            let operator = whereFieldsPF[t].operator;

                                            let paramWhere = 'filters';
                                            if (operator === 'like') {
                                                paramWhere = 'fields';
                                            }

                                            for (let n = 0; n < data.list[paramWhere].length; n++) {
                                                let validate = false;
                                                if (paramWhere === 'filters') {
                                                    if (data.list[paramWhere][n].idFieldTable === idField && data.list[paramWhere][n].operator === operator) {
                                                        validate = true;
                                                    }
                                                } else {
                                                    if (data.list[paramWhere][n].idFieldTable === idField) {
                                                        validate = true;
                                                    }
                                                }
                                                if (validate) {
                                                    let type = data.list[paramWhere][n].type;
                                                    switch (type) {
                                                        case 'Select':
                                                            let sourceSelect = data.list[paramWhere][n].sourceSelect;

                                                            arrayResponse.forEach((itemInfo) => {
                                                                if (itemInfo.source === sourceSelect) {
                                                                    if (Number(value) === Number(itemInfo.id)) {
                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [data.list[paramWhere][n].id]: {
                                                                                id: itemInfo.id,
                                                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                            }
                                                                        }), []);
                                                                    }

                                                                }
                                                            })
                                                            break;
                                                        case 'Switch':
                                                            let valueSwitch = value;
                                                            if (operator !== 'like') {
                                                                valueSwitch = false;
                                                                if (Number(value) === 1)
                                                                    valueSwitch = true;
                                                            }
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [data.list[paramWhere][n].id]: valueSwitch
                                                            }), []);
                                                            break;

                                                        default:
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [data.list[paramWhere][n].id]: value
                                                            }), []);
                                                            break;
                                                    }
                                                }
                                            }
                                        }
                                        setLoad(false);
                                        setLoadList(false);

                                        informationService.searchViewListRecordCount(`${instance}.${data.list.view}`, whereFieldsPF).then((response) => {
                                            setRecordCount(response.data.count);
                                            setRecordCountLoad(false);

                                            informationService.searchViewListTotal(`${instance}.${data.list.view}`, fields, whereFieldsPF).then((response) => {
                                                setTotalFooter(response.data)
                                                setTotalFooterLoad(false);
                                            }).catch((error) => {
                                                console.log(error);
                                            });

                                            let validateTotalHeader = false;
                                            let whereFieldParamFlag = JSON.parse(JSON.stringify(whereFieldsPF))
                                            let valueDate = null;
                                            let idFieldDate = null;
                                            for (let d = 0; d < whereFieldParamFlag.length; d++) {
                                                if (whereFieldParamFlag[d].idField.toUpperCase().includes('DATE') && whereFieldParamFlag[d].operator === ">=") {
                                                    validateTotalHeader = true;
                                                    valueDate = whereFieldParamFlag[d].value;
                                                    idFieldDate = whereFieldParamFlag[d].idField;
                                                }
                                            }
                                            if (validateTotalHeader && valueDate && idFieldDate) {

                                                whereFieldParamFlag = whereFieldParamFlag.filter(obj => !obj.idField.toUpperCase().includes('DATE'));

                                                whereFieldParamFlag.push({
                                                    idField: idFieldDate,
                                                    operator: '<',
                                                    value: valueDate
                                                })


                                                informationService.searchViewListTotal(`${instance}.${data.list.view}`, fields, whereFieldParamFlag).then((response) => {
                                                    setTotalHeader(response.data);
                                                    setTotalSaldoAnteriorLoad(false);
                                                }).catch((error) => {
                                                    console.log(error);
                                                });
                                            } else {
                                                setTotalHeader(null);
                                                setTotalSaldoAnteriorLoad(false);
                                            }
                                        }).catch((error) => {
                                            console.log(error);
                                        });
                                    }).catch((error) => {
                                        console.log(error);
                                        setLoad(false);
                                        setLoadList(false);
                                    });



                                }).catch((error) => {
                                    console.log(error);
                                });
                            }).catch((error) => {
                                console.log(error);
                            });


                        }).catch((error) => {
                            console.log(error);
                            setLoad(false);
                            setLoadList(false);
                        });
                    } else {
                        setLoad(false);
                        setLoadList(false);
                    }

                }
            } else {

                document.title = `${data.crud.title} - wBroker`;
                if (data.crud.boxes) {
                    data.crud.boxes = orderArray(data.crud.boxes);
                }
                for (let h = 0; h < data.crud.boxes.length; h++) {
                    for (let t = 0; t < data.crud.boxes[h].fields.length; t++) {
                        data.crud.boxes[h].fields = orderArray(data.crud.boxes[h].fields);
                    }
                }
                if (data.crud.buttonsHeader) {
                    data.crud.buttonsHeader = orderArray(data.crud.buttonsHeader);
                }
                if (data.crud.buttonsFooter) {
                    data.crud.buttonsFooter = orderArray(data.crud.buttonsFooter);
                }
                if (data.crud.store) {
                    data.crud.store = orderArray(data.crud.store);
                }
                let arrayResponse = [];
                let whereFilters = [];
                filterByTradeAccountIdManagerId(whereFilters);

                let arrayTables = [];
                for (let h = 0; h < data.crud.boxes.length; h++) {
                    for (let u = 0; u < data.crud.boxes[h].fields.length; u++) {

                        if (data.crud.boxes[h].fields[u].sourceSelect !== null) {
                            let existe = false;
                            for (let y = 0; y < arrayTables.length; y++) {
                                if (data.crud.boxes[h].fields[u].sourceSelect === arrayTables[y].table.split('.')[1]) {
                                    existe = true;
                                    if (data.crud.boxes[h].fields[u].dataSource.length > 0) {
                                        let existeSelectFilter = false;
                                        for (let y1 = 0; y1 < arrayTables[y].selectFilters.length; y1++) {
                                            if (arrayTables[y].selectFilters[y1] === data.crud.boxes[h].fields[u].idFieldTable) {
                                                existeSelectFilter = true;
                                            }
                                        }
                                        if (!existeSelectFilter) {
                                            if (data.crud.boxes[h].fields[u].idFieldTable && arrayTables[y].table.split('.')[1] !== data.crud.boxes[h].fields[u].idFieldTable.replace('Id', ''))
                                                arrayTables[y].selectFilters.push(data.crud.boxes[h].fields[u].idFieldTable);
                                        }
                                    }
                                }
                            }

                            if (existe === false) {
                                let doc = [];
                                if (data.crud.boxes[h].fields[u].sourceSelectDoc !== null) {
                                    for (let n = 0; n < data.crud.boxes[h].fields[u].sourceSelectDoc.length; n++) {
                                        doc.push(data.crud.boxes[h].fields[u].sourceSelectDoc[n]);
                                    }
                                }

                                let selectFilters = [];
                                if (data.crud.boxes[h].fields[u].dataSource.length > 0) {
                                    for (let p1 = 0; p1 < data.crud.boxes.length; p1++) {
                                        for (let a1 = 0; a1 < data.crud.boxes[p1].fields.length; a1++) {
                                            for (let bv = 0; bv < data.crud.boxes[h].fields[u].dataSource.length; bv++) {
                                                if (Number(data.crud.boxes[p1].fields[a1].id) === Number(data.crud.boxes[h].fields[u].dataSource[bv])) {
                                                    if (data.crud.boxes[p1].fields[a1].idFieldTable)
                                                        selectFilters.push(data.crud.boxes[p1].fields[a1].idFieldTable)
                                                }
                                            }


                                        }
                                    }
                                }
                                arrayTables.push({
                                    table: `${user.data.instance}.${data.crud.boxes[h].fields[u].sourceSelect}`,
                                    doc: [],
                                    selectFilters: selectFilters,
                                    whereFilters: whereFilters
                                })
                            }
                        }

                        if (data.crud.boxes[h].fields[u].searchSource !== null) {
                            let arraySearchSource = [];
                            for (let q = 0; q < data.crud.boxes[h].fields[u].searchSource.length; q++) {
                                for (let e = 0; e < data.crud.boxes.length; e++) {
                                    for (let w = 0; w < data.crud.boxes[e].fields.length; w++) {
                                        if (data.crud.boxes[e].fields[w].id === data.crud.boxes[h].fields[u].searchSource[q]) {
                                            arraySearchSource.push(data.crud.boxes[e].fields[w]);
                                        }
                                        //modificacion 210725
                                        if (data.crud.boxes[e].fields[w].group !== null) {

                                            for (let w1 = 0; w1 < data.crud.boxes[e].fields[w].group.length; w1++) {
                                                if (data.crud.boxes[e].fields[w].group[w1].design === 'fieldsNoAdd') {
                                                    for (let w2 = 0; w2 < data.crud.boxes[e].fields[w].group[w1].fields.length; w2++) {
                                                        if (data.crud.boxes[e].fields[w].group[w1].fields[w2].id === data.crud.boxes[h].fields[u].searchSource[q]) {
                                                            let objectFieldsNoAdd = JSON.parse(JSON.stringify(data.crud.boxes[e].fields[w].group[w1].fields[w2]));
                                                            objectFieldsNoAdd.fieldsNoAdd = true;
                                                            arraySearchSource.push(objectFieldsNoAdd);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        //modificacion 210725
                                    }
                                }
                            }

                            arrayFieldsSource.push({
                                id: data.crud.boxes[h].fields[u].id,
                                idFieldTable: data.crud.boxes[h].fields[u].idFieldTable,
                                type: data.crud.boxes[h].fields[u].type,
                                search: data.crud.boxes[h].fields[u].search,
                                searchSource: arraySearchSource,
                                sourceSelect: data.crud.boxes[h].fields[u].sourceSelect,
                                orderBox: data.crud.boxes[h].order,
                                nameGroup: null,
                                index: null
                            });
                        }

                        if (data.crud.boxes[h].fields[u].group !== null) {

                            for (let t = 0; t < data.crud.boxes[h].fields[u].group.length; t++) {

                                for (let k = 0; k < data.crud.boxes[h].fields[u].group[t].fields.length; k++) {

                                    if (data.crud.boxes[h].fields[u].group[t].fields[k].sourceSelect !== null) {
                                        let existe = false;
                                        for (let y = 0; y < arrayTables.length; y++) {
                                            if (data.crud.boxes[h].fields[u].group[t].fields[k].sourceSelect === arrayTables[y].table.split('.')[1]) {
                                                existe = true;
                                                if (data.crud.boxes[h].fields[u].group[t].fields[k].dataSource.length > 0) {
                                                    let existeSelectFilter = false;
                                                    for (let y1 = 0; y1 < arrayTables[y].selectFilters.length; y1++) {
                                                        if (arrayTables[y].selectFilters[y1] === data.crud.boxes[h].fields[u].group[t].fields[k].idFieldTable) {
                                                            existeSelectFilter = true;
                                                        }
                                                    }
                                                    if (!existeSelectFilter) {
                                                        arrayTables[y].selectFilters.push(data.crud.boxes[h].fields[u].group[t].fields[k].idFieldTable);
                                                    }
                                                }
                                            }
                                        }
                                        if (existe === false) {
                                            let doc = [];
                                            if (data.crud.boxes[h].fields[u].group[t].fields[k].sourceSelectDoc !== null) {
                                                for (let n = 0; n < data.crud.boxes[h].fields[u].group[t].fields[k].sourceSelectDoc.length; n++) {
                                                    doc.push(data.crud.boxes[h].fields[u].group[t].fields[k].sourceSelectDoc[n]);
                                                }
                                            }
                                            let selectFilters = [];
                                            if (data.crud.boxes[h].fields[u].group[t].fields[k].dataSource.length > 0) {
                                                for (let p1 = 0; p1 < data.crud.boxes.length; p1++) {
                                                    for (let a1 = 0; a1 < data.crud.boxes[p1].fields.length; a1++) {
                                                        for (let bv = 0; bv < data.crud.boxes[h].fields[u].group[t].fields[k].dataSource.length; bv++) {
                                                            if (Number(data.crud.boxes[p1].fields[a1].id) === Number(data.crud.boxes[h].fields[u].group[t].fields[k].dataSource[bv])) {
                                                                selectFilters.push(data.crud.boxes[p1].fields[a1].idFieldTable)
                                                            }
                                                        }

                                                        if (data.crud.boxes[p1].fields[a1].group !== null) {
                                                            for (let b1 = 0; b1 < data.crud.boxes[p1].fields[a1].group.length; b1++) {
                                                                for (let c1 = 0; c1 < data.crud.boxes[h].fields[u].group[b1].fields.length; c1++) {
                                                                    for (let bv = 0; bv < data.crud.boxes[h].fields[u].group[t].fields[k].dataSource.length; bv++) {
                                                                        if (Number(data.crud.boxes[h].fields[u].group[b1].fields[c1].id) === Number(data.crud.boxes[h].fields[u].group[t].fields[k].dataSource[bv])) {
                                                                            selectFilters.push(data.crud.boxes[h].fields[u].group[b1].fields[c1].idFieldTable)
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            arrayTables.push({
                                                table: `${user.data.instance}.${data.crud.boxes[h].fields[u].group[t].fields[k].sourceSelect}`,
                                                doc: [],
                                                selectFilters: selectFilters,
                                                whereFilters: whereFilters
                                            })
                                        }
                                    }
                                }
                            }
                        }

                        if (data.crud.boxes[h].fields[u].idFieldTable === 'entityPropId') {
                            switch (data.id) {
                                case 'owner':
                                    setField(prevState => ({
                                        ...prevState,
                                        [data.crud.boxes[h].fields[u].id]: {
                                            'id': 1,
                                            'label': 'Titular'
                                        }
                                    }), []);
                                    break;
                                case 'jointOwner':
                                    setField(prevState => ({
                                        ...prevState,
                                        [data.crud.boxes[h].fields[u].id]: {
                                            'id': 2,
                                            'label': 'Condómino'
                                        }
                                    }), []);
                                    break;
                                case 'proxy':
                                    setField(prevState => ({
                                        ...prevState,
                                        [data.crud.boxes[h].fields[u].id]: {
                                            'id': 3,
                                            'label': 'Apoderado'
                                        }
                                    }), []);
                                    break;
                                case 'authorized':
                                    setField(prevState => ({
                                        ...prevState,
                                        [data.crud.boxes[h].fields[u].id]: {
                                            'id': 4,
                                            'label': 'Autorizado'
                                        }
                                    }), []);
                                    break;
                                case 'employee':
                                    setField(prevState => ({
                                        ...prevState,
                                        [data.crud.boxes[h].fields[u].id]: {
                                            'id': 5,
                                            'label': 'Empleado'
                                        }
                                    }), []);
                                    break;
                                case 'manager':
                                    setField(prevState => ({
                                        ...prevState,
                                        [data.crud.boxes[h].fields[u].id]: {
                                            'id': 6,
                                            'label': 'Manager'
                                        }
                                    }), []);
                                    break;
                                case 'producer':
                                    setField(prevState => ({
                                        ...prevState,
                                        [data.crud.boxes[h].fields[u].id]: {
                                            'id': 7,
                                            'label': 'Productor'
                                        }
                                    }), []);
                                    break;
                                case 'official':
                                    setField(prevState => ({
                                        ...prevState,
                                        [data.crud.boxes[h].fields[u].id]: {
                                            'id': 8,
                                            'label': 'Oficial de cuenta'
                                        }
                                    }), []);
                                    break;
                                case 'client':
                                    setField(prevState => ({
                                        ...prevState,
                                        [data.crud.boxes[h].fields[u].id]: {
                                            'id': 9,
                                            'label': 'Cliente'
                                        }
                                    }), []);
                                    break;
                                case 'supplier':
                                    setField(prevState => ({
                                        ...prevState,
                                        [data.crud.boxes[h].fields[u].id]: {
                                            'id': 10,
                                            'label': 'Proveedor'
                                        }
                                    }), []);
                                    break;
                                case 'taxAgency':
                                    setField(prevState => ({
                                        ...prevState,
                                        [data.crud.boxes[h].fields[u].id]: {
                                            'id': 11,
                                            'label': 'Agencia Impositiva'
                                        }
                                    }), []);
                                    break;
                                case 'bank':
                                    setField(prevState => ({
                                        ...prevState,
                                        [data.crud.boxes[h].fields[u].id]: {
                                            'id': 12,
                                            'label': 'Banco'
                                        }
                                    }), []);
                                    break;
                                case 'market':
                                    setField(prevState => ({
                                        ...prevState,
                                        [data.crud.boxes[h].fields[u].id]: {
                                            'id': 13,
                                            'label': 'Mercado'
                                        }
                                    }), []);
                                    break;
                                default:
                                    break;
                            }
                        }
                        if (data.crud.store) {
                            for (let p = 0; p < data.crud.store.length; p++) {

                                if (data.crud.store[p].order === 1 && data.crud.store[p].table === 'trx') {
                                    setIsTrxPropId(true);
                                    break;
                                }
                            }

                        }
                    }
                }

                let mainTables = [];
                for (let u = 0; u < data.crud.boxes.length; u++) {
                    for (let v = 0; v < data.crud.boxes[u].fields.length; v++) {
                        if (data.crud.boxes[u].fields[v].group === null) {
                            let existe = false;
                            for (let g = 0; g < mainTables.length; g++) {
                                if (mainTables[g].table === `${user.data.instance}.${data.crud.boxes[u].fields[v].table}`) {
                                    existe = true;
                                }
                            }
                            if (existe === false) {
                                mainTables.push({ table: `${user.data.instance}.${data.crud.boxes[u].fields[v].table}`, fk: data.crud.boxes[u].fields[v].idFieldTable })
                            }
                        }
                    }
                }

                informationService.viewTables().then((response) => {

                    //if (arrayTables.length > 0) {
                    let searchTable = `${user.data.instance}.${data.list.view}`;

                    for (let r = 0; r < response.data.length; r++) {
                        for (let y = 0; y < arrayTables.length; y++) {
                            let tableFlag = arrayTables[y].table.split('.');
                            if (tableFlag[1] === response.data[r].name) {
                                arrayTables[y].table = `wbSys.${tableFlag[1]}`
                            }
                        }
                        if (response.data[r].name === data.list.view) {
                            searchTable = `wbSys.${data.list.view}`
                        }
                        for (let y = 0; y < mainTables.length; y++) {
                            let tableFlag = mainTables[y].table.split('.');
                            if (tableFlag[1] === response.data[r].name) {
                                mainTables[y].table = `wbSys.${tableFlag[1]}`
                            }
                        }
                    }

                    if (mode === 'c' || mode === 'u') {

                        informationService.findSourceField(arrayTables).then((response) => {
                            for (let i = 0; i < response.data.length; i++) {
                                arrayResponse.push(response.data[i]);
                            }

                            setInfo(arrayResponse);
                            initialDoc.initialDocHeader(data, arrayResponse, setField);

                            if (id) {
                                loadRecord(id, arrayResponse, searchTable, mainTables, user);
                            } else {
                                initialDoc.initialDocGroup(data, arrayResponse, setField, setGroup);

                                setLoad(false);
                                setLoadGroup(false);
                            }

                        }).catch((error) => {
                            console.log(error);
                        });
                    }
                    if (mode === 'r' || mode === 'd') {
                        loadRecord(id, [], searchTable, mainTables, user);
                    }

                }).catch((error) => {
                    console.log(error);
                });



            }
        } else {
            navigate('/');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modeFlag, id]);

    useEffect(() => {
        let groupFlag = JSON.parse(JSON.stringify(group));
        let arraySourceFieldGroupFlag = [];
        for (let key in groupFlag) {
            for (let f = 0; f < groupFlag[key].length; f++) {
                for (let a = 0; a < groupFlag[key][f].fields.length; a++) {
                    if (groupFlag[key][f].fields[a].searchSource !== null) {
                        let arraySearchSource = [];
                        let existe = false;
                        for (let q = 0; q < groupFlag[key][f].fields[a].searchSource.length; q++) {

                            for (let o = 0; o < groupFlag[key][f].fields.length; o++) {
                                if (groupFlag[key][f].fields[a].searchSource[q] === groupFlag[key][f].fields[o].id) {
                                    arraySearchSource.push(groupFlag[key][f].fields[o]);
                                    existe = true;
                                }
                            }
                            if (existe === false) {
                                for (let g = 0; g < data.crud.boxes.length; g++) {
                                    for (let q1 = 0; q1 < data.crud.boxes[g].fields.length; q1++) {
                                        if (Number(groupFlag[key][f].fields[a].searchSource[q]) === Number(data.crud.boxes[g].fields[q1].id)) {
                                            arraySearchSource.push(data.crud.boxes[g].fields[q1]);
                                        }
                                    }
                                }
                            }
                        }
                        arraySourceFieldGroupFlag.push({
                            id: groupFlag[key][f].fields[a].id,
                            idFieldTable: groupFlag[key][f].fields[a].idFieldTable,
                            type: groupFlag[key][f].fields[a].type,
                            search: groupFlag[key][f].fields[a].search,
                            searchSource: arraySearchSource,
                            sourceSelect: groupFlag[key][f].fields[a].sourceSelect,
                            orderBox: 1,
                            nameGroup: key,
                            index: f
                        });
                    }
                }
            }
        }
        arrayFieldsSourceGroup = arraySourceFieldGroupFlag;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [group]);


    const loadRecord = (id, arrayResponse, searchTable, mainTables, user) => {

        let whereParam = parseQueryParams();
        let whereFieldsPF = JSON.parse(JSON.stringify(whereParam))
        filterByTradeAccountIdManagerId(whereFieldsPF);
        informationService.redirectRecord(`${searchTable}`, id, whereFieldsPF).then((response) => {
            let ids = [];
            for (let t = 0; t < response.data.length; t++) {
                ids.push(response.data[t].id);
            }
            setRedirectId(ids);
        })
        //BUSCAR REGISTRO
        let entityId;
        let tradeAccountIdsr = null;
        let managerIdsr = null;
        whereFieldsPF.forEach((item) => {
            if (item.idField === 'tradeAccountId') {
                tradeAccountIdsr = item.value
            }
            if (item.idField === 'managerId') {
                managerIdsr = item.value
            }
        })
        informationService.searchRecord(`${searchTable}`, id, tradeAccountIdsr, managerIdsr).then((response) => {

            if (Object.keys(response.data).length !== 0) {

                if (response.data.entityId) {
                    entityId = response.data.entityId;
                }
                let title = '';
                data.crud.docName = orderArray(data.crud.docName);
                for (let u = 0; u < data.crud.docName.length; u++) {
                    if (data.crud.docName[u].display !== 'hidden') {
                        for (let key in response.data) {
                            if (data.crud.docName[u].idFieldTable === key) {
                                let value = response.data[key];
                                title = `${title} ${value}`;
                            }
                        }
                    }
                }
                for (let key in response.data) {
                    for (let u = 0; u < data.crud.boxes.length; u++) {
                        for (let v = 0; v < data.crud.boxes[u].fields.length; v++) {
                            if (data.crud.boxes[u].fields[v].group === null) {
                                if (data.crud.boxes[u].fields[v].idFieldTable === key) {
                                    let clave = data.crud.boxes[u].fields[v].id;
                                    let value = response.data[key];
                                    if (data.crud.boxes[u].fields[v].type === 'Select') {
                                        let newValue = null;
                                        for (let b = 0; b < arrayResponse.length; b++) {
                                            if (arrayResponse[b].source === data.crud.boxes[u].fields[v].sourceSelect && arrayResponse[b].id === value) {
                                                let idFlag = arrayResponse[b].id;
                                                let labelFlag = (arrayResponse[b].nameAlt !== '' && arrayResponse[b].nameAlt !== undefined && arrayResponse[b].nameAlt !== null) ? `${arrayResponse[b].name} ${arrayResponse[b].nameAlt}` : arrayResponse[b].name;
                                                newValue = {
                                                    'id': idFlag,
                                                    'label': labelFlag
                                                }
                                                if (idFlag !== undefined && labelFlag !== undefined)
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [clave]: {
                                                            'id': idFlag,
                                                            'label': labelFlag
                                                        }
                                                    }), []);
                                            }
                                        }
                                        if (arrayResponse.length === 0) {
                                            let idFlag = response.data[key];
                                            let labelFlag = response.data[key.replace('Id', '')];
                                            newValue = {
                                                'id': idFlag,
                                                'label': labelFlag
                                            }
                                            setField(prevState => ({
                                                ...prevState,
                                                [clave]: {
                                                    'id': idFlag,
                                                    'label': labelFlag
                                                }
                                            }), []);
                                        }


                                        searchFieldSource(data.crud.boxes[u].fields[v], newValue);
                                    } else {
                                        if (data.crud.boxes[u].fields[v].type === 'Date' && value !== null) {
                                            value = value.substring(0, 10);
                                        }
                                        if (data.crud.boxes[u].fields[v].type === 'Checkbox' || data.crud.boxes[u].fields[v].type === 'Switch') {

                                            if (value === '1') {
                                                value = true;

                                            } else {
                                                value = false;
                                            }
                                        }
                                        if ((data.crud.boxes[u].fields[v].type === 'Currency' || data.crud.boxes[u].fields[v].type.includes('Number') || data.crud.boxes[u].fields[v].type.includes('Percentage')) && value !== null) {

                                            if (data.crud.boxes[u].fields[v].type.includes('Percentage')) {
                                                let fix = 0;
                                                let flag = data.crud.boxes[u].fields[v].type.split('age');
                                                if (flag.length > 1) {
                                                    fix = (flag[1]);
                                                }
                                                value = (Number(value) * 100).toFixed(fix);
                                                value = value.toString();
                                            }
                                            value = value.replace(/\./g, ',');

                                            if (data.crud.boxes[u].fields[v].type.includes('Number') || data.crud.boxes[u].fields[v].type.includes('Percentage')) {
                                                let step = 0;
                                                let decimalValueFlag;

                                                if (data.crud.boxes[u].fields[v].type.includes('Number'))
                                                    decimalValueFlag = data.crud.boxes[u].fields[v].type.split('ber');
                                                if (data.crud.boxes[u].fields[v].type.includes('Percentage')) {
                                                    decimalValueFlag = data.crud.boxes[u].fields[v].type.split('age');
                                                }
                                                if (decimalValueFlag.length > 1) {
                                                    step = (decimalValueFlag[1]);
                                                    let valueSplit = value.split(',');
                                                    if (valueSplit.length > 1) {
                                                        value = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                    }
                                                }
                                                if (mode === 'r')
                                                    value = formatNumberWithThousandsSeparator(value);
                                            }

                                            if (data.crud.boxes[u].fields[v].type === 'Currency') {
                                                //buscar currencyId
                                                let valueSplit = value.split(',');
                                                let step = 2;
                                                data.crud.boxes.forEach((itemBoxes) => {
                                                    itemBoxes.fields.forEach((itemFields) => {
                                                        if (itemFields.idFieldTable === 'currencyId') {
                                                            let valueResponse = itemFields.value;
                                                            let existe = false;

                                                            for (let g = 0; g < currencys.length; g++) {
                                                                if (Number(currencys[g].id) === Number(valueResponse)) {
                                                                    setFormatCurrency(prevState => ({
                                                                        ...prevState,
                                                                        [id]: currencys[g].symbol,
                                                                    }), []);
                                                                    step = currencys[g].decimals;
                                                                    existe = true;
                                                                }
                                                            }
                                                            if (existe === false) {
                                                                setFormatCurrency(prevState => ({
                                                                    ...prevState,
                                                                    [id]: '',
                                                                }), []);
                                                                step = 2;
                                                            }
                                                        }
                                                    })
                                                })
                                                if (valueSplit.length > 1) {
                                                    value = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                }
                                                if (mode === 'r')
                                                    value = formatNumberWithThousandsSeparator(value);
                                            }
                                        }
                                        if (value !== null) {

                                            setField(prevState => ({
                                                ...prevState,
                                                [clave]: value,
                                            }), []);

                                            searchFieldSource(data.crud.boxes[u].fields[v], value);
                                        }

                                    }
                                }
                            }
                        }
                    }
                }
                for (let k = 0; k < mainTables.length; k++) {

                    informationService.searchRecordGroup(`${mainTables[k].table}`, id, null, `${mainTables[k].fk}`).then((responseSelect) => {

                        for (let h = 0; h < responseSelect.data.length; h++) {

                            let trxLineTypeId = false;
                            if (responseSelect.data[h].trxLineTypeId) {
                                if (responseSelect.data[h].trxLineTypeId !== '1') {
                                    trxLineTypeId = true;
                                }
                            } else {
                                trxLineTypeId = true;
                            }
                            if (trxLineTypeId) {
                                for (let key in responseSelect.data[h]) {
                                    for (let u = 0; u < data.crud.boxes.length; u++) {
                                        for (let v = 0; v < data.crud.boxes[u].fields.length; v++) {
                                            if (data.crud.boxes[u].fields[v].group === null) {
                                                if (data.crud.boxes[u].fields[v].idFieldTable === key && data.crud.boxes[u].fields[v].table === mainTables[k].table.split('.')[1]) {
                                                    let clave = data.crud.boxes[u].fields[v].id;
                                                    let value = responseSelect.data[h][key];
                                                    if (data.crud.boxes[u].fields[v].type === 'Select') {
                                                        for (let ab = 0; ab < arrayResponse.length; ab++) {
                                                            if (arrayResponse[ab].source === data.crud.boxes[u].fields[v].sourceSelect) {
                                                                if (Number(value) === Number(arrayResponse[ab].id)) {
                                                                    let labelFlag = (arrayResponse[ab].nameAlt !== '' && arrayResponse[ab].nameAlt !== undefined && arrayResponse[ab].nameAlt !== null) ? `${arrayResponse[ab].name} ${arrayResponse[ab].nameAlt}` : arrayResponse[ab].name;
                                                                    if (value !== undefined && labelFlag !== undefined) {
                                                                        let idValue = value;
                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [clave]: {
                                                                                'id': idValue,
                                                                                'label': labelFlag
                                                                            }
                                                                        }), []);
                                                                    }

                                                                }
                                                            }
                                                        }
                                                        if (arrayResponse.length === 0) {
                                                            let idFlag = responseSelect.data[h][key];
                                                            let labelFlag = responseSelect.data[h][key.replace('Id', '')];

                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [clave]: {
                                                                    'id': idFlag,
                                                                    'label': labelFlag
                                                                }
                                                            }), []);
                                                        }
                                                    } else {
                                                        if (data.crud.boxes[u].fields[v].type === 'Date') {
                                                            if (value)
                                                                value = value.substring(0, 10);
                                                        }
                                                        if (data.crud.boxes[u].fields[v].type === 'Checkbox' || data.crud.boxes[u].fields[v].type === 'Switch') {

                                                            if (value === '1') {
                                                                value = true;

                                                            } else {
                                                                value = false;
                                                            }
                                                        }
                                                        if (data.crud.boxes[u].fields[v].type === 'Currency' || data.crud.boxes[u].fields[v].type.includes('Number') || data.crud.boxes[u].fields[v].type.includes('Percentage')) {
                                                            if (value) {

                                                                if (data.crud.boxes[u].fields[v].type.includes('Percentage')) {
                                                                    let fix = 0;
                                                                    let flag = data.crud.boxes[u].fields[v].type.split('age');
                                                                    if (flag.length > 1) {
                                                                        fix = (flag[1]);
                                                                    }
                                                                    value = (Number(value) * 100).toFixed(fix);
                                                                    value = value.toString();
                                                                }

                                                                value = value.replace(/\./g, ',');

                                                                if (data.crud.boxes[u].fields[v].type.includes('Number') || data.crud.boxes[u].fields[v].type.includes('Percentage')) {
                                                                    let step = 0;
                                                                    let decimalValueFlag
                                                                    if (data.crud.boxes[u].fields[v].type.includes('Number'))
                                                                        decimalValueFlag = data.crud.boxes[u].fields[v].type.split('ber');
                                                                    if (data.crud.boxes[u].fields[v].type.includes('Percentage'))
                                                                        decimalValueFlag = data.crud.boxes[u].fields[v].type.split('age');
                                                                    if (decimalValueFlag.length > 1) {
                                                                        step = (decimalValueFlag[1]);
                                                                        let valueSplit = value.split(',');
                                                                        if (valueSplit.length > 1) {
                                                                            value = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                                        }
                                                                    }
                                                                    if (mode === 'r')
                                                                        value = formatNumberWithThousandsSeparator(value);
                                                                }

                                                                if (data.crud.boxes[u].fields[v].type === 'Currency') {
                                                                    //buscar currencyId
                                                                    let valueSplit = value.split(',');
                                                                    let step = 2;
                                                                    data.crud.boxes.forEach((itemBoxes) => {
                                                                        itemBoxes.fields.forEach((itemFields) => {
                                                                            if (itemFields.idFieldTable === 'currencyId') {
                                                                                let valueResponse = itemFields.value;
                                                                                let existe = false;

                                                                                for (let g = 0; g < currencys.length; g++) {
                                                                                    if (Number(currencys[g].id) === Number(valueResponse)) {
                                                                                        setFormatCurrency(prevState => ({
                                                                                            ...prevState,
                                                                                            [id]: currencys[g].symbol,
                                                                                        }), []);
                                                                                        step = currencys[g].decimals;
                                                                                        existe = true;
                                                                                    }
                                                                                }
                                                                                if (existe === false) {
                                                                                    setFormatCurrency(prevState => ({
                                                                                        ...prevState,
                                                                                        [id]: '',
                                                                                    }), []);
                                                                                    step = 2;
                                                                                }
                                                                            }
                                                                        })
                                                                    })
                                                                    if (valueSplit.length > 1) {
                                                                        value = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                                    }
                                                                    if (mode === 'r')
                                                                        value = formatNumberWithThousandsSeparator(value);
                                                                }
                                                            }
                                                        }
                                                        if (value !== null)
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [clave]: value,
                                                            }), []);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                        }

                    }).catch((error) => {
                        console.log(error);
                    });

                }

                setTitle(title)
                setLoad(false);

                //BUSCAR GRUPOS DEL REGISTRO
                let tableGroup = [];
                for (let u = 0; u < data.crud.boxes.length; u++) {
                    for (let v = 0; v < data.crud.boxes[u].fields.length; v++) {
                        if (data.crud.boxes[u].fields[v].group !== null) {
                            for (let b = 0; b < data.crud.boxes[u].fields[v].group.length; b++) {

                                let viewGroup = data.crud.boxes[u].fields[v].group[b].view;

                                for (let m = 0; m < data.crud.boxes[u].fields[v].group[b].fields.length; m++) {
                                    if (data.crud.boxes[u].fields[v].group[b].fields[m].table !== null) {
                                        if (tableGroup.length === 0) {
                                            if (data.crud.boxes[u].fields[v].group[b].fields[m].idFieldTable.toUpperCase() !== 'ID')
                                                tableGroup.push({
                                                    table: (mode === 'r' || mode === 'u') ? viewGroup : data.crud.boxes[u].fields[v].group[b].fields[m].table,
                                                    tableSelect: data.crud.boxes[u].fields[v].group[b].fields[m].table,
                                                    group: data.crud.boxes[u].fields[v].group[b].name,
                                                    field: data.crud.boxes[u].fields[v].group[b].fields[m].idFieldTable,
                                                });
                                        } else {
                                            let existe = false;
                                            for (let p = 0; p < tableGroup.length; p++) {

                                                let validateFlag = false;

                                                if (viewGroup === tableGroup[p].table && data.crud.boxes[u].fields[v].group[b].name === tableGroup[p].group)
                                                    validateFlag = true
                                                if (validateFlag) {
                                                    existe = true;
                                                }
                                            }
                                            if (existe === false) {
                                                tableGroup.push({
                                                    table: (mode === 'r' || mode === 'u') ? viewGroup : data.crud.boxes[u].fields[v].group[b].fields[m].table,
                                                    tableSelect: data.crud.boxes[u].fields[v].group[b].fields[m].table,
                                                    group: data.crud.boxes[u].fields[v].group[b].name,
                                                    field: data.crud.boxes[u].fields[v].group[b].fields[m].idFieldTable,
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                informationService.viewTables().then((response) => {
                    for (let g = 0; g < tableGroup.length; g++) {
                        tableGroup[g].table = `${user.data.instance}.${tableGroup[g].table}`;
                        tableGroup[g].tableSelect = `${user.data.instance}.${tableGroup[g].tableSelect}`;
                        for (let r = 0; r < response.data.length; r++) {
                            let tableFlag = tableGroup[g].table.split('.');
                            let tableFlag1 = tableGroup[g].tableSelect.split('.');

                            if (tableFlag[1] === response.data[r].name) {
                                tableGroup[g].table = `wbSys.${tableFlag[1]}`
                            }
                            if (tableFlag1[1] === response.data[r].name) {
                                tableGroup[g].tableSelect = `wbSys.${tableFlag1[1]}`
                            }
                        }
                    }
                    let idRequest = id;
                    if (entityId) {
                        //idRequest = entityId;
                    }


                    for (let i = 0; i < tableGroup.length; i++) {
                        let tableSearch = tableGroup[i].table;
                        let groupSearch = tableGroup[i].group;
                        let fieldSearch = tableGroup[i].field;

                        informationService.searchRecordGroup(`${tableSearch}`, idRequest, `${groupSearch}`, `${fieldSearch}`).then((response) => {

                            let objectsGroups = [];
                            //let designGroup = null;

                            for (let h = 0; h < response.data.length; h++) {
                                for (let u = 0; u < data.crud.boxes.length; u++) {
                                    for (let v = 0; v < data.crud.boxes[u].fields.length; v++) {
                                        if (data.crud.boxes[u].fields[v].group !== null) {
                                            for (let b = 0; b < data.crud.boxes[u].fields[v].group.length; b++) {

                                                let validateFlag = false;
                                                if (mode !== 'r' && groupSearch === response.data[h].group) {
                                                    validateFlag = true;
                                                } else {
                                                    if (mode === 'r') {
                                                        validateFlag = true;
                                                    }
                                                }
                                                validateFlag = true;

                                                if (validateFlag) {
                                                    let validateFlag1 = false;
                                                    if (data.crud.boxes[u].fields[v].group[b].name === response.data[h].nameGroup) {
                                                        validateFlag1 = true;
                                                    }
                                                    if (validateFlag1) {

                                                        let objectGroup = {};
                                                        let arrayFields = [];
                                                        //designGroup = data.crud.boxes[u].fields[v].group[b].design;
                                                        for (let m = 0; m < data.crud.boxes[u].fields[v].group[b].fields.length; m++) {

                                                            let itemFlag = JSON.parse(JSON.stringify(data.crud.boxes[u].fields[v].group[b].fields[m]));
                                                            let tamano = objectsGroups.length;
                                                            let newIdField = m + '_' + data.crud.boxes[u].fields[v].group[b].fields[m].id + '_' + m + tamano;
                                                            itemFlag.id = newIdField;
                                                            itemFlag.isGroup = true;

                                                            //buscar y reemplazar id de los where
                                                            if (itemFlag.where !== null) {
                                                                for (let r = 0; r < itemFlag.where.length; r++) {
                                                                    if (itemFlag.where[r].field.length !== null) {
                                                                        for (let d = 0; d < itemFlag.where[r].field.length; d++) {
                                                                            let idField = itemFlag.where[r].field[d].idField;
                                                                            let existeIdGroup = false;

                                                                            for (let ñ = 0; ñ < data.crud.boxes[u].fields[v].group[b].fields.length; ñ++) {
                                                                                if (data.crud.boxes[u].fields[v].group[b].fields[ñ].id === idField) {
                                                                                    let tamano1 = objectsGroups.length;
                                                                                    let newIdField1 = ñ + '_' + data.crud.boxes[u].fields[v].group[b].fields[ñ].id + '_' + ñ + tamano1;
                                                                                    itemFlag.where[r].field[d].idField = newIdField1;
                                                                                    existeIdGroup = true;
                                                                                }
                                                                            }

                                                                            if (existeIdGroup === false) {
                                                                                let newIdField1 = idField;
                                                                                itemFlag.where[r].field[d].idField = newIdField1;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            //buscar y reemplazar id de los search source
                                                            if (itemFlag.searchSource !== null) {
                                                                for (let r = 0; r < itemFlag.searchSource.length; r++) {
                                                                    let idField = itemFlag.searchSource[r];
                                                                    let existeIdGroup = false;
                                                                    for (let ñ = 0; ñ < data.crud.boxes[u].fields[v].group[b].fields.length; ñ++) {
                                                                        if (data.crud.boxes[u].fields[v].group[b].fields[ñ].id === idField) {
                                                                            let tamano1 = objectsGroups.length;
                                                                            let newIdField1 = ñ + '_' + data.crud.boxes[u].fields[v].group[b].fields[ñ].id + '_' + ñ + tamano1;
                                                                            itemFlag.searchSource[r] = newIdField1;
                                                                            existeIdGroup = true;
                                                                        }
                                                                    }

                                                                    if (existeIdGroup === false) {
                                                                        let newIdField1 = idField;
                                                                        itemFlag.searchSource[r] = newIdField1;
                                                                    }
                                                                }
                                                            }

                                                            arrayFields.push(itemFlag);
                                                            let existeMap = false;

                                                            for (let key in response.data[h]) {
                                                                if (response.data[h][key] !== null) {
                                                                    if (itemFlag.idFieldTable === key) {
                                                                        existeMap = true;
                                                                        let value = response.data[h][key];

                                                                        let idField = itemFlag.id;
                                                                        if ((itemFlag.type === 'Checkbox' || itemFlag.type === 'Switch') && value === '0') {
                                                                            value = false
                                                                        }
                                                                        if ((itemFlag.type === 'Checkbox' || itemFlag.type === 'Switch') && value === '1') {
                                                                            value = true
                                                                        }
                                                                        if (itemFlag.type === 'Currency' || itemFlag.type.includes('Number') || itemFlag.type.includes('Percentage')) {

                                                                            if (itemFlag.type.includes('Percentage')) {
                                                                                let fix = 0;
                                                                                let flag = itemFlag.type.split('age');
                                                                                if (flag.length > 1) {
                                                                                    fix = (flag[1]);
                                                                                }
                                                                                value = (Number(value) * 100).toFixed(fix);
                                                                                value = value.toString();
                                                                            }

                                                                            value = value.replace(/\./g, ',');
                                                                            if (itemFlag.type.includes('Number') || itemFlag.type.includes('Percentage')) {
                                                                                let step = 0;
                                                                                let decimalValueFlag;
                                                                                if (itemFlag.type.includes('Number'))
                                                                                    decimalValueFlag = itemFlag.type.split('ber');
                                                                                if (itemFlag.type.includes('Percentage'))
                                                                                    decimalValueFlag = itemFlag.type.split('age');
                                                                                if (decimalValueFlag.length > 1) {
                                                                                    step = (decimalValueFlag[1]);
                                                                                    let valueSplit = value.split(',');
                                                                                    if (valueSplit.length > 1) {
                                                                                        value = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                                                    }
                                                                                }
                                                                                if (mode === 'r')
                                                                                    value = formatNumberWithThousandsSeparator(value);
                                                                            }
                                                                            if (itemFlag.type === 'Currency') {
                                                                                //buscar currencyId
                                                                                let valueSplit = value.split(',');
                                                                                let step = 2;
                                                                                data.crud.boxes.forEach((itemBoxes) => {
                                                                                    itemBoxes.fields.forEach((itemFields) => {
                                                                                        if (itemFields.idFieldTable === 'currencyId') {
                                                                                            let valueResponse = itemFields.value;
                                                                                            let existe = false;

                                                                                            for (let g = 0; g < currencys.length; g++) {
                                                                                                if (Number(currencys[g].id) === Number(valueResponse)) {
                                                                                                    setFormatCurrency(prevState => ({
                                                                                                        ...prevState,
                                                                                                        [id]: currencys[g].symbol,
                                                                                                    }), []);
                                                                                                    step = currencys[g].decimals;
                                                                                                    existe = true;
                                                                                                }
                                                                                            }
                                                                                            if (existe === false) {
                                                                                                setFormatCurrency(prevState => ({
                                                                                                    ...prevState,
                                                                                                    [id]: '',
                                                                                                }), []);
                                                                                                step = 2;
                                                                                            }
                                                                                        }
                                                                                    })
                                                                                })
                                                                                if (valueSplit.length > 1) {
                                                                                    value = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                                                }
                                                                                if (mode === 'r')
                                                                                    value = formatNumberWithThousandsSeparator(value);
                                                                            }
                                                                        }

                                                                        if (itemFlag.type === 'Select') {
                                                                            for (let ab = 0; ab < arrayResponse.length; ab++) {
                                                                                if (arrayResponse[ab].source === itemFlag.sourceSelect) {
                                                                                    if (Number(value) === Number(arrayResponse[ab].id)) {
                                                                                        let labelFlag = (arrayResponse[ab].nameAlt !== '' && arrayResponse[ab].nameAlt !== undefined && arrayResponse[ab].nameAlt !== null) ? `${arrayResponse[ab].name} ${arrayResponse[ab].nameAlt}` : arrayResponse[ab].name;
                                                                                        if (value !== undefined && labelFlag !== undefined)
                                                                                            value = {
                                                                                                'id': value,
                                                                                                'label': labelFlag
                                                                                            }

                                                                                    }
                                                                                }
                                                                            }
                                                                            if (arrayResponse.length === 0) {
                                                                                let idFlag = response.data[h][key];
                                                                                let labelFlag = response.data[h][key.replace('Id', '')];
                                                                                value = {
                                                                                    'id': idFlag,
                                                                                    'label': labelFlag
                                                                                }
                                                                            }
                                                                        }

                                                                        if (itemFlag.type === 'Currency' || itemFlag.type === 'Number') {
                                                                            value = value.replace(/\./g, ',');
                                                                            if (mode === 'r') {
                                                                                value = formatNumberWithThousandsSeparator(value);
                                                                            }
                                                                        }

                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [idField]: value
                                                                        }));
                                                                        itemFlag.valueTemporal = value;

                                                                        if (itemFlag.searchSource !== null && (value === null || value === undefined)) {
                                                                            setValueSearchSource(itemFlag, idField, arrayFields, arrayResponse);
                                                                        }
                                                                    }
                                                                }
                                                            }

                                                            if (existeMap === false) {

                                                                let idField = itemFlag.id;

                                                                if (itemFlag.type === 'Select') {
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: null
                                                                    }), []);

                                                                } else {
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: ''
                                                                    }), []);
                                                                }
                                                                itemFlag.valueTemporal = null;

                                                                if (itemFlag.searchSource !== null) {
                                                                    setValueSearchSource(itemFlag, idField, arrayFields, arrayResponse);
                                                                }
                                                            }
                                                        }
                                                        objectGroup.fields = arrayFields;
                                                        objectGroup.doc = response.data[h].doc
                                                        objectsGroups.push(objectGroup);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }


                            setLoadGroup(false)
                            //AGREGAR ULTIMO    
                            /*if (security({
                                linkto: pathParameter,
                                mode: 'c'
                            })) {
                                if (mode === 'u' && designGroup !== 'fieldsNoAdd' && designGroup !== 'tableNoAdd') {
                                    let objectGroupUltimo = {};
                                    let arrayFieldsUltimo = [];
                                    data.crud.boxes.forEach((itemBoxs) => {
                                        itemBoxs.fields.forEach((itemFields, index) => {
                                            if (itemFields.group !== null) {
                                                itemFields.group.forEach((itemGroup) => {
                                                    if (itemGroup.name === groupSearch) {
                                                        itemGroup.fields.forEach((item, indexField) => {
                                                            let itemFlag = JSON.parse(JSON.stringify(item));
                                                            let newIdField = index + '_' + item.id + '_' + index + "_auto";
                                                            itemFlag.id = newIdField;
                                                            itemFlag.isGroup = true;
 
                                                            //buscar y reemplazar id de los where
                                                            if (itemFlag.where !== null) {
                                                                for (let r = 0; r < itemFlag.where.length; r++) {
                                                                    if (itemFlag.where[r].field.length !== null) {
                                                                        for (let d = 0; d < itemFlag.where[r].field.length; d++) {
                                                                            let idField = itemFlag.where[r].field[d].idField;
                                                                            let existeIdGroup = false;
                                                                            itemGroup.fields.forEach((itemFlagFieldsGroup) => {
                                                                                if (itemFlagFieldsGroup.id === idField) {
                                                                                    let newIdField1 = index + '_' + itemFlagFieldsGroup.id + '_' + index + "_auto";
                                                                                    itemFlag.where[r].field[d].idField = newIdField1;
                                                                                    existeIdGroup = true;
                                                                                }
                                                                            })
                                                                            if (existeIdGroup === false) {
                                                                                let newIdField1 = idField;
                                                                                itemFlag.where[r].field[d].idField = newIdField1;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            //buscar y reemplazar id de los search source
                                                            if (itemFlag.searchSource !== null) {
                                                                for (let r = 0; r < itemFlag.searchSource.length; r++) {
                                                                    let idField = itemFlag.searchSource[r];
                                                                    let existeIdGroup = false;
                                                                    itemGroup.fields.forEach((itemFlagFieldsGroup) => {
                                                                        if (itemFlagFieldsGroup.id === idField) {
                                                                            let newIdField1 = index + '_' + itemFlagFieldsGroup.id + '_' + index + "_auto";
                                                                            itemFlag.searchSource[r] = newIdField1;
                                                                            existeIdGroup = true;
                                                                        }
                                                                    })
 
                                                                    if (existeIdGroup === false) {
                                                                        let newIdField1 = idField;
                                                                        itemFlag.searchSource[r] = newIdField1;
                                                                    }
                                                                }
                                                            }
                                                            arrayFieldsUltimo.push(itemFlag);
 
                                                            if (indexField === 0) {
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: id
                                                                }));
                                                            } else {
                                                                switch (item.type) {
                                                                    case 'Select':
                                                                        if (item.defaultValue) {
                                                                            info.forEach((itemInfo) => {
                                                                                if (itemInfo.source === item.sourceSelect) {
                                                                                    if (Number(item.defaultValue) === Number(itemInfo.id))
                                                                                        setField(prevState => ({
                                                                                            ...prevState,
                                                                                            [newIdField]: {
                                                                                                id: itemInfo.id,
                                                                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                                            }
                                                                                        }), []);
                                                                                }
                                                                            })
                                                                        } else {
                                                                            setField(prevState => ({
                                                                                ...prevState,
                                                                                [newIdField]: null
                                                                            }));
                                                                        }
                                                                        break;
                                                                    case 'MultipleSelect':
                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [newIdField]: null
                                                                        }));
                                                                        break;
                                                                    case 'List':
                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [newIdField]: null
                                                                        }));
                                                                        break;
                                                                    case 'Checkbox':
                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [newIdField]: false
                                                                        }));
                                                                        break;
                                                                    case 'Switch':
                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [newIdField]: false
                                                                        }));
                                                                        break;
                                                                    case 'Number':
                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [newIdField]: item.defaultValue ? item.defaultValue : ''
                                                                        }));
                                                                        break;
                                                                    case 'Currency':
                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [newIdField]: item.defaultValue ? item.defaultValue : ''
                                                                        }));
                                                                        break;
                                                                    case 'Date':
                                                                        if (item.defaultValue === 'CURDATE()') {
                                                                            setField(prevState => ({
                                                                                ...prevState,
                                                                                [newIdField]: new Date().toISOString().split('T')[0]
                                                                            }), []);
                                                                        } else {
                                                                            setField(prevState => ({
                                                                                ...prevState,
                                                                                [newIdField]: ''
                                                                            }));
                                                                        }
                                                                        break;
                                                                    default:
                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [newIdField]: item.defaultValue ? item.defaultValue : ''
                                                                        }));
                                                                        break;
                                                                }
                                                            }
 
                                                        })
                                                    }
                                                })
                                            }
                                        })
                                    })
                                    objectGroupUltimo.fields = arrayFieldsUltimo;
                                    objectsGroups.push(objectGroupUltimo);
                                }
                            }*/

                            if (objectsGroups.length > 0) {

                                setGroup(prevState => ({
                                    ...prevState,
                                    [groupSearch]: objectsGroups
                                }));


                            } else {
                                for (let u = 0; u < data.crud.boxes.length; u++) {
                                    for (let v = 0; v < data.crud.boxes[u].fields.length; v++) {
                                        if (data.crud.boxes[u].fields[v].group !== null) {
                                            for (let b = 0; b < data.crud.boxes[u].fields[v].group.length; b++) {
                                                if (groupSearch === data.crud.boxes[u].fields[v].group[b].name) {
                                                    let objectGroup = {};
                                                    let arrayFields = [];
                                                    for (let m = 0; m < data.crud.boxes[u].fields[v].group[b].fields.length; m++) {

                                                        let itemFlag = JSON.parse(JSON.stringify(data.crud.boxes[u].fields[v].group[b].fields[m]));
                                                        let tamano = objectsGroups.length;
                                                        let newIdField = m + '_' + data.crud.boxes[u].fields[v].group[b].fields[m].id + '_' + m + tamano;
                                                        itemFlag.id = newIdField;
                                                        itemFlag.isGroup = true;

                                                        //buscar y reemplazar id de los where
                                                        if (itemFlag.where !== null) {
                                                            for (let r = 0; r < itemFlag.where.length; r++) {
                                                                if (itemFlag.where[r].field.length !== null) {
                                                                    for (let d = 0; d < itemFlag.where[r].field.length; d++) {
                                                                        let idField = itemFlag.where[r].field[d].idField;
                                                                        let existeIdGroup = false;

                                                                        for (let ñ = 0; ñ < data.crud.boxes[u].fields[v].group[b].fields.length; ñ++) {
                                                                            if (data.crud.boxes[u].fields[v].group[b].fields[ñ].id === idField) {
                                                                                let tamano1 = objectsGroups.length;
                                                                                let newIdField1 = ñ + '_' + data.crud.boxes[u].fields[v].group[b].fields[ñ].id + '_' + ñ + tamano1;
                                                                                itemFlag.where[r].field[d].idField = newIdField1;
                                                                                existeIdGroup = true;
                                                                            }
                                                                        }

                                                                        if (existeIdGroup === false) {
                                                                            let newIdField1 = idField;
                                                                            itemFlag.where[r].field[d].idField = newIdField1;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        //buscar y reemplazar id de los search source
                                                        if (itemFlag.searchSource !== null) {
                                                            for (let r = 0; r < itemFlag.searchSource.length; r++) {
                                                                let idField = itemFlag.searchSource[r];
                                                                let existeIdGroup = false;
                                                                for (let ñ = 0; ñ < data.crud.boxes[u].fields[v].group[b].fields.length; ñ++) {
                                                                    if (data.crud.boxes[u].fields[v].group[b].fields[ñ].id === idField) {
                                                                        let tamano1 = objectsGroups.length;
                                                                        let newIdField1 = ñ + '_' + data.crud.boxes[u].fields[v].group[b].fields[ñ].id + '_' + ñ + tamano1;
                                                                        itemFlag.searchSource[r] = newIdField1;
                                                                        existeIdGroup = true;
                                                                    }
                                                                }

                                                                if (existeIdGroup === false) {
                                                                    let newIdField1 = idField;
                                                                    itemFlag.searchSource[r] = newIdField1;
                                                                }
                                                            }
                                                        }
                                                        arrayFields.push(itemFlag);
                                                        switch (itemFlag.type) {
                                                            case 'Select':
                                                                if (itemFlag.defaultValue) {
                                                                    info.forEach((itemInfo) => {
                                                                        if (itemInfo.source === itemFlag.sourceSelect) {
                                                                            if (Number(itemFlag.defaultValue) === Number(itemInfo.id))
                                                                                setField(prevState => ({
                                                                                    ...prevState,
                                                                                    [newIdField]: {
                                                                                        id: itemInfo.id,
                                                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                                    }
                                                                                }), []);
                                                                        }
                                                                    })
                                                                } else {
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [newIdField]: null
                                                                    }));
                                                                }
                                                                break;
                                                            case 'MultipleSelect':
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: null
                                                                }));
                                                                break;
                                                            case 'List':
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: null
                                                                }));
                                                                break;
                                                            case 'Checkbox':
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: false
                                                                }));
                                                                break;
                                                            case 'Switch':
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: false
                                                                }));
                                                                break;
                                                            case 'Number':
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                                                }));
                                                                break;
                                                            case 'Currency':
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                                                }));
                                                                break;
                                                            case 'Date':
                                                                if (itemFlag.defaultValue === 'CURDATE()') {
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [newIdField]: new Date().toISOString().split('T')[0]
                                                                    }), []);
                                                                } else {
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [newIdField]: ''
                                                                    }));
                                                                }
                                                                break;
                                                            default:
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: itemFlag.defaultValue ? itemFlag.defaultValue : ''
                                                                }));
                                                                break;
                                                        }


                                                    }
                                                    objectGroup.fields = arrayFields;
                                                    objectsGroups.push(objectGroup);
                                                }
                                            }
                                        }
                                    }
                                }

                                setGroup(prevState => ({
                                    ...prevState,
                                    [groupSearch]: objectsGroups
                                }));

                            }
                        }).catch((error) => {
                            console.log(error);
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                });

                setRecordLoad(true);
            } else {
                navigate(`/${data.crud.route}?m=l`)
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    const updateList = () => {
        setLoadList(true);
        setSelectedIds([]);
        let whereFieldParam = whereFields;

        let fieldsArray = [];
        for (let p = 0; p < data.list.fields.length; p++) {
            if (data.list.fields[p].idFieldTable !== null) {
                fieldsArray.push(data.list.fields[p].idFieldTable);
            }
        }
        let fields = fieldsArray.join(",");
        setRecordCountLoad(true);
        setTotalFooterLoad(true);
        setTotalSaldoAnteriorLoad(true)

        let whereFieldsPF = JSON.parse(JSON.stringify(whereFieldParam))
        filterByTradeAccountIdManagerId(whereFieldsPF);

        informationService.searchViewList(`${instance}.${data.list.view}`, data.id, fields, 0, Number(listSegmentSize), whereFieldsPF).then((response) => {

            let arrayResponse = [];
            for (let i = 0; i < info.length; i++) {
                if (info[i].source !== data.list.view) {
                    arrayResponse.push(info[i])
                }
            }
            let arrayInitialList = [];
            for (let i = 0; i < response.data.length; i++) {
                arrayResponse.push(response.data[i]);
                arrayInitialList.push(response.data[i]);
            }
            //setInfo(arrayResponse);
            setList(arrayInitialList);
            //setLoad(false);
            setLoadList(false);

            informationService.searchViewListRecordCount(`${instance}.${data.list.view}`, whereFieldsPF).then((response) => {
                setRecordCountLoad(false);
                setRecordCount(response.data.count)

                informationService.searchViewListTotal(`${instance}.${data.list.view}`, fields, whereFieldsPF).then((response) => {
                    setTotalFooter(response.data);
                    setTotalFooterLoad(false);
                }).catch((error) => {
                    console.log(error);
                });

                let validateTotalHeader = false;
                let whereFieldParamFlag = JSON.parse(JSON.stringify(whereFieldsPF))
                let valueDate = null;
                let idFieldDate = null;

                for (let d = 0; d < whereFieldParamFlag.length; d++) {
                    if (whereFieldParamFlag[d].type === 'Date' && whereFieldParamFlag[d].operator === ">=") {
                        validateTotalHeader = true;
                        valueDate = whereFieldParamFlag[d].value;
                        idFieldDate = whereFieldParamFlag[d].idField;
                    }
                }
                if (validateTotalHeader && valueDate && idFieldDate) {

                    whereFieldParamFlag = whereFieldParamFlag.filter(obj => obj.type !== 'Date');

                    whereFieldParamFlag.push({
                        idField: idFieldDate,
                        operator: '<',
                        value: valueDate
                    })

                    informationService.searchViewListTotal(`${instance}.${data.list.view}`, fields, whereFieldParamFlag).then((response) => {
                        setTotalHeader(response.data)
                        setTotalSaldoAnteriorLoad(false)
                    }).catch((error) => {
                        console.log(error);
                    });
                } else {
                    setTotalHeader(null);
                    setTotalSaldoAnteriorLoad(false)
                }
            }).catch((error) => {
                console.log(error);
            });

        }).catch((error) => {
            console.log(error);
            //setLoad(false);
            setLoadList(false);
        });
    }


    const auditChange = (fieldId, newValue, oldValue, nameField, item, doc, idParameter) => {

        if (oldValue !== newValue && item.type !== 'Password') {
            let existe = false;
            for (var i = 0; i < audit.length; i++) {
                if (audit[i].fieldId === fieldId) {
                    existe = true;
                    audit[i].newValue = newValue;
                }
            }
            if (existe === false) {
                const user = AuthService.getCurrentUser();
                if (doc === null)
                    doc = data.id
                if (idParameter === null)
                    idParameter = id

                let objectAudit = {
                    context: 'UI',
                    doc: doc,
                    fieldId,
                    field: nameField,
                    id: idParameter,
                    mode,
                    newValue,
                    oldValue,
                    user: user.email
                }
                //setAudit([...audit, objectAudit]);
                setAudit(prevAudit => [...prevAudit, objectAudit]);
            }
        }
    }

    const handleClickOpen = (linkto) => {
        setOpen(true);
        setPath(linkto);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const orderArray = array => {
        let temporal = 0;
        for (let i = 0; i < array.length; i++) {
            for (let j = 1; j < (array.length - i); j++) {
                if (array[j - 1].order > array[j].order) {
                    temporal = array[j - 1];
                    array[j - 1] = array[j];
                    array[j] = temporal;
                }
            }
        }
        return array;
    }

    const back = (linkto, mode) => {
        setLoad(true);
        setField(initialField(data));
        setTitle('');
        setGroup(initialArrayGroup(data.crud));
        const whereParameters = getFilteredParams();
        if (mode === 'l')
            navigate(`/${linkto}?m=${mode}${whereParameters}`);
        else
            navigate(`/${linkto}?id=${id}&m=${mode}${whereParameters}`);
        setModeFlag(mode);
    }

    const goToRecordList = (linkto, direction) => {

        const ids = redirectId;

        let goToId = null;
        for (let g = 0; g < ids.length; g++) {
            if (direction === 'next' && Number(id) < ids[g]) {
                goToId = ids[g];
            } else {
                if (direction === 'prev' && Number(id) > ids[g]) {
                    goToId = ids[g];
                }
            }
        }

        if (goToId !== null) {
            setLoad(true);
            setField(initialField(data));
            setTitle('');
            setGroup(initialArrayGroup(data.crud));
            const whereParameters = getFilteredParams();
            navigate(`/${linkto}?id=${goToId}&m=r${whereParameters}`);
            setModeFlag(mode);
        }
    }


    //fci
    const fciAlta = async () => {
        setLoadIntegration(true);
        const user = AuthService.getCurrentUser();
        setErroresIntegracion('');
        if (user) {
            let arraySave = await fundsIntegration.fciAlta(data, field, group, constants.CLIENT, user.data.instance, id);
            if (arraySave.errores) {
                let errores = '';
                for (const err of arraySave.errores) {
                    errores = errores + err.descripcion + '\n';
                }
                setErroresIntegracion(errores);
                setLoadIntegration(false);

            } else {
                let auditLocal = fundsIntegration.generateAuditIntegration(arraySave, data, group, field, id, user);
                informationService.update(data.crud.route, constants.CLIENT, user.data.instance, 'saveRecord', user.email, arraySave, data.list.view).then((response) => {

                    const responseService = response.data;
                    if (responseService.errores) {
                        let errores = '';
                        for (const err of responseService.errores) {
                            errores = errores + err.codigoError + "=" + err.descripcionError + '\n';
                        }
                        setErroresIntegracion(errores);
                        setLoad(false);
                    } else {
                        auditService.save(user.client, user.data.instance, auditLocal).then(() => {
                            setLoadIntegration(false);
                            window.location.reload();
                        }).catch((error) => {
                            setMessage({ error: true, message: error })
                            setLoad(false);
                        });
                    }
                }).catch((error) => {
                    setMessage({ error: true, message: error })
                    setLoad(false);
                });
            }
        }
    }

    const fciIngresar = async () => {
        setErroresIntegracion('');
        setLoadIntegration(true);
        const user = AuthService.getCurrentUser();
        if (user) {
            let response = await fundsIntegration.fciIngresar(data, field, group, constants.CLIENT, user.data.instance, id);
            if (response === "ok") {
                fciConsulta(null);
            } else {
                if (response.errores) {
                    let errores = '';
                    for (const err of response.errores) {
                        errores = errores + err.descripcion + '\n';
                    }
                    setErroresIntegracion(errores);
                    setLoadIntegration(false);
                    fciConsulta(null);
                }
            }
        }
    }

    const fciEliminar = async () => {
        setErroresIntegracion('');
        setLoadIntegration(true);
        const user = AuthService.getCurrentUser();
        if (user) {
            let response = await fundsIntegration.fciEliminar(data, field, group, constants.CLIENT, user.data.instance, id);
            if (response === null) {
                deleteRecord('funds', 'd');
            } else {
                if (response === "ok") {
                    deleteRecord('funds', 'd');
                } else {
                    if (response.errores) {
                        let errores = '';
                        for (const err of response.errores) {
                            errores = errores + err.descripcion + '\n';
                        }
                        setErroresIntegracion(errores);
                        setLoadIntegration(false);
                        fciConsulta(null);
                    }
                }
            }
        }
    }

    const fciAnular = async () => {
        setErroresIntegracion('');
        setLoadIntegration(true);
        const user = AuthService.getCurrentUser();
        if (user) {
            let response = await fundsIntegration.fciAnular(data, field, group, constants.CLIENT, user.data.instance, id);
            if (response === "ok") {
                fciConsulta("1");
            } else {
                if (response.errores) {
                    let errores = '';
                    for (const err of response.errores) {
                        errores = errores + err.descripcion + '\n';
                    }
                    setErroresIntegracion(errores);
                    setLoadIntegration(false);
                    fciConsulta(null);
                }
            }
        }
    }

    const fciConsulta = async (isInactive) => {
        const user = AuthService.getCurrentUser();
        if (user) {
            let arrayUpdate = await fundsIntegration.fciConsulta(data, field, group, constants.CLIENT, user.data.instance, id, isInactive);

            if (arrayUpdate) {
                if (arrayUpdate.errores) {
                    let errores = '';
                    for (const err of arrayUpdate.errores) {
                        errores = errores + err.descripcion + '\n';
                    }
                    setErroresIntegracion(errores);
                    setLoad(false);
                } else {
                    if (arrayUpdate !== null) {
                        let auditLocal = fundsIntegration.generateAuditIntegration(arrayUpdate, data, group, field, id, user);

                        if (isInactive === '1') {
                            for (let u = 0; u < arrayUpdate.length; u++) {
                                arrayUpdate[u].fields.push({
                                    id: 'isInactive',
                                    value: isInactive
                                })
                            }
                        }
                        let arrayFlag = [];
                        for (const arrayUp of arrayUpdate) {
                            if (arrayUp.fields.length > 1) {
                                arrayFlag.push(arrayUp);
                            }
                        }
                        if (arrayFlag.length > 0) {
                            informationService.update(data.crud.route, constants.CLIENT, user.data.instance, 'saveRecord', user.email, arrayFlag, data.list.view).then((response) => {
                                const responseService = response.data;
                                if (responseService.errores) {
                                    let errores = '';
                                    for (const err of responseService.errores) {
                                        errores = errores + err.codigoError + "=" + err.descripcionError + '\n';
                                    }
                                    setErroresIntegracion(errores);
                                    setLoad(false);
                                } else {
                                    auditService.save(user.client, user.data.instance, auditLocal).then(() => {
                                        setLoadIntegration(false);
                                        window.location.reload();
                                    }).catch((error) => {
                                        setMessage({ error: true, message: error })
                                        setLoad(false);
                                    });
                                }
                            }).catch((error) => {
                                setMessage({ error: true, message: error })
                                setLoad(false);
                            });
                        }
                    }
                }
            }
        }
    }

    //Return trxLine
    const trxLineGroup = (group, trxLineTypeId) => {
        let groups = [];
        for (let key in group) {
            for (let r = 0; r < group[key].length; r++) {
                let lineType;
                for (let d = 0; d < group[key][r].fields.length; d++) {
                    if (group[key][r].fields[d].idFieldTable === 'trxLineTypeId') {
                        if (field[group[key][r].fields[d].id]) {
                            lineType = field[group[key][r].fields[d].id].id
                            if (!lineType) {
                                lineType = group[key][r].fields[d].defaultValue;
                            }
                        } else {
                            lineType = group[key][r].fields[d].defaultValue;
                        }
                    }
                }
                if (Number(lineType) === Number(trxLineTypeId)) {
                    groups.push(group[key]);
                }
            }
        }
        return groups;
    }

    //valo
    const inmmediates = async (groupFlag, trxId) => {

        try {

            setLoadIntegration(true);
            const user = AuthService.getCurrentUser();
            setErroresIntegracion('');
            if (user) {

                let request = [];

                let grupoLine5 = trxLineGroup(groupFlag, 5);

                for (let key in grupoLine5) {
                    for (let r = 0; r < grupoLine5[key].length; r++) {
                        let validate = null;
                        let validateLine = r;
                        let sign;
                        for (let d = 0; d < grupoLine5[key][r].fields.length; d++) {
                            if (grupoLine5[key][r].fields[d].idFieldTable === 'function') {
                                validate = field[grupoLine5[key][r].fields[d].id]
                            }
                            if (grupoLine5[key][r].fields[d].idFieldTable === 'sign') {
                                sign = field[grupoLine5[key][r].fields[d].id]
                            }
                        }

                        if (validate !== null && validate !== undefined && sign === "-1") {
                            let entityBankAccountId;
                            let argValoConceptId;
                            let amount;
                            let memo;
                            for (let d = 0; d < grupoLine5[key][r].fields.length; d++) {
                                if (grupoLine5[key][r].fields[d].idFieldTable === 'entityBankAccountId') {
                                    entityBankAccountId = Number(field[grupoLine5[key][r].fields[d].id].id);
                                }
                                if (grupoLine5[key][r].fields[d].idFieldTable === 'argValoConceptId') {
                                    argValoConceptId = Number(field[grupoLine5[key][r].fields[d].id].id);
                                }
                                if (grupoLine5[key][r].fields[d].idFieldTable === 'amount') {
                                    amount = field[grupoLine5[key][r].fields[d].id];
                                    amount = amount.toString().replace(/\./g, '');
                                    amount = amount.toString().replace(/,/g, '.');
                                    amount = Number(amount).toFixed(2);
                                }
                                if (grupoLine5[key][r].fields[d].idFieldTable === 'memo') {
                                    memo = field[grupoLine5[key][r].fields[d].id];
                                }
                            }
                            let origin = {
                                entityBankAccountId,
                                argValoConceptId,
                                amount,
                                memo
                            }

                            let alias;
                            let cbu;

                            let grupoLine1 = trxLineGroup(groupFlag, 1);
                            for (let key in grupoLine1) {
                                for (let d = 0; d < grupoLine1[key][validateLine].fields.length; d++) {
                                    if (grupoLine1[key][validateLine].fields[d].idFieldTable === 'key') {
                                        cbu = field[grupoLine1[key][validateLine].fields[d].id];
                                    }
                                    if (grupoLine1[key][validateLine].fields[d].idFieldTable === 'alias') {
                                        alias = field[grupoLine1[key][validateLine].fields[d].id];
                                    }
                                    if (grupoLine1[key][validateLine].fields[d].idFieldTable === 'entityBankAccountId') {
                                        entityBankAccountId = Number(field[grupoLine1[key][validateLine].fields[d].id].id);
                                    }
                                }
                            }
                            let destination = {
                                alias,
                                cbu,
                                entityBankAccountId
                            }

                            request.push({
                                origin,
                                destination,
                                trxId
                            })
                        }
                    }
                }
                if (request.length > 0) {
                    await valoIntegration.immediates(constants.CLIENT, user.data.instance, request);
                    setLoad(false);
                } else {
                    setLoad(false);
                }

            }
        } catch (error) {
            console.log('error' + error)
            setLoad(false);
        }
    }


    const saveRecord = async (linkto, mode) => {

        setErroresIntegracion('');
        setLoad(true);
        let validation = true;
        let groupFlag = JSON.parse(JSON.stringify(group));
        const user = AuthService.getCurrentUser();
        for (let key in groupFlag) {

            let fieldsNoAdd = false;
            data.crud.boxes.forEach((itemBoxes) => {
                itemBoxes.fields.forEach((itemFields) => {
                    if (itemFields.group !== null) {
                        itemFields.group.forEach((itemGroup) => {
                            if (itemGroup.name === key && itemGroup.design === 'fieldsNoAdd')
                                fieldsNoAdd = true;
                        })
                    }
                })
            })


            let arrayFlag = [];
            for (let f = 0; f < groupFlag[key].length; f++) {
                if (fieldsNoAdd === true && f !== groupFlag[key].length) {
                    let addElementGroup = false;
                    for (let d = 0; d < groupFlag[key][f].fields.length; d++) {
                        if (groupFlag[key][f].fields[d].display !== 'hidden') {
                            let view = true;
                            if (groupFlag[key][f].fields[d].where !== null && groupFlag[key][f].fields[d].where !== undefined) {
                                view = whereFunction(groupFlag[key][f].fields[d]);
                            }
                            if (view === true) {
                                if (field[groupFlag[key][f].fields[d].id])
                                    addElementGroup = true;
                            }
                        }
                    }
                    if (addElementGroup)
                        arrayFlag.push(groupFlag[key][f]);
                }
                else {
                    if (f !== groupFlag[key].length) {
                        let addElementGroup = false;
                        for (let d = 0; d < groupFlag[key][f].fields.length; d++) {
                            if (groupFlag[key][f].fields[d].display !== 'hidden') {
                                let view = true;
                                if (groupFlag[key][f].fields[d].where !== null && groupFlag[key][f].fields[d].where !== undefined) {
                                    view = whereFunction(groupFlag[key][f].fields[d]);
                                }
                                if (view === true) {
                                    if (field[groupFlag[key][f].fields[d].id])
                                        addElementGroup = true;
                                }
                            }
                        }
                        if (addElementGroup)
                            arrayFlag.push(groupFlag[key][f]);
                    }
                }

            }
            groupFlag[key] = arrayFlag;
        }
        //delete group
        let groupFlagDelete = JSON.parse(JSON.stringify(arrayGroupsDelete));
        for (let key in groupFlagDelete) {
            let arrayFlag = [];

            for (let f = 0; f < groupFlagDelete[key].length; f++) {
                arrayFlag.push(groupFlagDelete[key][f]);
            }
            groupFlagDelete[key] = arrayFlag;
        }
        for (let r = 0; r < data.crud.boxes.length; r++) {
            for (let g = 0; g < data.crud.boxes[r].fields.length; g++) {
                if (data.crud.boxes[r].fields[g].type !== 'Switch' && data.crud.boxes[r].fields[g].display !== 'hidden' && data.crud.boxes[r].fields[g].mandatory === true && !field[data.crud.boxes[r].fields[g].id]) {

                    if (data.crud.boxes[r].fields[g].where !== null && data.crud.boxes[r].fields[g].where !== undefined) {
                        let view = whereFunction(data.crud.boxes[r].fields[g]);
                        if (view === true) {
                            validation = false;
                        }
                    } else {
                        validation = false;
                    }
                }

                if (data.crud.boxes[r].fields[g].group !== null) {
                    for (let a = 0; a < data.crud.boxes[r].fields[g].group.length; a++) {
                        let nameGroup = data.crud.boxes[r].fields[g].group[a].name;
                        for (let u = 0; u < groupFlag[nameGroup].length; u++) {
                            for (let b = 0; b < groupFlag[nameGroup][u].fields.length; b++) {
                                if (groupFlag[nameGroup][u].fields[b].type !== 'Switch' && groupFlag[nameGroup][u].fields[b].display !== 'hidden' && groupFlag[nameGroup][u].fields[b].mandatory === true && !field[groupFlag[nameGroup][u].fields[b].id]) {
                                    validation = false;
                                }
                            }
                        }
                    }
                }
            }
        }

        if (validation === false) {
            setErrorSave('Complete todos los campos obligatorios');
            setLoad(false);
            return false;
        }

        let arrayRequest = [];

        data.crud.boxes.forEach((itemBoxs) => {
            itemBoxs.fields.forEach((item) => {
                let view = true;
                if (item.where !== null && item.where !== undefined)
                    view = whereFunction(item);
                if (view === true) {
                    for (let key in field) {

                        if (key === item.id && item.group == null) {

                            let existe = false;
                            for (let r = 0; r < arrayRequest.length; r++) {
                                if (arrayRequest[r].table === `${instance}.${item.table}`) {

                                    if (field[key] !== 'index') {

                                        if (item.type === 'Select') {
                                            let valueSelect;
                                            if (field[key] === null) {
                                                valueSelect = 'null';
                                            } else {
                                                valueSelect = field[key].id;
                                                if (valueSelect === undefined)
                                                    valueSelect = 'null';
                                            }

                                            arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${valueSelect}'` })

                                        } else {
                                            if (field[key] !== null) {//20-02-25
                                                let value = field[key];
                                                if (value === true) {
                                                    value = '1'
                                                }
                                                if (value === false) {
                                                    value = '0'
                                                }
                                                if ((item.type === 'Date' || item.type === 'Datetime' || item.type === 'Time') && !value) {
                                                    value = 'null';
                                                }
                                                if (item.type.includes('Percentage') || item.type.includes('Number') || item.type === 'Currency') {
                                                    if (value !== null && value !== undefined) {
                                                        value = value.toString().replace(/\./g, '');
                                                        value = value.toString().replace(/,/g, '.');
                                                        if (item.type.includes('Percentage')) {
                                                            value = Number(value) / 100;
                                                        }

                                                    }
                                                    //if (value)
                                                }
                                                if ((item.type.includes('Percentage') || item.type.includes('Number') || item.type === 'Currency') && (value === null || value === undefined || value === '') && item.idFieldTable !== 'id') {
                                                    value = 'null';
                                                }
                                                if (item.idFieldTable === 'id' && mode !== 'c') {
                                                    if (item.type !== 'TextField')
                                                        arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${value}'` })
                                                    else
                                                        if (item.display === 'edit')
                                                            arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${value}'` })
                                                        else
                                                            if (item.idFieldTable === 'name' || item.idFieldTable === 'nameAlt')
                                                                arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${value}'` })
                                                            else
                                                                if (value)
                                                                    arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${value}'` })
                                                }
                                                else {
                                                    if (item.idFieldTable !== 'id') {
                                                        if (item.type !== 'TextField')
                                                            arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${value}'` })
                                                        else
                                                            if (item.display === 'edit')
                                                                arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${value}'` })
                                                            else
                                                                if (item.idFieldTable === 'name' || item.idFieldTable === 'nameAlt')
                                                                    arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${value}'` })
                                                                else
                                                                    if (value)
                                                                        arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${value}'` })

                                                    }
                                                }

                                            }
                                        }
                                    }
                                    existe = true;
                                }
                            }
                            if (existe === false) {

                                if (field[key] !== 'index') {
                                    if (item.type === 'Select') {
                                        let valueSelect;
                                        if (field[key] === null) {
                                            valueSelect = 'null';
                                        } else {
                                            valueSelect = field[key].id;
                                            if (valueSelect === undefined)
                                                valueSelect = 'null';
                                        }

                                        arrayRequest.push({
                                            table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${valueSelect}'` }]
                                        })

                                    } else {
                                        if (field[key] !== null) {//20-02-25
                                            let value = field[key];
                                            if (value === true) {
                                                value = '1'
                                            }
                                            if (value === false) {
                                                value = '0'
                                            }
                                            if ((item.type === 'Date' || item.type === 'Datetime' || item.type === 'Time') && !value) {
                                                value = 'null';
                                            }
                                            if (item.type.includes('Percentage') || item.type.includes('Number') || item.type.includes('Currency')) {
                                                if (value !== null && value !== undefined) {
                                                    value = value.toString().replace(/\./g, '');
                                                    value = value.toString().replace(/,/g, '.');
                                                    if (item.type.includes('Percentage')) {
                                                        value = Number(value) / 100;
                                                    }
                                                }
                                            }
                                            if ((item.type.includes('Percentage') || item.type.includes('Number') || item.type.includes('Currency')) && (value === undefined || value === null || value === '') && item.idFieldTable !== 'id') {
                                                value = 'null';
                                            }
                                            //if (value)
                                            if (item.idFieldTable === 'id' && mode !== 'c') {
                                                if (item.type !== 'TextField')
                                                    arrayRequest.push({
                                                        table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${value}'` }]
                                                    })
                                                else
                                                    if (item.display === 'edit')
                                                        arrayRequest.push({
                                                            table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${value}'` }]
                                                        })
                                                    else
                                                        if (value)
                                                            arrayRequest.push({
                                                                table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${value}'` }]
                                                            })
                                            }

                                            else
                                                if (item.idFieldTable !== 'id') {
                                                    if (item.type !== 'TextField')
                                                        arrayRequest.push({
                                                            table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${value}'` }]
                                                        })
                                                    else
                                                        if (item.display === 'edit')
                                                            arrayRequest.push({
                                                                table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${value}'` }]
                                                            })
                                                        else
                                                            if (item.idFieldTable === 'name' || item.idFieldTable === 'nameAlt')
                                                                arrayRequest.push({
                                                                    table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${value}'` }]
                                                                })
                                                            else
                                                                if (value)
                                                                    arrayRequest.push({
                                                                        table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${value}'` }]
                                                                    })
                                                }
                                        }
                                    }
                                }

                            }
                        }
                    }
                }
            })
        })

        for (let key in groupFlag) {
            //if (key !== 'Cónyuge') {

            for (let r = 0; r < groupFlag[key].length; r++) {
                let table;
                let fields = [];

                //validate TRXLINE
                let validateTrxLineAccountEntity = null;
                for (let d = 0; d < groupFlag[key][r].fields.length; d++) {
                    if (groupFlag[key][r].fields[d].idFieldTable === 'trxLineTypeId') {
                        let keyField = groupFlag[key][r].fields[d].id;
                        validateTrxLineAccountEntity = field[keyField].id;
                    }
                }
                console.log('validateTrxLineAccountEntity-> '+validateTrxLineAccountEntity)
                //validate TRXLINE

                for (let d = 0; d < groupFlag[key][r].fields.length; d++) {
                    let view = true;
                    if (groupFlag[key][r].fields[d].where !== null && groupFlag[key][r].fields[d].where !== undefined)
                        view = whereFunction(groupFlag[key][r].fields[d]);

                    if (view === true) {
                        let keyField = groupFlag[key][r].fields[d].id;
                        let fieldTable = groupFlag[key][r].fields[d].idFieldTable;

                        //if (field[keyField] != null && fieldTable !== null) {
                        if (fieldTable !== null && groupFlag[key][r].fields[d].table !== null) {

                            if (typeof field[keyField] === 'object') {
                                if (field[keyField] === null) {
                                    if ((fieldTable === 'accountId' || fieldTable === 'entityPropertyId') && validateTrxLineAccountEntity) {
                                        let arrayRequest = [];
                                        let currencyId;
                                        let paymentSystemId;
                                        switch (validateTrxLineAccountEntity) {
                                            case '1':
                                                let requestTrxLineTypeId1 = {};
                                                requestTrxLineTypeId1.doc = data.id;
                                                requestTrxLineTypeId1.trxLineTypeId = '1';
                                                requestTrxLineTypeId1.isGuarantee = '0';
                                                data.crud.boxes.forEach((itemBoxes) => {
                                                    itemBoxes.fields.forEach((itemFields) => {
                                                        let idfield = itemFields.id;
                                                        if (field[idfield]) {
                                                            switch (itemFields.idFieldTable) {
                                                                case 'currencyId':
                                                                    requestTrxLineTypeId1.currencyId = field[idfield].id;
                                                                    break;
                                                                case 'agentId':
                                                                    requestTrxLineTypeId1.agentId = field[idfield].id;
                                                                    break;
                                                                case 'entityPropertyId':
                                                                    requestTrxLineTypeId1.entityPropertyId = field[idfield].id;
                                                                    break;
                                                                case 'paymentSystemId':
                                                                    requestTrxLineTypeId1.paymentSystemId = field[idfield].id;
                                                                    break;
                                                                default:
                                                                    break;
                                                            }
                                                        }
                                                    })
                                                })
                                                arrayRequest.push(requestTrxLineTypeId1);
                                                await informationService.searchAccount(user.data.instance, arrayRequest).then((response) => {
                                                    fields.push({ id: fieldTable, value: `${response.data[0][fieldTable]}` });
                                                })
                                                break;
                                            case '2':
                                                let requestTrxLineTypeId2 = {};
                                                requestTrxLineTypeId2.doc = data.id;
                                                requestTrxLineTypeId2.trxLineTypeId = '2';
                                                requestTrxLineTypeId2.isGuarantee = '0';
                                                data.crud.boxes.forEach((itemBoxes) => {
                                                    itemBoxes.fields.forEach((itemFields) => {
                                                        let idfield = itemFields.id;
                                                        if (field[idfield]) {
                                                            switch (itemFields.idFieldTable) {
                                                                case 'currencyId':
                                                                    requestTrxLineTypeId2.currencyId = field[idfield].id;
                                                                    break;
                                                                case 'agentId':
                                                                    requestTrxLineTypeId2.entityPropertyId = field[idfield].id;
                                                                    break;
                                                                case 'entityPropertyId':
                                                                    requestTrxLineTypeId2.entityPropertyId = field[idfield].id;
                                                                    break;
                                                                case 'paymentSystemId':
                                                                    requestTrxLineTypeId2.paymentSystemId = field[idfield].id;
                                                                    break;
                                                                default:
                                                                    break;
                                                            }
                                                        }
                                                    })
                                                })
                                                arrayRequest.push(requestTrxLineTypeId2);
                                                await informationService.searchAccount(user.data.instance, arrayRequest).then((response) => {
                                                    fields.push({ id: fieldTable, value: `${response.data[0][fieldTable]}` });
                                                })
                                                break;
                                            case '3':
                                                data.crud.boxes.forEach((itemBoxes) => {
                                                    itemBoxes.fields.forEach((itemFields) => {
                                                        let idfield = itemFields.id;
                                                        if (field[idfield]) {
                                                            switch (itemFields.idFieldTable) {
                                                                case 'currencyId':
                                                                    currencyId = field[idfield].id;
                                                                    break;
                                                                case 'paymentSystemId':
                                                                    paymentSystemId = field[idfield].id;
                                                                    break;
                                                                default:
                                                                    break;
                                                            }
                                                        }
                                                    })
                                                })
                                                let nameGroup3 = trxLineGroup(group, 3);
                                                for (let a1 = 0; a1 < nameGroup3.length; a1++) {
                                                    if (group[nameGroup3[a1]]) {
                                                        for (let y = 0; y < group[nameGroup3[a1]].length; y++) {
                                                            if (y === r) {
                                                                //TRXLINETYPEID 3
                                                                let requestTrxLineTypeId3 = {};
                                                                requestTrxLineTypeId3.doc = data.id;
                                                                requestTrxLineTypeId3.trxLineTypeId = '3';
                                                                requestTrxLineTypeId3.currencyId = currencyId;
                                                                requestTrxLineTypeId3.paymentSystemId = paymentSystemId;
                                                                for (let i = 0; i < group[nameGroup3[a1]][y].fields.length; i++) {
                                                                    if (group[nameGroup3[a1]][y].fields[i].idFieldTable === 'itemPropertyId') {
                                                                        let idField = group[nameGroup3[a1]][y].fields[i].id;
                                                                        if (field[idField])
                                                                            requestTrxLineTypeId3.itemPropertyId = field[idField].id;
                                                                        requestTrxLineTypeId3.line = y.toString();
                                                                    }
                                                                }
                                                                arrayRequest.push(requestTrxLineTypeId3);
                                                                await informationService.searchAccount(user.data.instance, arrayRequest).then((response) => {
                                                                    fields.push({ id: fieldTable, value: `${response.data[0][fieldTable]}` });
                                                                })
                                                            }
                                                        }
                                                    }
                                                }
                                                break;
                                            case '4':
                                                data.crud.boxes.forEach((itemBoxes) => {
                                                    itemBoxes.fields.forEach((itemFields) => {
                                                        let idfield = itemFields.id;
                                                        if (field[idfield]) {
                                                            switch (itemFields.idFieldTable) {
                                                                case 'currencyId':
                                                                    currencyId = field[idfield].id;
                                                                    break;
                                                                case 'paymentSystemId':
                                                                    paymentSystemId = field[idfield].id;
                                                                    break;
                                                                default:
                                                                    break;
                                                            }
                                                        }
                                                    })
                                                })
                                                let nameGroup4 = trxLineGroup(group, 4);
                                                for (let a1 = 0; a1 < nameGroup4.length; a1++) {
                                                    if (group[nameGroup4[a1]]) {
                                                        for (let y = 0; y < group[nameGroup4[a1]].length; y++) {
                                                            if (y === r) {
                                                                //TRXLINETYPEID 4
                                                                let requestTrxLineTypeId4 = {};
                                                                requestTrxLineTypeId4.doc = data.id;
                                                                requestTrxLineTypeId4.trxLineTypeId = '4';
                                                                requestTrxLineTypeId4.currencyId = currencyId;
                                                                requestTrxLineTypeId4.paymentSystemId = paymentSystemId;
                                                                for (let i = 0; i < group[nameGroup4[a1]][y].fields.length; i++) {
                                                                    if (group[nameGroup4[a1]][y].fields[i].idFieldTable === 'itemPropertyId') {
                                                                        let idField = group[nameGroup4[a1]][y].fields[i].id;
                                                                        if (field[idField])
                                                                            requestTrxLineTypeId4.itemPropertyId = field[idField].id;
                                                                        requestTrxLineTypeId4.line = y.toString();
                                                                    }
                                                                }
                                                                arrayRequest.push(requestTrxLineTypeId4);
                                                                await informationService.searchAccount(user.data.instance, arrayRequest).then((response) => {
                                                                    fields.push({ id: fieldTable, value: `${response.data[0][fieldTable]}` });
                                                                })
                                                            }
                                                        }
                                                    }
                                                }
                                                break;
                                            case '5':
                                                data.crud.boxes.forEach((itemBoxes) => {
                                                    itemBoxes.fields.forEach((itemFields) => {
                                                        let idfield = itemFields.id;
                                                        if (field[idfield]) {
                                                            switch (itemFields.idFieldTable) {
                                                                case 'currencyId':
                                                                    currencyId = field[idfield].id;
                                                                    break;
                                                                case 'paymentSystemId':
                                                                    paymentSystemId = field[idfield].id;
                                                                    break;
                                                                default:
                                                                    break;
                                                            }
                                                        }
                                                    })
                                                })
                                                let nameGroup5 = trxLineGroup(group, 5);
                                                for (let a1 = 0; a1 < nameGroup5.length; a1++) {
                                                    if (group[nameGroup5[a1]]) {
                                                        for (let y = 0; y < group[nameGroup5[a1]].length; y++) {
                                                            if (y === r) {
                                                                //TRXLINETYPEID 5
                                                                let requestTrxLineTypeId5 = {};
                                                                requestTrxLineTypeId5.doc = data.id;
                                                                requestTrxLineTypeId5.trxLineTypeId = '5';
                                                                requestTrxLineTypeId5.currencyId = currencyId;
                                                                requestTrxLineTypeId5.paymentSystemId = paymentSystemId;
                                                                for (let i = 0; i < group[nameGroup5[a1]][y].fields.length; i++) {
                                                                    if (group[nameGroup5[a1]][y].fields[i].idFieldTable === 'itemPropertyId') {
                                                                        let idField = group[nameGroup5[a1]][y].fields[i].id;
                                                                        if (field[idField])
                                                                            requestTrxLineTypeId5.itemPropertyId = field[idField].id;
                                                                        requestTrxLineTypeId5.line = y.toString();
                                                                    }
                                                                }
                                                                arrayRequest.push(requestTrxLineTypeId5);
                                                                await informationService.searchAccount(user.data.instance, arrayRequest).then((response) => {
                                                                    fields.push({ id: fieldTable, value: `${response.data[0][fieldTable]}` });
                                                                })
                                                            }
                                                        }
                                                    }
                                                }
                                                break;
                                            default:
                                                break;
                                        }
                                    } else {
                                        fields.push({ id: fieldTable, value: `'null'` });
                                    }
                                } else {
                                    if (field[keyField].id) {
                                        let valueSelect = field[keyField].id;
                                        if (valueSelect === undefined)
                                            valueSelect = 'null';
                                        fields.push({ id: fieldTable, value: `'${valueSelect}'` })
                                    }
                                }
                            } else {

                                if (field[keyField] === undefined) {//nuevo 21 02 25
                                    let defaultValue = groupFlag[key][r].fields[d].defaultValue;
                                    if (defaultValue !== null && defaultValue !== undefined) {
                                        fields.push({ id: fieldTable, value: `'${defaultValue}'` })
                                    }
                                }
                                if (field[keyField] != null) {
                                    let valueGroup = field[keyField];
                                    if (field[keyField] === 'No' || field[keyField] === false) {
                                        valueGroup = '0'
                                    }
                                    if (field[keyField] === 'Si' || field[keyField] === true) {
                                        valueGroup = '1'
                                    }
                                    if ((groupFlag[key][r].fields[d].type === 'Date' || groupFlag[key][r].fields[d].type === 'Datetime' || groupFlag[key][r].fields[d].type === 'Time') && !field[keyField]) {
                                        valueGroup = 'null';
                                    }

                                    if (groupFlag[key][r].fields[d].type.includes('Percentage') || groupFlag[key][r].fields[d].type.includes('Number') || groupFlag[key][r].fields[d].type.includes('Currency')) {
                                        if (valueGroup !== null && valueGroup !== undefined) {

                                            valueGroup = valueGroup.toString().replace(/\./g, '');
                                            valueGroup = valueGroup.toString().replace(/,/g, '.');
                                            if (groupFlag[key][r].fields[d].type.includes('Percentage')) {
                                                valueGroup = Number(valueGroup) / 100;
                                            }
                                        }
                                    }
                                    if ((groupFlag[key][r].fields[d].type.includes('Percentage') || groupFlag[key][r].fields[d].type.includes('Number') || groupFlag[key][r].fields[d].type === 'Currency')
                                        && (field[keyField] === null || field[keyField] === undefined || field[keyField] === '') && groupFlag[key][r].fields[d].idFieldTable !== 'id') {
                                        valueGroup = 'null';
                                    }

                                    if (groupFlag[key][r].fields[d].type !== 'TextField')
                                        fields.push({ id: fieldTable, value: `'${valueGroup}'` })
                                    else
                                        if (groupFlag[key][r].fields[d].display === 'edit')
                                            fields.push({ id: fieldTable, value: `'${valueGroup}'` })
                                        else
                                            if (groupFlag[key][r].fields[d].idFieldTable === 'name' || groupFlag[key][r].fields[d].idFieldTable === 'nameAlt')
                                                fields.push({ id: fieldTable, value: `'${valueGroup}'` })
                                            else
                                                if (valueGroup)
                                                    fields.push({ id: fieldTable, value: `'${valueGroup}'` })

                                }
                            }
                        }
                    }
                }

                data.crud.boxes.forEach((itemBoxs) => {
                    itemBoxs.fields.forEach((item) => {
                        if (item.group !== null) {
                            item.group.forEach((itemGroup) => {
                                itemGroup.fields.forEach((itemGroupFields) => {
                                    if (itemGroup.name === key) {
                                        table = itemGroupFields.table;
                                    }
                                })
                            })
                        }
                    })
                })

                if (fields.length > 0) {
                    //validar signo trxline3 y trxline4
                    if (table === 'trxLine') {
                        let validate = false;
                        for (let v = 0; v < fields.length; v++) {
                            if (fields[v].id === 'trxLineTypeId') {
                                if (Number(fields[v].value.toString().replace(/'/g, '')) === 3 || Number(fields[v].value.toString().replace(/'/g, '')) === 4) {
                                    validate = true;
                                }
                            }
                        }
                        if (validate === true) {
                            for (let v = 0; v < fields.length; v++) {
                                if (fields[v].id === 'sign') {
                                    fields[v].value = '1';
                                }
                            }
                        }
                    }
                    arrayRequest.push({
                        table: `${instance}.${table}`, fields: fields
                    })
                }

            }
            //}
        }

        //DELETE GROUP
        if (id) {
            for (let key in groupFlagDelete) {
                for (let r = 0; r < groupFlagDelete[key].length; r++) {
                    let table;
                    let fields = [];
                    if (groupFlagDelete[key][r].fields !== null && groupFlagDelete[key][r].fields !== undefined) {
                        let addElementDelete = false;
                        for (let d = 0; d < groupFlagDelete[key][r].fields.length; d++) {
                            let keyField = groupFlagDelete[key][r].fields[d].id;
                            let fieldTable = groupFlagDelete[key][r].fields[d].idFieldTable;
                            if (fieldTable === 'id' && field[keyField] && field[keyField] !== null && field[keyField] !== undefined && Number(field[keyField]) !== 0) {
                                addElementDelete = true;
                            }
                        }

                        if (addElementDelete) {
                            for (let d = 0; d < groupFlagDelete[key][r].fields.length; d++) {
                                let view = true;
                                if (groupFlagDelete[key][r].fields[d].where !== null && groupFlagDelete[key][r].fields[d].where !== undefined)
                                    view = whereFunction(groupFlagDelete[key][r].fields[d]);

                                if (view === true) {
                                    let keyField = groupFlagDelete[key][r].fields[d].id;
                                    let fieldTable = groupFlagDelete[key][r].fields[d].idFieldTable;

                                    if (field[keyField] != null && fieldTable !== null) {
                                        if (typeof field[keyField] === 'object') {
                                            if (field[keyField].id)
                                                fields.push({ id: fieldTable, value: `'${field[keyField].id}'` })
                                        } else {
                                            if (field[keyField] === 'No' || field[keyField] === false) {
                                                field[keyField] = '0'
                                            }
                                            if (field[keyField] === 'Si' || field[keyField] === true) {
                                                field[keyField] = '1'
                                            }
                                            fields.push({ id: fieldTable, value: `'${field[keyField]}'` })
                                        }
                                    }
                                }
                            }

                            data.crud.boxes.forEach((itemBoxs) => {
                                itemBoxs.fields.forEach((item) => {
                                    if (item.group !== null) {
                                        item.group.forEach((itemGroup) => {
                                            itemGroup.fields.forEach((itemGroupFields) => {
                                                if (itemGroup.name === key) {
                                                    table = itemGroupFields.table;
                                                }
                                            })
                                        })
                                    }
                                })
                            })

                            arrayRequest.push({
                                table: `${instance}.${table}`, fields: fields, delete: true
                            })
                        }
                    }
                }
            }
        }

        let arraySave = [];
        for (let f = 0; f < data.crud.store.length; f++) {
            for (let h = 0; h < arrayRequest.length; h++) {
                if (arrayRequest[h].table.split('.')[1] === data.crud.store[f].table) {
                    arraySave.push(arrayRequest[h]);
                }
            }
        }

        informationService.viewTables().then(async (responseTables) => {
            for (let y = 0; y < arraySave.length; y++) {
                for (let r = 0; r < responseTables.data.length; r++) {
                    let tableFlag = arraySave[y].table.split('.');
                    if (tableFlag[1] === responseTables.data[r].name) {
                        arraySave[y].table = `wbSys.${tableFlag[1]}`
                    }
                }
            }


            for (let l = 0; l < arraySave.length; l++) {
                var fields = arraySave[l].fields;
                var uniqueFields = [];
                var uniqueIds = {};
                for (let x = 0; x < fields.length; x++) {
                    var idf = fields[x].id;
                    if (!uniqueIds[idf]) {
                        uniqueIds[idf] = true;
                        uniqueFields.push(fields[x]);
                    }
                }
                arraySave[l].fields = uniqueFields;
            }
            await isGuarantee(arraySave);

            console.log('arraysave-> ' + JSON.stringify(arraySave))
            if (!id) {

                informationService.save(data.crud.route, constants.CLIENT, user.data.instance, 'saveRecord', user.email, arraySave, data.list.view).then((response) => {
                    const responseService = response.data;
                    if (responseService.idRecord !== 0) {

                        inmmediates(groupFlag, responseService.idRecord);
                        const whereParameters = getFilteredParams();
                        navigate(`/${linkto}?id=${responseService.idRecord}&m=${mode}${whereParameters}`);
                        setModeFlag(mode);
                        setField(initialField(data));
                        setTitle('');
                        setGroup(initialArrayGroup(data.crud));

                        for (let y = 0; y < audit.length; y++) {
                            audit[y].id = responseService.idRecord;
                        }
                        auditService.save(user.client, user.data.instance, audit).then((response) => {
                            setAudit([]);
                        }).catch((error) => {
                            setMessage({ error: true, message: error })
                            setLoad(false);
                        });
                    } else {
                        //manejo de errores
                        if (responseService.errores) {
                            let errores = '';
                            for (const err of responseService.errores) {
                                errores = errores + err.codigoError + "=" + err.descripcionError + '\n';
                            }
                            setErroresIntegracion(errores);
                            setLoad(false);
                        }
                    }
                }).catch((error) => {
                    setMessage({ error: true, message: error })
                    setLoad(false);
                });
            } else {
                for (let b = 0; b < arraySave.length; b++) {
                    if (arraySave[b].table.split(".")[1] === 'entity' || arraySave[b].table.split(".")[1] === 'entityProperty' || arraySave[b].table.split(".")[1] === 'argEntity') {
                        for (let c = 0; c < arraySave[b].fields.length; c++) {
                            if (arraySave[b].fields[c].id === 'id') {
                                //arraySave[b].fields[c].value = record.entityId;
                            }
                        }
                    }
                }
                informationService.update(data.crud.route, constants.CLIENT, user.data.instance, 'saveRecord', user.email, arraySave, data.list.view).then((response) => {

                    const responseService = response.data;
                    if (responseService.errores) {
                        let errores = '';
                        for (const err of responseService.errores) {
                            errores = errores + err.codigoError + "=" + err.descripcionError + '\n';
                        }
                        setErroresIntegracion(errores);
                        setLoad(false);
                    } else {
                        const whereParameters = getFilteredParams();
                        navigate(`/${linkto}?id=${id}&m=${mode}${whereParameters}`);
                        setModeFlag(mode);
                        setField(initialField(data));
                        setTitle('');
                        setGroup(initialArrayGroup(data.crud));

                        auditService.save(user.client, user.data.instance, audit).then((response) => {
                            setAudit([]);
                        }).catch((error) => {
                            setMessage({ error: true, message: error })
                            setLoad(false);
                        });
                    }
                }).catch((error) => {
                    setMessage({ error: true, message: error })
                    setLoad(false);
                });
            }
        }).catch((error) => {
            setMessage({ error: true, message: error })
            setLoad(false);
        });
    }

    const isGuarantee = async (arraySave) => {
        const user = AuthService.getCurrentUser();
        //GUARANTEE
        if (data.id === 'guarantee') {
            for (let b = 0; b < arraySave.length; b++) {
                let table = arraySave[b].table.split('.');
                if (table[1] === 'trxLine') {
                    let trxLineTypeId;
                    let isGuarantee;
                    for (let d = 0; d < arraySave[b].fields.length; d++) {
                        if (arraySave[b].fields[d].id === 'isGuarantee') {
                            isGuarantee = Number(arraySave[b].fields[d].value.toString().replace(/'/g, ''));
                        }
                        if (arraySave[b].fields[d].id === 'trxLineTypeId') {
                            trxLineTypeId = Number(arraySave[b].fields[d].value.toString().replace(/'/g, ''));
                        }
                    }
                    //add trxline 2

                    if (Number(trxLineTypeId) === 2 && Number(isGuarantee) === 0) {
                        let addObject = JSON.parse(JSON.stringify(arraySave[b]));
                        addObject.delete = false;
                        for (let d = 0; d < addObject.fields.length; d++) {
                            if (addObject.fields[d].id === 'isGuarantee')
                                addObject.fields[d].value = '1';
                            if (addObject.fields[d].id === 'sign')
                                addObject.fields[d].value = Number(addObject.fields[d].value.toString().replace(/'/g, '')) * -1;
                            if (addObject.fields[d].id === 'id')
                                addObject.fields[d].value = "''";
                        }
                        //search account
                        let arrayRequest = [];
                        let requestTrxLineTypeId2 = {};
                        requestTrxLineTypeId2.doc = data.id;
                        requestTrxLineTypeId2.trxLineTypeId = '2';
                        requestTrxLineTypeId2.isGuarantee = '1';
                        data.crud.boxes.forEach((itemBoxes) => {
                            itemBoxes.fields.forEach((itemFields) => {
                                let idfield = itemFields.id;
                                if (field[idfield]) {
                                    switch (itemFields.idFieldTable) {
                                        case 'currencyId':
                                            requestTrxLineTypeId2.currencyId = field[idfield].id;
                                            break;
                                        case 'agentId':
                                            requestTrxLineTypeId2.entityPropertyId = field[idfield].id;
                                            break;
                                        case 'paymentSystemId':
                                            requestTrxLineTypeId2.paymentSystemId = field[idfield].id;
                                            break;
                                        default:
                                            break;
                                    }
                                }
                            })
                        })
                        arrayRequest.push(requestTrxLineTypeId2);

                        await informationService.searchAccount(user.data.instance, arrayRequest).then((response) => {
                            for (let d = 0; d < addObject.fields.length; d++) {
                                if (addObject.fields[d].id === 'entityPropertyId')
                                    addObject.fields[d].value = response.data[0].entityPropertyId
                                if (addObject.fields[d].id === 'accountId')
                                    addObject.fields[d].value = response.data[0].accountId
                            }
                            arraySave.push(addObject);
                        })
                        //search account
                    }
                }
            }

            //add trxline 1
            let arrayFlagIsGuarantee1 = [];
            for (let b = 0; b < arraySave.length; b++) {
                let table = arraySave[b].table.split('.');
                if (table[1] === 'trxLine') {
                    let trxLineTypeId;
                    let isGuarantee;
                    let currencyId;
                    let sign;
                    let amount;
                    for (let d = 0; d < arraySave[b].fields.length; d++) {
                        if (arraySave[b].fields[d].id === 'isGuarantee')
                            isGuarantee = Number(arraySave[b].fields[d].value.toString().replace(/'/g, ''));
                        if (arraySave[b].fields[d].id === 'trxLineTypeId')
                            trxLineTypeId = Number(arraySave[b].fields[d].value.toString().replace(/'/g, ''));
                        if (arraySave[b].fields[d].id === 'currencyId')
                            currencyId = Number(arraySave[b].fields[d].value.toString().replace(/'/g, ''));
                        if (arraySave[b].fields[d].id === 'sign')
                            sign = Number(arraySave[b].fields[d].value.toString().replace(/'/g, ''));
                        if (arraySave[b].fields[d].id === 'amount')
                            amount = Number(arraySave[b].fields[d].value.toString().replace(/'/g, ''));

                    }

                    if (Number(trxLineTypeId) === 2 && Number(isGuarantee) === 1) {
                        if (arrayFlagIsGuarantee1.length === 0) {
                            arrayFlagIsGuarantee1.push(arraySave[b]);
                        } else {
                            let existe = false;
                            for (let m = 0; m < arrayFlagIsGuarantee1.length; m++) {
                                let currencyIdFlag;
                                for (let t = 0; t < arrayFlagIsGuarantee1[m].fields.length; t++) {
                                    if (arrayFlagIsGuarantee1[m].fields[t].id === 'currencyId')
                                        currencyIdFlag = Number(arrayFlagIsGuarantee1[m].fields[t].value.toString().replace(/'/g, ''));
                                }
                                if (Number(currencyIdFlag) === Number(currencyId)) {
                                    for (let t = 0; t < arrayFlagIsGuarantee1[m].fields.length; t++) {
                                        if (arrayFlagIsGuarantee1[m].fields[t].id === 'amount')
                                            amount = Number(amount) + Number(arrayFlagIsGuarantee1[m].fields[t].value.toString().replace(/'/g, '')) * sign;
                                    }
                                    existe = true;
                                }
                            }
                            if (existe === false)
                                arrayFlagIsGuarantee1.push(arraySave[b]);
                        }
                    }
                }
            }
            let addTrxline1 = {};
            let sign;
            for (let b = 0; b < arraySave.length; b++) {
                let table = arraySave[b].table.split('.');
                if (table[1] === 'trxLine') {
                    let trxLineTypeId;
                    for (let d = 0; d < arraySave[b].fields.length; d++) {
                        if (arraySave[b].fields[d].id === 'trxLineTypeId')
                            trxLineTypeId = Number(arraySave[b].fields[d].value.toString().replace(/'/g, ''));
                    }
                    if (Number(trxLineTypeId) === 1 && !arraySave[b].delete) {
                        addTrxline1 = JSON.parse(JSON.stringify(arraySave[b]));
                        addTrxline1.delete = false;
                    }
                }
                if (table[1] === 'trx') {
                    for (let d = 0; d < arraySave[b].fields.length; d++) {
                        if (arraySave[b].fields[d].id === 'sign')
                            sign = Number(arraySave[b].fields[d].value.toString().replace(/'/g, ''));
                    }
                }
            }

            for (let b = 0; b < arrayFlagIsGuarantee1.length; b++) {
                let amount = 0;
                for (let a = 0; a < arrayFlagIsGuarantee1[b].fields.length; a++) {
                    if (arrayFlagIsGuarantee1[b].fields[a].id === 'amount')
                        amount = arrayFlagIsGuarantee1[b].fields[a].value.toString().replace(/'/g, '');

                }
                for (let b1 = 0; b1 < addTrxline1.fields.length; b1++) {
                    if (addTrxline1.fields[b1].id === 'amount') {
                        addTrxline1.fields[b1].value = amount;
                    }
                    if (addTrxline1.fields[b1].id === 'isGuarantee') {
                        addTrxline1.fields[b1].value = 1;
                    }
                    if (addTrxline1.fields[b1].id === 'sign') {
                        addTrxline1.fields[b1].value = sign;
                    }
                    if (addTrxline1.fields[b1].id === 'id') {
                        addTrxline1.fields[b1].value = "''";
                    }
                }
                //search account
                let arrayRequest = [];
                let requestTrxLineTypeId1 = {};
                requestTrxLineTypeId1.doc = data.id;
                requestTrxLineTypeId1.trxLineTypeId = '1';
                requestTrxLineTypeId1.isGuarantee = '1';

                data.crud.boxes.forEach((itemBoxes) => {
                    itemBoxes.fields.forEach((itemFields) => {
                        let idfield = itemFields.id;
                        if (field[idfield]) {
                            switch (itemFields.idFieldTable) {
                                case 'currencyId':
                                    requestTrxLineTypeId1.currencyId = field[idfield].id;
                                    break;
                                case 'agentId':
                                    requestTrxLineTypeId1.agentId = field[idfield].id;
                                    break;
                                case 'entityPropertyId':
                                    requestTrxLineTypeId1.entityPropertyId = field[idfield].id;
                                    break;
                                case 'paymentSystemId':
                                    requestTrxLineTypeId1.paymentSystemId = field[idfield].id;
                                    break;
                                default:
                                    break;
                            }
                        }
                    })
                })
                arrayRequest.push(requestTrxLineTypeId1);

                await informationService.searchAccount(user.data.instance, arrayRequest).then((response) => {
                    for (let d = 0; d < addTrxline1.fields.length; d++) {
                        if (addTrxline1.fields[d].id === 'accountId')
                            addTrxline1.fields[d].value = response.data[0].accountId
                    }
                    arraySave.push(addTrxline1);
                })
                //search account
            }
        }
    }

    const handleFocus = (idField, currentValue) => {
        setPreviousValue((prev) => ({ ...prev, [idField]: currentValue }));
    };

    const deleteRecord = (linkto, mode) => {
        let arrayRequest = [];
        setLoad(true);
        data.crud.boxes.forEach((itemBoxs) => {
            itemBoxs.fields.forEach((item) => {
                for (let key in field) {
                    if (key === item.id) {
                        let existe = false;
                        for (var r = 0; r < arrayRequest.length; r++) {
                            if (item.idFieldTable === 'id') {
                                if (arrayRequest[r].table === `${instance}.${item.table}`) {
                                    arrayRequest[r].fields.push({ id: 'id', value: `'${field[key]}'` })
                                    //arrayRequest[r].fields.push({ id: item.id, value: `'${field[key]}'` })
                                    existe = true;
                                }
                            }
                        }
                        if (existe === false && item.table !== null) {
                            if (item.idFieldTable === 'id') {
                                arrayRequest.push({
                                    table: `${instance}.${item.table}`, fields: [{ id: 'id', value: `'${field[key]}'` }]
                                })
                            }
                        }
                    }
                }
            })
        })
        setOpen(false);
        const user = AuthService.getCurrentUser();
        informationService.viewTables().then((responseTables) => {

            for (let y = 0; y < arrayRequest.length; y++) {

                for (let r = 0; r < responseTables.data.length; r++) {

                    let tableFlag = arrayRequest[y].table.split('.');

                    if (tableFlag[1] === responseTables.data[r].name) {
                        arrayRequest[y].table = `wbSys.${tableFlag[1]}`
                    }
                }
            }
            informationService.deleteRecord(data.crud.route, constants.CLIENT, user.data.instance, 'deleteRecord', user.email, arrayRequest).then((response) => {

                const responseService = response.data;
                if (responseService.errores) {
                    let errores = '';
                    for (const err of responseService.errores) {
                        errores = errores + err.codigoError + "=" + err.descripcionError + '\n';
                    }
                    setErroresIntegracion(errores);
                    setLoad(false);
                } else {
                    const whereParameters = getFilteredParams();
                    navigate(`/${linkto}?m=l${whereParameters}`);
                    setModeFlag('l');
                    setField(initialField(data));
                    setTitle('');
                    setGroup(initialArrayGroup(data.crud));

                    let auditDelete = [{
                        context: 'UI',
                        doc: data.id,
                        id,
                        mode,
                        user: user.email
                    }]
                    auditService.save(user.client, user.data.instance, auditDelete).then((response) => {

                    }).catch((error) => {
                        setMessage({ error: true, message: error })
                        setLoad(false);
                    });
                }
            }).catch((error) => {
                setMessage({ error: true, message: error })
                setLoad(false);
            });
        }).catch((error) => {
            setMessage({ error: true, message: error })
            setLoad(false);
        });
    }

    const addRedirectRecord = (doc, idRecord) => {
        idRecord = idRecord.toString().replace(/\./g, '');
        idRecord = idRecord.toString().replace(/,/g, '');
        const urlNuevaPestana = `${doc}?id=${idRecord}&m=r`;
        window.open(urlNuevaPestana, '_blank');
    }

    const setValueSearchSource = (item, newIdField, arrayFields, arrayResponse) => {

        try {
            let table = item.search;
            let fieldsRequest = [];

            for (let u = 0; u < item.searchSource.length; u++) {

                let existe = false;
                data.crud.boxes.forEach((itemBoxs) => {//solo busca por cabecera, revisar mas adelante si es necesario grupo
                    itemBoxs.fields.forEach((itemFields) => {
                        if (itemFields.group === null) {
                            if (itemFields.id === item.searchSource[u]) {
                                existe = true;
                                let idFieldTable = itemFields.idFieldTable;
                                let fieldFlag = idFieldTable.replace('Id', '');
                                if (fieldFlag === table) {
                                    idFieldTable = 'id';
                                }
                                if (typeof field[itemFields.id] === 'object') {
                                    if (field[itemFields.id] !== null) {
                                        fieldsRequest.push({
                                            id: idFieldTable,
                                            value: field[itemFields.id].id
                                        })
                                    }
                                } else {
                                    fieldsRequest.push({
                                        id: idFieldTable,
                                        value: field[itemFields.id]
                                    })
                                }
                            }
                        }
                    })
                })
                if (existe === false) {
                    if (arrayFields !== null) {
                        for (let j = 0; j < arrayFields.length; j++) {
                            if (arrayFields[j].id === item.searchSource[u]) {
                                existe = true;
                                let idFieldTable = arrayFields[j].idFieldTable;
                                let fieldFlag = idFieldTable.replace('Id', '');
                                if (fieldFlag === table) {
                                    idFieldTable = 'id';
                                }

                                if (typeof arrayFields[j].valueTemporal === 'object') {
                                    if (arrayFields[j].valueTemporal !== null) {
                                        fieldsRequest.push({
                                            id: idFieldTable,
                                            value: arrayFields[j].valueTemporal.id
                                        })
                                    }
                                } else {
                                    fieldsRequest.push({
                                        id: idFieldTable,
                                        value: arrayFields[j].valueTemporal
                                    })
                                }
                            }
                        }
                    }
                }
            }

            let valueSearch = item.idFieldTable;

            informationService.searchSource(table, instance, fieldsRequest).then((response) => {

                if (response.data.length > 0) {
                    let idSearch = response.data[0][valueSearch];

                    if (item.type === 'Select') {
                        var fieldSearchValue = valueSearch.replace('Id', '');
                        let label = response.data[0][fieldSearchValue];
                        if (arrayResponse === null && (label === undefined || label === 'undefined')) {
                            for (const inf of info) {
                                if (inf.source === fieldSearchValue) {
                                    if (Number(inf.id) === Number(idSearch)) {
                                        label = inf.nameAlt !== undefined ? `${inf.name} ${inf.nameAlt}` : `${inf.name}`
                                    }
                                }
                            }
                        } else {
                            if (arrayResponse !== null && (label === undefined || label === 'undefined')) {
                                for (const inf of arrayResponse) {
                                    if (inf.source === fieldSearchValue) {
                                        if (Number(inf.id) === Number(idSearch)) {
                                            label = inf.nameAlt !== undefined ? `${inf.name} ${inf.nameAlt}` : `${inf.name}`
                                        }
                                    }
                                }
                            } else {
                                label = response.data[0].nameAlt !== undefined ? `${response.data[0].name} ${response.data[0].nameAlt}` : `${response.data[0].name}`
                            }
                        }
                        setField(prevState => ({
                            ...prevState,
                            [newIdField]: {
                                id: idSearch,
                                label: label
                            },
                        }), []);
                    } else {
                        setField(prevState => ({
                            ...prevState,
                            [newIdField]: idSearch,
                        }), []);
                    }
                } else {
                    if (item.type === 'Select') {
                        setField(prevState => ({
                            ...prevState,
                            [newIdField]: null,
                        }), []);
                    } else {
                        setField(prevState => ({
                            ...prevState,
                            [newIdField]: '',
                        }), []);
                    }
                }
            }).catch((error) => {
                console.log(error);
            })

        } catch (error) {
            console.log('error-> ' + error)
        }
    }

    const addElementGroup = (group1, setValues) => {
        let objArrayElement = {};
        let arrayFields = [];
        data.crud.boxes.forEach((itemBoxs) => {
            itemBoxs.fields.forEach((itemFields, index) => {
                if (itemFields.group !== null) {
                    itemFields.group.forEach((itemGroup) => {
                        if (itemGroup.name === group1) {
                            itemGroup.fields.forEach((item) => {
                                let itemFlag = JSON.parse(JSON.stringify(item));
                                let tamano = generateNumber();
                                let newIdField = index + '_' + item.id + '_' + index + tamano;
                                itemFlag.id = newIdField;
                                itemFlag.isGroup = true;
                                arrayFields.push(itemFlag);
                            })

                            arrayFields.forEach((item, indexFields) => {
                                let newIdField = item.id;
                                if (item.where !== null) {
                                    for (let r = 0; r < item.where.length; r++) {
                                        if (item.where[r].field.length !== null) {
                                            for (let d = 0; d < item.where[r].field.length; d++) {
                                                let idField = item.where[r].field[d].idField;
                                                let existeIdGroup = false;
                                                itemGroup.fields.forEach((itemFlagFieldsGroup) => {
                                                    if (itemFlagFieldsGroup.id === idField) {
                                                        //modificacion 18 03 25                                                        
                                                        arrayFields.forEach((itemArrayFields) => {
                                                            if (itemArrayFields.idFieldTable === itemFlagFieldsGroup.idFieldTable) {
                                                                item.where[r].field[d].idField = itemArrayFields.id;
                                                                existeIdGroup = true;
                                                            }
                                                        })
                                                        //modificacion 18 03 25
                                                    }
                                                })
                                                if (existeIdGroup === false) {
                                                    let newIdField1 = idField;
                                                    item.where[r].field[d].idField = newIdField1;
                                                }
                                            }
                                        }
                                    }
                                }
                                //buscar y reemplazar id de los search source
                                if (item.searchSource !== null) {
                                    for (let r = 0; r < item.searchSource.length; r++) {
                                        let idField = item.searchSource[r];
                                        let existeIdGroup = false;
                                        itemGroup.fields.forEach((itemFlagFieldsGroup) => {
                                            if (itemFlagFieldsGroup.id === idField) {

                                                //modificacion 18 03 25                                                        
                                                arrayFields.forEach((itemArrayFields) => {
                                                    if (itemArrayFields.idFieldTable === itemFlagFieldsGroup.idFieldTable) {
                                                        item.searchSource[r] = itemArrayFields.id;
                                                        existeIdGroup = true;
                                                    }
                                                })
                                                //modificacion 18 03 25


                                            }
                                        })

                                        if (existeIdGroup === false) {
                                            let newIdField1 = idField;
                                            item.searchSource[r] = newIdField1;
                                        }
                                    }
                                }
                                if (setValues) {
                                    if (indexFields === 0 && mode === 'u') {
                                        setField(prevState => ({
                                            ...prevState,
                                            [newIdField]: id
                                        }));
                                    } else {
                                        let value;
                                        switch (item.type) {
                                            case 'Select':
                                                if (item.defaultValue) {
                                                    info.forEach((itemInfo) => {
                                                        if (itemInfo.source === item.sourceSelect) {
                                                            if (Number(item.defaultValue) === Number(itemInfo.id))
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [newIdField]: {
                                                                        id: itemInfo.id,
                                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                    }
                                                                }), []);
                                                        }
                                                    })
                                                } else {
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [newIdField]: null
                                                    }));
                                                }
                                                if (item.searchSource !== null) {
                                                    setValueSearchSource(item, newIdField, null, null);
                                                }
                                                break;
                                            case 'MultipleSelect':
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [newIdField]: null
                                                }));
                                                break;
                                            case 'List':
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [newIdField]: null
                                                }));
                                                break;
                                            case 'Checkbox':
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [newIdField]: false
                                                }));
                                                break;
                                            case 'Switch':
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [newIdField]: false
                                                }));
                                                break;
                                            case 'Number':
                                                value = item.defaultValue ? item.defaultValue : '';

                                                setField(prevState => ({
                                                    ...prevState,
                                                    [newIdField]: value
                                                }));

                                                if (item.searchSource !== null) {
                                                    setValueSearchSource(item, newIdField, null, null);

                                                }
                                                break;
                                            case 'Currency':
                                                value = item.defaultValue ? item.defaultValue : '';

                                                setField(prevState => ({
                                                    ...prevState,
                                                    [newIdField]: value
                                                }));
                                                if (item.searchSource !== null) {
                                                    setValueSearchSource(item, newIdField, null, null);

                                                }
                                                break;
                                            case 'Date':
                                                if (item.defaultValue === 'CURDATE()') {
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [newIdField]: new Date().toISOString().split('T')[0]
                                                    }), []);
                                                } else {
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [newIdField]: ''
                                                    }));
                                                }
                                                break;
                                            default:
                                                value = item.defaultValue ? item.defaultValue : '';
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [newIdField]: value
                                                }));
                                                if (item.searchSource !== null) {
                                                    setValueSearchSource(item, newIdField, null, null);
                                                }
                                                break;
                                        }
                                    }
                                }
                            })
                        }
                    })
                }
            })
        })

        objArrayElement.fields = arrayFields;

        if (setValues === true) {
            setGroup(prevState => ({
                ...prevState,
                [group1]: [...group[group1], objArrayElement]
            }));
        }
        return objArrayElement;
    }


    const onDeleteElementGroup = (index, group1) => {

        let arrayFlag = [];
        let arrayFlagDelete = [];

        for (let i = 0; i < group[group1].length; i++) {
            if (Number(i) !== Number(index)) {
                arrayFlag.push(group[group1][i]);
            } else {
                arrayFlagDelete.push(group[group1][i]);
            }
        }
        let tamanoOriginal = group[group1].length;
        if (tamanoOriginal === 1) {
            arrayFlag.push(addElementGroup(group1, true));
        }

        setGroup(prevState => ({
            ...prevState,
            [group1]: arrayFlag
        }));

        setArrayGroupDelete(prevState => ({
            ...prevState,
            [group1]: [...(prevState[group1] || []), ...arrayFlagDelete],
        }));

        //VALIDATE TRXLINE

        if (group1) {
            let trxLineTypeId = 0;
            for (let r = 0; r < group[group1].length; r++) {
                if (Number(index) === Number(r)) {
                    for (let d = 0; d < group[group1][r].fields.length; d++) {
                        if (group[group1][r].fields[d].idFieldTable === 'trxLineTypeId') {
                            if (field[group[group1][r].fields[d].id]) {
                                trxLineTypeId = field[group[group1][r].fields[d].id].id
                                if (Number(trxLineTypeId) === 0)
                                    trxLineTypeId = group[group1][r].fields[d].defaultValue
                            }
                        }
                    }
                }
            }

            group[group1] = arrayFlag;


            //if (group1 === 'trxLine2' && data.id !== 'dividens') {
            if (Number(trxLineTypeId) === 2 && data.id !== 'dividens') {
                //group.trxLine2 = arrayFlag;    
                trxLine.setTrxLine3(null, field, null, group1, data, group, addElementGroup, setField, info, setGroup, setArrayGroupDelete, id, null, true, searchFieldSource, setValueSearchSource, mode, [], []);
            }

            //if (group1 === 'trxLine3') {
            if (Number(trxLineTypeId) === 3) {
                //group.trxLine3 = arrayFlag;
                trxLine.setTrxLine4(null, null, null, null, field, data, group, addElementGroup, setField, info, setGroup, setArrayGroupDelete, id, null, null, true, searchFieldSource, setValueSearchSource, mode);
            }

            //if (group1 === 'trxLine4') {
            if (Number(trxLineTypeId) === 4) {
                //group.trxLine4 = arrayFlag;
                trxLine.setTrxLine1(field, null, group, setField, info, id, addElementGroup, setGroup, null, data, null, null, null, null, setArrayGroupDelete, searchFieldSource, true, setValueSearchSource, mode);
            }

            //if (group1 === 'trxLine5') {
            if (Number(trxLineTypeId) === 5) {
                //group.trxLine5 = arrayFlag;
                trxLine.setTrxLine1(field, null, group, setField, info, id, addElementGroup, setGroup, null, data, null, null, null, null, setArrayGroupDelete, searchFieldSource, true, setValueSearchSource, mode);
            }
        }


    }

    const buttonHeaderActionList = (linkto, mode, fc, list) => {
        if (linkto && mode && !fc) {
            setLoad(true);
            setField(initialField(data));
            setTitle('');
            setGroup(initialArrayGroup(data.crud));
            let whereParameters = '';
            for (let t = 0; t < whereFields.length; t++) {
                whereParameters = whereParameters + `&${buildParam(whereFields[t].idField, whereFields[t].operator, whereFields[t].value)}`
            }
            if (mode === 'c') {
                navigate(`/${linkto}?m=${mode}`);
            } else {
                if (id) {
                    navigate(`/${linkto}?id=${id}&m=${mode}${whereParameters}`);
                } else {
                    navigate(`/${linkto}?m=${mode}${whereParameters}`);
                }
            }
            setModeFlag(mode);
        }
        else {
            setLoadButtonAction(true);
            if (fc === 'post') {
                const user = AuthService.getCurrentUser();
                let request = [];
                if (list) {
                    for (let p = 0; p < selectedIds.length; p++) {
                        request.push({
                            trxId: selectedIds[p].toString()
                        })
                    }
                } else {
                    request.push({
                        trxId: id
                    })
                }
                if (list)
                    setMessageFileUpload({ code: 'success', description: 'Post en Proceso. Se informa por email el resultado.' })


                setTimeout(() => {
                    updateList();
                }, 3000);

                informationService.post(data.crud.route, constants.CLIENT, user.data.instance, fc, user.email, request).then((response) => {

                    if (!list) {
                        if (response.data[0].status === 'OK') {
                            setMessageFileUpload({ code: 'success', description: 'Post realizado correctamente' });
                            setTimeout(() => {
                                window.location.reload();
                            }, 2000);
                        }
                        if (response.data[0].status === 'ERROR') {
                            let error = '';
                            for (let k = 0; k < response.data[0].errores.length; k++) {
                                error = error + response.data[0].errores[k] + "\r\n";
                            }
                            setMessageFileUpload({ code: 'error', description: error });
                            setTimeout(() => {
                                window.location.reload();
                            }, 2000);
                        }
                    }
                    setLoadButtonAction(false);
                }).catch((error => {
                    setMessageFileUpload({ code: 'error', description: error.message || 'Ocurrió un error inesperado' });
                    if (!list)
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                }))
            }
        }
    }

    const buttonFieldsActionList = (linkto, mode, id) => {
        setLoad(true);
        let whereParameters = '';
        for (let t = 0; t < whereFields.length; t++) {
            whereParameters = whereParameters + `&${buildParam(whereFields[t].idField, whereFields[t].operator, whereFields[t].value)}`
        }

        navigate(`/${linkto}?id=${id}&m=${mode}${whereParameters}`);
        setModeFlag(mode);
    }

    const whereFunction = (itemField) => {

        let next = true;
        let validate;
        for (let i = 0; i < itemField.where.length; i++) {
            if (itemField.where[i].field !== null && itemField.where[i].field !== undefined) {
                for (let y = 0; y < itemField.where[i].field.length; y++) {
                    if (next === true) {
                        //aca llega a obtener el ID del FIELD
                        let idField = itemField.where[i].field[y].idField;
                        switch (idField) {
                            case 'mode':
                                validate = false;
                                for (let d = 0; d < itemField.where[i].field[y].id.length; d++) {
                                    if (itemField.where[i].field[y].operator === 'in') {
                                        let idFlag = itemField.where[i].field[y].id[d];
                                        if (mode === idFlag) {
                                            validate = true;
                                        }
                                    }
                                    if (itemField.where[i].field[y].operator === 'not in') {
                                        let idFlag = itemField.where[i].field[y].id[d];
                                        if (mode === idFlag) {
                                            validate = false;
                                            break;
                                        } else {
                                            validate = true;
                                        }
                                    }
                                }
                                if (validate === false) {
                                    next = false;
                                }
                                break;
                            case 'role':
                                const user = AuthService.getCurrentUser();
                                validate = false;
                                for (let d = 0; d < itemField.where[i].field[y].id.length; d++) {
                                    if (itemField.where[i].field[y].operator === 'in') {
                                        let idFlag = itemField.where[i].field[y].id[d];
                                        if (user.data.roleId === idFlag) {
                                            validate = true;
                                        }
                                    }
                                    if (itemField.where[i].field[y].operator === 'not in') {
                                        let idFlag = itemField.where[i].field[y].id[d];
                                        if (user.data.roleId === idFlag) {
                                            validate = false;
                                            break;
                                        } else {
                                            validate = true;
                                        }
                                    }
                                }
                                if (validate === false) {
                                    next = false;
                                }
                                break;
                            default:
                                //aca llega a obtener el ID del FIELD
                                //Determino si el field con el ID obtenido tiene valor, sino tiene debe devolver false
                                //Si tiene valor, ingreso a validar el array de ID'S

                                //if (field[idField] || field[idField] === 0) {
                                validate = false;

                                for (let d = 0; d < itemField.where[i].field[y].id.length; d++) {

                                    if (itemField.where[i].field[y].operator === 'in') {
                                        if (typeof field[idField] === 'object') {
                                            if (field[idField]) {
                                                if (Number(field[idField].id) === Number(itemField.where[i].field[y].id[d])) {
                                                    validate = true;
                                                }
                                            } else {
                                                if (field[idField] === itemField.where[i].field[y].id[d]) {
                                                    validate = true;
                                                }
                                            }
                                        } else {
                                            let idFlag = itemField.where[i].field[y].id[d];
                                            if (itemField.where[i].field[y].id[d]) {
                                                idFlag = itemField.where[i].field[y].id[d].toString();
                                            }
                                            if (field[idField]) {
                                                if (field[idField].toString() === idFlag) {
                                                    validate = true;
                                                }
                                            } else {
                                                if (field[idField] === (idFlag === "true" ? true : idFlag === "false" ? false : idFlag)) {
                                                    validate = true;
                                                }
                                            }
                                        }
                                    }

                                    if (itemField.where[i].field[y].operator === 'not in') {
                                        if (typeof field[idField] === 'object') {

                                            if (field[idField]) {
                                                if (Number(field[idField].id) === Number(itemField.where[i].field[y].id[d])) {
                                                    validate = false;
                                                    break;
                                                } else {
                                                    validate = true;
                                                }
                                            }
                                            else {
                                                if (field[idField] === itemField.where[i].field[y].id[d]) {
                                                    validate = false;
                                                    break;
                                                } else {
                                                    validate = true;
                                                }
                                            }
                                        } else {
                                            let idFlag = itemField.where[i].field[y].id[d];
                                            if (itemField.where[i].field[y].id[d]) {
                                                idFlag = itemField.where[i].field[y].id[d].toString();
                                            }

                                            if (field[idField]) {
                                                if (field[idField].toString() === idFlag) {
                                                    validate = false;
                                                    break;
                                                } else {
                                                    validate = true;
                                                }
                                            } else {
                                                if (field[idField] === idFlag) {
                                                    validate = false;
                                                    break;
                                                } else {
                                                    validate = true;
                                                }
                                            }
                                        }
                                    }
                                }
                                if (validate === false) {
                                    next = false;
                                }

                                /*} else {
                                    validate = false;
                                }*/
                                break;
                        }
                    }
                }
            }
        }
        return validate;
    }

    const whereFunctionList = (itemField, row) => {

        let next = true;
        let validate;
        for (let i = 0; i < itemField.where.length; i++) {
            if (itemField.where[i].field !== null && itemField.where[i].field !== undefined) {
                for (let y = 0; y < itemField.where[i].field.length; y++) {
                    if (next === true) {
                        let idField = itemField.where[i].field[y].idField;
                        let idFieldTableList;
                        for (let b = 0; b < data.list.fields.length; b++) {
                            if (Number(idField) === Number(data.list.fields[b].id)) {
                                idFieldTableList = data.list.fields[b].idFieldTable;
                            }
                        }

                        let valueFlag = row[idFieldTableList];

                        if (valueFlag || valueFlag === 0) {
                            validate = false;

                            for (let d = 0; d < itemField.where[i].field[y].id.length; d++) {

                                if (itemField.where[i].field[y].operator === 'in') {
                                    if (typeof valueFlag === 'object') {
                                        if (Number(valueFlag.id) === Number(itemField.where[i].field[y].id[d])) {
                                            validate = true;
                                        }
                                    } else {
                                        let idFlag = itemField.where[i].field[y].id[d];
                                        if (itemField.where[i].field[y].id[d]) {
                                            idFlag = itemField.where[i].field[y].id[d].toString();
                                        }
                                        if (valueFlag.toString() === idFlag) {
                                            validate = true;
                                        }
                                    }
                                }

                                if (itemField.where[i].field[y].operator === 'not in') {

                                    if (typeof valueFlag === 'object') {
                                        if (Number(valueFlag.id) === Number(itemField.where[i].field[y].id[d])) {
                                            validate = false;
                                            break;
                                        } else {
                                            validate = true;
                                        }
                                    } else {
                                        let idFlag = itemField.where[i].field[y].id[d];
                                        if (itemField.where[i].field[y].id[d]) {
                                            idFlag = itemField.where[i].field[y].id[d].toString();
                                        }
                                        if (valueFlag.toString() === idFlag) {
                                            validate = false;
                                            break;
                                        } else {
                                            validate = true;
                                        }
                                    }
                                }
                            }
                            if (validate === false) {
                                next = false;
                            }

                        } else {
                            validate = false;
                        }
                    }
                }

            }
        }
        return validate;
    }

    const validateCurrencyFxRate = (nameGroup, index) => {
        if (nameGroup) {
            for (let y = 0; y < group[nameGroup].length; y++) {
                for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                    if (y === index) {
                        if (group[nameGroup][y].fields[i].idFieldTable === 'currencyId') {
                            let idfield = group[nameGroup][y].fields[i].id;
                            if (!field[idfield]) {
                                data.crud.boxes.forEach((itemBoxes) => {
                                    itemBoxes.fields.forEach((itemFields) => {
                                        if (itemFields.idFieldTable === 'currencyId') {
                                            let idfieldHeder = itemFields.id;
                                            if (field[idfieldHeder]) {
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idfield]: field[idfieldHeder],
                                                }), []);
                                            }
                                        }
                                    })
                                })
                            }
                        }
                        if (group[nameGroup][y].fields[i].idFieldTable === 'fxRate') {
                            let idfield = group[nameGroup][y].fields[i].id;
                            if (!field[idfield]) {
                                data.crud.boxes.forEach((itemBoxes) => {
                                    itemBoxes.fields.forEach((itemFields) => {
                                        if (itemFields.idFieldTable === 'fxRate') {
                                            let idfieldHeder = itemFields.id;
                                            if (field[idfieldHeder]) {
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idfield]: field[idfieldHeder],
                                                }), []);
                                            }
                                        }
                                    })
                                })
                            }
                        }
                    }
                }
            }
        }
    }


    const formatListNumber = (e, idParameter, item, nameGroup, index) => {
        if (mode !== 'r') {
            let changeValue = e.target.value;

            //validar si hay moneda en la linea, sino hay copia de la cabecera
            validateCurrencyFxRate(nameGroup, index);

            if (item.type === 'Currency') {
                //buscar currencyId
                changeValue = changeValue.replace(/\./g, '');
                let valueSplit = changeValue.split(',');
                let step = 2;
                if (!nameGroup) {
                    data.crud.boxes.forEach((itemBoxes) => {
                        itemBoxes.fields.forEach((itemFields) => {
                            if (itemFields.idFieldTable === 'currencyId') {
                                let idfield = itemFields.id;
                                if (field[idfield]) {
                                    for (let g = 0; g < currencys.length; g++) {
                                        if (Number(currencys[g].id) === Number(field[idfield].id)) {
                                            setFormatCurrency(prevState => ({
                                                ...prevState,
                                                [idParameter]: currencys[g].symbol,
                                            }), []);
                                            step = currencys[g].decimals;
                                        }
                                    }
                                } else {
                                    setFormatCurrency(prevState => ({
                                        ...prevState,
                                        [idParameter]: '',
                                    }), []);
                                    step = 2;
                                }
                            }
                        })
                    })
                } else {
                    for (let y = 0; y < group[nameGroup].length; y++) {
                        for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                            if (y === index) {
                                if (group[nameGroup][y].fields[i].idFieldTable === 'currencyId') {
                                    let idfield = group[nameGroup][y].fields[i].id;
                                    if (field[idfield]) {
                                        for (let g = 0; g < currencys.length; g++) {
                                            if (Number(currencys[g].id) === Number(field[idfield].id)) {
                                                setFormatCurrency(prevState => ({
                                                    ...prevState,
                                                    [idParameter]: currencys[g].symbol,
                                                }), []);
                                                step = currencys[g].decimals;
                                            }
                                        }
                                    } else {
                                        setFormatCurrency(prevState => ({
                                            ...prevState,
                                            [idParameter]: '',
                                        }), []);
                                        step = 2;
                                    }
                                }
                            }
                        }
                    }
                }
                if (valueSplit.length > 1) {
                    if (Number(valueSplit[1].length) < Number(step)) {

                        let ceros = '';
                        let dif = Number(step) - Number(valueSplit[1].length);
                        for (let o = 0; o < dif; o++) {
                            ceros = ceros + '0';
                        }
                        changeValue = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                    } else {
                        changeValue = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                    }
                } else {
                    let ceros = '';
                    for (let o = 0; o < step; o++) {
                        ceros = ceros + '0';
                    }
                    changeValue = `${valueSplit[0]},${ceros}`;
                }
                //changeValue = formatNumberWithThousandsSeparator(changeValue);
                setField(prevState => ({
                    ...prevState,
                    [idParameter]: changeValue,
                }), []);
            }

            if (item.type.includes('Percentage') || item.type.includes('Number')) {
                let step = 0;
                let decimalValueFlag;

                if (item.type.includes('Number'))
                    decimalValueFlag = item.type.split('ber');
                if (item.type.includes('Percentage')) {
                    decimalValueFlag = item.type.split('age');
                    /*let fix = 0;
                    let flag = item.type.split('age');
                    if (flag.length > 1) {
                        fix = (flag[1]);
                    }
                    changeValue = (Number(changeValue) * 100).toFixed(fix);
                    changeValue = changeValue.toString();*/
                }

                if (decimalValueFlag.length > 1) {
                    if (decimalValueFlag[1])
                        step = (decimalValueFlag[1]);

                    let valueSplit = changeValue.split(',');
                    if (valueSplit.length > 1) {
                        if (Number(valueSplit[1].length) < Number(step)) {
                            let ceros = '';
                            let dif = Number(step) - Number(valueSplit[1].length);
                            for (let o = 0; o < dif; o++) {
                                ceros = ceros + '0';
                            }
                            changeValue = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                        } else {
                            changeValue = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                        }
                    } else {
                        if (step > 0) {
                            let ceros = '';
                            for (let o = 0; o < step; o++) {
                                ceros = ceros + '0';
                            }
                            changeValue = `${valueSplit[0]},${ceros}`;
                        }
                    }
                    setField(prevState => ({
                        ...prevState,
                        [idParameter]: changeValue,
                    }), []);
                }
            }

            setCurrencyFxRate(item, field, previousValue, setField, group, changeValue, info, data);

            if (nameGroup) {

                //QTY*PRICE=AMOUNT

                let amountFlag = [];
                if (item.idFieldTable === 'qty' || item.idFieldTable === 'price') {
                    let qty = 0;
                    let price = 0;
                    let idFieldAmount = null;
                    if (item.idFieldTable === 'qty')
                        qty = changeValue
                    if (item.idFieldTable === 'price')
                        price = changeValue

                    for (let r = 0; r < group[nameGroup].length; r++) {
                        if (Number(index) === Number(r)) {
                            for (let d = 0; d < group[nameGroup][r].fields.length; d++) {
                                if (group[nameGroup][r].fields[d].idFieldTable === 'qty' && item.idFieldTable !== 'qty') {
                                    let view = true;
                                    if (group[nameGroup][r].fields[d].where !== null && group[nameGroup][r].fields[d].where !== undefined) {
                                        view = whereFunction(group[nameGroup][r].fields[d]);
                                    }
                                    if (view) {
                                        if (group[nameGroup][r].fields[d].display !== 'hidden') {
                                            if (field[group[nameGroup][r].fields[d].id]) {
                                                qty = field[group[nameGroup][r].fields[d].id];
                                            }
                                        }
                                    }
                                }
                                if (group[nameGroup][r].fields[d].idFieldTable === 'price' && item.idFieldTable !== 'price') {
                                    let view = true;
                                    if (group[nameGroup][r].fields[d].where !== null && group[nameGroup][r].fields[d].where !== undefined) {
                                        view = whereFunction(group[nameGroup][r].fields[d]);
                                    }
                                    if (view) {
                                        if (group[nameGroup][r].fields[d].display !== 'hidden') {
                                            if (field[group[nameGroup][r].fields[d].id]) {
                                                price = field[group[nameGroup][r].fields[d].id];
                                            }
                                        }
                                    }
                                }
                                if (group[nameGroup][r].fields[d].idFieldTable === 'amount') {
                                    let view = true;
                                    if (group[nameGroup][r].fields[d].where !== null && group[nameGroup][r].fields[d].where !== undefined) {
                                        view = whereFunction(group[nameGroup][r].fields[d]);
                                    }
                                    if (view) {
                                        if (group[nameGroup][r].fields[d].display !== 'hidden') {
                                            idFieldAmount = group[nameGroup][r].fields[d].id
                                        }
                                    }
                                }
                            }
                        }
                    }


                    let amount = Number(qty.toString().replace(/,/g, '.')) * Number(price.toString().replace(/,/g, '.'));


                    setField(prevState => ({
                        ...prevState,
                        [idFieldAmount]: amount,
                    }), []);

                    for (let y = 0; y < group[nameGroup].length; y++) {
                        let am = 0;
                        for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                            if (group[nameGroup][y].fields[i].idFieldTable === 'amount') {
                                am = field[group[nameGroup][0].fields[i].id];
                            }
                        }
                        if (index !== y) {
                            amountFlag.push({
                                amount: Number(am),
                                index: y
                            })
                        }
                        if (index === y) {
                            amountFlag.push({
                                amount: Number(amount),
                                index: y
                            })
                        }
                    }
                }

                let qtyFlag = [];
                if (item.idFieldTable === 'amount') {
                    let qty = 0;
                    let price = 0;
                    let amount = Number(changeValue.toString().replace(/,/g, '.'));

                    let idFieldQty = null;
                    for (let r = 0; r < group[nameGroup].length; r++) {
                        if (Number(index) === Number(r)) {
                            for (let d = 0; d < group[nameGroup][r].fields.length; d++) {
                                if (group[nameGroup][r].fields[d].idFieldTable === 'qty') {
                                    let view = true;
                                    if (group[nameGroup][r].fields[d].where !== null && group[nameGroup][r].fields[d].where !== undefined) {
                                        view = whereFunction(group[nameGroup][r].fields[d]);
                                    }

                                    if (view) {

                                        if (group[nameGroup][r].fields[d].display !== 'hidden') {
                                            idFieldQty = group[nameGroup][r].fields[d].id;

                                            if (field[group[nameGroup][r].fields[d].id]) {
                                                qty = field[group[nameGroup][r].fields[d].id];
                                            }
                                        }
                                    }

                                }
                                if (group[nameGroup][r].fields[d].idFieldTable === 'price') {
                                    let view = true;
                                    if (group[nameGroup][r].fields[d].where !== null && group[nameGroup][r].fields[d].where !== undefined) {
                                        view = whereFunction(group[nameGroup][r].fields[d]);
                                    }


                                    if (view) {


                                        if (group[nameGroup][r].fields[d].display !== 'hidden') {


                                            if (field[group[nameGroup][r].fields[d].id]) {
                                                price = field[group[nameGroup][r].fields[d].id];
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }


                    if (Number(qty.toString().replace(/,/g, '.')) === 0 && Number(price.toString().replace(/,/g, '.')) > 0) {
                        qty = Number(amount) / Number(price.toString().replace(/,/g, '.'));


                        setField(prevState => ({
                            ...prevState,
                            [idFieldQty]: qty,
                        }), []);



                        for (let y = 0; y < group[nameGroup].length; y++) {
                            let qt = 0;
                            for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                if (group[nameGroup][y].fields[i].idFieldTable === 'qty') {
                                    qt = field[group[nameGroup][0].fields[i].id];
                                }
                            }
                            if (index !== y) {
                                qtyFlag.push({
                                    qty: Number(qt),
                                    index: y
                                })
                            }
                            if (index === y) {
                                qtyFlag.push({
                                    qty: Number(qty),
                                    index: y
                                })
                            }
                        }
                    }
                }

                let trxLineTypeId = 0;
                for (let r = 0; r < group[nameGroup].length; r++) {
                    if (Number(index) === Number(r)) {
                        for (let d = 0; d < group[nameGroup][r].fields.length; d++) {
                            if (group[nameGroup][r].fields[d].idFieldTable === 'trxLineTypeId') {
                                if (field[group[nameGroup][r].fields[d].id]) {
                                    trxLineTypeId = field[group[nameGroup][r].fields[d].id].id
                                    if (Number(trxLineTypeId) === 0) {
                                        trxLineTypeId = group[nameGroup][r].fields[d].defaultValue
                                    }
                                } else {
                                    trxLineTypeId = group[nameGroup][r].fields[d].defaultValue
                                }
                            }
                        }
                    }
                }

                //if (nameGroup === 'trxLine1') {
                if (Number(trxLineTypeId) === 1) {
                    setAccountId(item, field, previousValue, data, setField, group, info, null, null);
                }

                //if (nameGroup === 'trxLine2' && data.id !== 'dividens') {
                if (Number(trxLineTypeId) === 2 && data.id !== 'dividens') {
                    trxLine.setTrxLine3(item, field, previousValue, nameGroup, data, group, addElementGroup, setField, info, setGroup, setArrayGroupDelete, id, index, false, searchFieldSource, setValueSearchSource, mode, amountFlag, qtyFlag);
                }
                //if (nameGroup === 'trxLine3') {
                if (Number(trxLineTypeId) === 3) {
                    trxLine.setTrxLine4(item, previousValue, null, null, field, data, group, addElementGroup, setField, info, setGroup, setArrayGroupDelete, id, null, index, false, searchFieldSource, setValueSearchSource, mode);
                }

                //if (nameGroup === 'trxLine4') {
                if (Number(trxLineTypeId) === 4) {
                    trxLine.setTrxLine1(field, null, group, setField, info, id, addElementGroup, setGroup, item, data, previousValue, null, null, null, setArrayGroupDelete, searchFieldSource, false, setValueSearchSource, mode);
                }

                //if (nameGroup === 'trxLine5') {
                if (Number(trxLineTypeId) === 5) {
                    trxLine.setTrxLine1(field, null, group, setField, info, id, addElementGroup, setGroup, item, data, previousValue, null, null, null, setArrayGroupDelete, searchFieldSource, false, setValueSearchSource, mode);
                }
            } else {
                updateImportes();
            }
        }
    }

    const formatNumberWithThousandsSeparator = (num) => {
        const parts = num.split(',');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return parts.join(',');
    };


    const handleCheckboxChange = (id, checked) => {
        setSelectedIds((prevSelected) =>
            checked
                ? [...prevSelected, id]
                : prevSelected.filter((selectedId) => selectedId !== id)
        );
    };

    const debouncedFetchResults = useRef(_.debounce((value, idFieldTable, whereFields, listSegmentSize, idDom, type, sourceSelect) => {
        let whereFieldParam = whereFields;
        let existe = false;
        for (let t = 0; t < whereFieldParam.length; t++) {
            if (whereFieldParam[t].idField === idFieldTable) {
                existe = true;
                whereFieldParam[t].value = value;
                whereFieldParam[t].operator = 'like';
            }
        }
        if (!existe) {
            whereFieldParam.push({
                'idField': idFieldTable,
                'operator': 'like',
                'value': value,
                'idDom': idDom,
                'type': type,
                'sourceSelect': sourceSelect
            })
        }
        setWhereFields(whereFieldParam);

        let fieldsArray = [];
        for (let p = 0; p < data.list.fields.length; p++) {
            if (data.list.fields[p].idFieldTable !== null) {
                fieldsArray.push(data.list.fields[p].idFieldTable);
            }
        }
        let fields = fieldsArray.join(",");
        //setLoad(true);
        setLoadList(true);
        setRecordCountLoad(true);
        setTotalFooterLoad(true);
        setTotalSaldoAnteriorLoad(true);
        let whereFieldsPF = JSON.parse(JSON.stringify(whereFieldParam))
        filterByTradeAccountIdManagerId(whereFieldsPF);
        informationService.searchViewList(`${instance}.${data.list.view}`, data.id, fields, 0, Number(listSegmentSize), whereFieldsPF).then((response) => {

            let arrayResponse = [];
            for (let i = 0; i < info.length; i++) {
                if (info[i].source !== data.list.view) {
                    arrayResponse.push(info[i])
                }
            }
            let arrayInitialList = [];
            for (let i = 0; i < response.data.length; i++) {
                arrayResponse.push(response.data[i]);
                arrayInitialList.push(response.data[i]);
            }
            //setInfo(arrayResponse);
            setList(arrayInitialList);
            setLoadList(false);
            informationService.searchViewListRecordCount(`${instance}.${data.list.view}`, whereFieldsPF).then((response) => {
                setRecordCount(response.data.count);
                setRecordCountLoad(false);

                informationService.searchViewListTotal(`${instance}.${data.list.view}`, fields, whereFieldsPF).then((response) => {
                    setTotalFooter(response.data);
                    setTotalFooterLoad(false);
                }).catch((error) => {
                    console.log(error);
                });
                let validateTotalHeader = false;
                let whereFieldParamFlag = JSON.parse(JSON.stringify(whereFieldsPF))
                let valueDate = null;
                let idFieldDate = null;
                for (let d = 0; d < whereFieldParamFlag.length; d++) {
                    if (whereFieldParamFlag[d].type === 'Date' && whereFieldParamFlag[d].operator === ">=") {
                        validateTotalHeader = true;
                        valueDate = whereFieldParamFlag[d].value;
                        idFieldDate = whereFieldParamFlag[d].idField;
                    }
                }
                if (validateTotalHeader && valueDate && idFieldDate) {
                    whereFieldParamFlag = whereFieldParamFlag.filter(obj => obj.type !== 'Date');

                    whereFieldParamFlag.push({
                        idField: idFieldDate,
                        operator: '<',
                        value: valueDate
                    })

                    informationService.searchViewListTotal(`${instance}.${data.list.view}`, fields, whereFieldParamFlag).then((response) => {
                        setTotalHeader(response.data);
                        setTotalSaldoAnteriorLoad(false);
                    }).catch((error) => {
                        console.log(error);
                    });
                } else {
                    setTotalHeader(null);
                    setTotalSaldoAnteriorLoad(false);
                }
            }).catch((error) => {
                console.log(error);
            });

        }).catch((error) => {
            console.log(error);
            //setLoad(false);
            setLoadList(false);
        });

    }, 2000)).current;

    const handleFieldFilterChange = (e, idFieldTable, type, idDom, sourceSelect) => {

        let value = e.target.value;
        setField(prevState => ({
            ...prevState,
            [idDom]: value,
        }), []);
        if (type === 'Switch' || type === 'Checkbox') {
            if (value.toUpperCase().includes('N') || value.toUpperCase().includes('O')) {
                value = '0';
            }
            if (value.toUpperCase().includes('S') || value.toUpperCase().includes('I')) {
                value = '1';
            }
        }


        debouncedFetchResults(value, idFieldTable, whereFields, listSegmentSize, idDom, type, sourceSelect);

    }

    const searchFieldSource = (item, changeValue) => {
        const user = AuthService.getCurrentUser();
        let arrayFieldsSourceFlag = arrayFieldsSource.concat(arrayFieldsSourceGroup);
        for (let h = 0; h < arrayFieldsSourceFlag.length; h++) {

            let existeSearchField = false;
            for (let p = 0; p < arrayFieldsSourceFlag[h].searchSource.length; p++) {
                if (arrayFieldsSourceFlag[h].searchSource[p].id.includes(item.id)) {
                    existeSearchField = true;
                }
                //modificacion 210725
                if (arrayFieldsSourceFlag[h].searchSource[p].fieldsNoAdd === true) {
                    if (Number(arrayFieldsSourceFlag[h].searchSource[p].id) === Number(item.id.split('_')[1])) {
                        existeSearchField = true;
                    }
                }
                //modificacion 210725
            }

            if (existeSearchField) {
                if (mode !== 'c' && mode !== 'u') {

                    if (field[arrayFieldsSourceFlag[h].id]) {
                        existeSearchField = false;
                    }
                }

                if (existeSearchField) {
                    let fieldsRequest = [];
                    let table = arrayFieldsSourceFlag[h].search;
                    let valueSearch = arrayFieldsSourceFlag[h].idFieldTable;
                    let idField = arrayFieldsSourceFlag[h].id;
                    let sourceSelect = arrayFieldsSourceFlag[h].sourceSelect;
                    if (arrayFieldsSourceFlag[h].type === 'Select') {
                        setField(prevState => ({
                            ...prevState,
                            [idField]: null,
                        }), []);
                    } else {
                        setField(prevState => ({
                            ...prevState,
                            [idField]: '',
                        }), []);
                    }

                    for (let p = 0; p < arrayFieldsSourceFlag[h].searchSource.length; p++) {

                        let idFieldTable = arrayFieldsSourceFlag[h].searchSource[p].idFieldTable;
                        let fieldFlag = idFieldTable.replace('Id', '');
                        if (fieldFlag === arrayFieldsSourceFlag[h].search) {
                            idFieldTable = 'id';
                        }

                        //modificacion 210725
                        let searchSourceId = arrayFieldsSourceFlag[h].searchSource[p].id;
                        if (arrayFieldsSourceFlag[h].searchSource[p].fieldsNoAdd === true) {
                            searchSourceId = item.id;
                        }
                        //modificacion 210725
                        if (item.id === searchSourceId) {
                            if (typeof changeValue === 'object') {
                                if (changeValue)
                                    fieldsRequest.push({
                                        id: idFieldTable,
                                        value: changeValue.id
                                    })
                            } else {
                                fieldsRequest.push({
                                    id: idFieldTable,
                                    value: changeValue
                                })
                            }
                        } else {

                            if (typeof field[searchSourceId] === 'object') {

                                if (field[searchSourceId])
                                    fieldsRequest.push({
                                        id: idFieldTable,
                                        value: field[searchSourceId].id
                                    })
                                else
                                    fieldsRequest.push({
                                        id: idFieldTable,
                                        value: null
                                    })
                            } else {
                                fieldsRequest.push({
                                    id: idFieldTable,
                                    value: field[searchSourceId]
                                })
                            }
                        }

                    }


                    let validateRequest = true;
                    for (let g = 0; g < fieldsRequest.length; g++) {
                        if (fieldsRequest[g].value === null)
                            validateRequest = false;
                    }


                    if (fieldsRequest.length > 0 && validateRequest) {

                        informationService.searchSource(table, instance, fieldsRequest).then((response) => {

                            if (response.data.length > 0) {

                                let newChangeValue = null;
                                if (arrayFieldsSourceFlag[h].type === 'Select') {

                                    let idSearch;
                                    let label;

                                    if (response.data.length === 1) {

                                        idSearch = response.data[0][valueSearch];

                                        if (idSearch === undefined || idSearch === null) {
                                            idSearch = response.data[0].id;
                                        }

                                        if (info.length > 0) {

                                            for (const inf of info) {
                                                if (inf.source === sourceSelect) {
                                                    if (Number(inf.id) === Number(idSearch)) {
                                                        label = inf.nameAlt !== undefined ? `${inf.name} ${inf.nameAlt}` : `${inf.name}`
                                                    }
                                                }
                                            }

                                            newChangeValue = {
                                                id: idSearch,
                                                label: label
                                            }

                                            if (label)
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idField]: newChangeValue,
                                                }), []);
                                            globalFunctions.globalFunctionsDocs(mode, load, loadGroup, arrayFieldsSourceFlag[h], arrayFieldsSourceFlag[h].nameGroup, user, newChangeValue, data, setField, instance, paymentTerm, arrayFieldsSourceFlag[h].orderBox, field, AuthService, group, id, arrayFieldsSourceFlag[h].index, info);
                                        } else {

                                            let whereFilters = [];
                                            filterByTradeAccountIdManagerId(whereFilters);
                                            let arrayTables = [];
                                            arrayTables.push({
                                                table: `${user.data.instance}.${sourceSelect}`,
                                                doc: [],
                                                selectFilters: [],
                                                whereFilters: whereFilters
                                            })

                                            informationService.findSourceField(arrayTables).then((response) => {
                                                const res = response.data;
                                                for (const inf of res) {
                                                    if (inf.source === sourceSelect) {
                                                        if (Number(inf.id) === Number(idSearch)) {
                                                            label = inf.nameAlt !== undefined ? `${inf.name} ${inf.nameAlt}` : `${inf.name}`
                                                        }
                                                    }
                                                }
                                                newChangeValue = {
                                                    id: idSearch,
                                                    label: label
                                                }

                                                if (label)
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: newChangeValue,
                                                    }), []);
                                                globalFunctions.globalFunctionsDocs(mode, load, loadGroup, arrayFieldsSourceFlag[h], arrayFieldsSourceFlag[h].nameGroup, user, newChangeValue, data, setField, instance, paymentTerm, arrayFieldsSourceFlag[h].orderBox, field, AuthService, group, id, arrayFieldsSourceFlag[h].index, info);
                                            })
                                        }
                                    }
                                } else {
                                    if (arrayFieldsSourceFlag[h].type === 'Currency' || arrayFieldsSourceFlag[h].type.includes('Number')) {
                                        let valueFlag = response.data[0][valueSearch];
                                        if (valueFlag) {
                                            valueFlag = valueFlag.replace(/\./g, ',');
                                            if (mode === 'r')
                                                valueFlag = formatNumberWithThousandsSeparator(valueFlag);
                                        }

                                        if (arrayFieldsSourceFlag[h].type === 'Currency') {
                                            let step = 2;
                                            data.crud.boxes.forEach((itemBoxes) => {
                                                itemBoxes.fields.forEach((itemFields) => {
                                                    if (itemFields.idFieldTable === 'currencyId') {
                                                        let idfield1 = itemFields.id;
                                                        if (field[idfield1]) {
                                                            for (let g = 0; g < currencys.length; g++) {
                                                                if (Number(currencys[g].id) === Number(field[idfield1].id)) {
                                                                    setFormatCurrency(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: currencys[g].symbol,
                                                                    }), []);
                                                                    step = currencys[g].decimals;
                                                                }
                                                            }
                                                        } else {
                                                            setFormatCurrency(prevState => ({
                                                                ...prevState,
                                                                [idField]: '',
                                                            }), []);
                                                        }
                                                    }
                                                })
                                            })
                                            let value = valueFlag.split(',');

                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: `${value[0]},${value[1].slice(0, step)}`
                                            }), []);
                                            newChangeValue = `${value[0]},${value[1].slice(0, step)}`;
                                        } else {
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: valueFlag
                                            }), []);
                                            newChangeValue = valueFlag;
                                        }
                                        globalFunctions.globalFunctionsDocs(mode, load, loadGroup, arrayFieldsSourceFlag[h], arrayFieldsSourceFlag[h].nameGroup, user, valueFlag, data, setField, instance, paymentTerm, arrayFieldsSourceFlag[h].orderBox, field, AuthService, group, id, arrayFieldsSourceFlag[h].index, info);
                                    } else {

                                        setField(prevState => ({
                                            ...prevState,
                                            [idField]: response.data[0][valueSearch]
                                        }), []);
                                        newChangeValue = response.data[0][valueSearch];
                                        globalFunctions.globalFunctionsDocs(mode, load, loadGroup, arrayFieldsSourceFlag[h], arrayFieldsSourceFlag[h].nameGroup, user, response.data[0][valueSearch], data, setField, instance, paymentTerm, arrayFieldsSourceFlag[h].orderBox, field, AuthService, group, id, arrayFieldsSourceFlag[h].index, info);
                                    }

                                }
                                //modificacion 230825
                                searchFieldSource({ id: idField }, newChangeValue);
                                //modificacion 230825
                                //modificacion 210725

                            } else {
                                if (arrayFieldsSourceFlag[h].type === 'Currency' || arrayFieldsSourceFlag[h].type.includes('Number'))
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: 0
                                    }), []);
                                if (arrayFieldsSourceFlag[h].type === 'Select')
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: {
                                            id: '',
                                            label: ''
                                        }
                                    }), []);
                                if (arrayFieldsSourceFlag[h].type === 'TextField')
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: ''
                                    }), []);
                            }
                        }).catch((error) => {
                            console.log(error);
                        })
                    }
                }
            }
        }

    }

    const handleFieldChange = (e, newValue, id, item, nameGroup, index, nameField, ultimaLinea, design, orderBox, doc, idRecordGroup) => {
        try {

            let valiteContinues = false;
            if (item.type === 'Currency' || item.type.includes('Number') || item.type.includes('Porcentage')) {
                if (/^[\d,.-]*$/.test(e.target.value)) {
                    valiteContinues = true;
                }
            } else {
                if (item.type !== 'Currency' && !item.type.includes('Number') && !item.type.includes('Porcentage'))
                    valiteContinues = true;
            }

            if (item.idFieldTable === 'trxPropId') {
                if (previousValue[id]) {
                    if (Number(previousValue[id].id) !== Number(newValue.id)) {
                        setField(initialField(data));
                        setGroup(initialArrayGroup(data.crud));
                        setArrayGroupDelete(initialArrayGroup(data.crud));
                        initialDoc.initialDocHeader(data, info, setField);
                        initialDoc.initialDocGroup(data, info, setField, setGroup);
                    }
                }
            }
            if (nameGroup) {
                let trxLineTypeId = 0;
                for (let r = 0; r < group[nameGroup].length; r++) {
                    for (let d = 0; d < group[nameGroup][r].fields.length; d++) {
                        if (group[nameGroup][r].fields[d].idFieldTable === 'trxLineTypeId') {
                            if (field[group[nameGroup][r].fields[d].id])
                                trxLineTypeId = field[group[nameGroup][r].fields[d].id].id
                        }
                    }
                }
                if (Number(trxLineTypeId) === 5 && item.idFieldTable === 'itemPropertyId') {
                    if (group[nameGroup].length > 1) {
                        for (let y = 0; y < group[nameGroup].length - 1; y++) {
                            for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                if (group[nameGroup][y].fields[i].idFieldTable === 'itemPropertyId') {
                                    if (field[group[nameGroup][y].fields[i].id] && newValue) {
                                        if (Number(field[group[nameGroup][y].fields[i].id].id) === Number(newValue.id)) {
                                            valiteContinues = false;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            if (valiteContinues === true) {

                let changeValue;

                if (e !== null) {
                    changeValue = e.target.value;
                    if (e.target.type === 'checkbox') {
                        changeValue = e.target.checked;
                        if (item.function === 'addColumn') {
                            setViewId(e.target.checked);
                        }
                        if (item.function === 'addSelection') {
                            setPosted(e.target.checked);
                        }

                        if (mode === 'l' && item.function === 'addFilter') {
                            //setLoad(true);
                            setLoadList(true);
                            let whereFieldParam = whereFields;
                            let existe = false;
                            let value = '0';

                            if (e.target.checked === false) {
                                for (let t = 0; t < whereFieldParam.length; t++) {
                                    if (whereFieldParam[t].idField === item.idFieldTable && whereFieldParam[t].operator === item.operator) {
                                        existe = true;
                                        whereFieldParam[t].value = value;
                                        whereFieldParam[t].operator = item.operator;
                                    }
                                }
                                if (!existe) {
                                    whereFieldParam.push({
                                        'idField': item.idFieldTable,
                                        'operator': item.operator,
                                        'value': value,
                                        'idDom': id,
                                        'type': item.type,
                                        'sourceSelect': item.sourceSelect
                                    })
                                }

                            }
                            if (e.target.checked === true) {
                                //whereFieldParam = whereFieldParam.filter(obj => obj.idField !== item.idFieldTable);
                                whereFieldParam = whereFieldParam.filter(obj =>
                                    !(obj.idField === item.idFieldTable && obj.operator === item.operator)
                                );
                            }
                            setWhereFields(whereFieldParam);

                            let fieldsArray = [];
                            for (let p = 0; p < data.list.fields.length; p++) {
                                if (data.list.fields[p].idFieldTable !== null) {
                                    fieldsArray.push(data.list.fields[p].idFieldTable);
                                }
                            }
                            let fields = fieldsArray.join(",");
                            setRecordCountLoad(true);
                            setTotalFooterLoad(true);
                            setTotalSaldoAnteriorLoad(true);
                            let whereFieldsPF = JSON.parse(JSON.stringify(whereFieldParam))
                            filterByTradeAccountIdManagerId(whereFieldsPF);
                            informationService.searchViewList(`${instance}.${data.list.view}`, data.id, fields, 0, Number(listSegmentSize), whereFieldsPF).then((response) => {

                                let arrayResponse = [];
                                for (let i = 0; i < info.length; i++) {
                                    if (info[i].source !== data.list.view) {
                                        arrayResponse.push(info[i])
                                    }
                                }
                                let arrayInitialList = [];
                                for (let i = 0; i < response.data.length; i++) {
                                    arrayResponse.push(response.data[i]);
                                    arrayInitialList.push(response.data[i]);
                                }
                                //setInfo(arrayResponse);
                                setList(arrayInitialList);
                                //setLoad(false);
                                setLoadList(false);
                                informationService.searchViewListRecordCount(`${instance}.${data.list.view}`, whereFieldsPF).then((response) => {
                                    setRecordCount(response.data.count)
                                    setRecordCountLoad(false);

                                    informationService.searchViewListTotal(`${instance}.${data.list.view}`, fields, whereFieldsPF).then((response) => {
                                        setTotalFooter(response.data);
                                        setTotalFooterLoad(false);
                                    }).catch((error) => {
                                        console.log(error);
                                    });

                                    let validateTotalHeader = false;
                                    let whereFieldParamFlag = JSON.parse(JSON.stringify(whereFieldsPF))
                                    let valueDate = null;
                                    let idFieldDate = null;
                                    for (let d = 0; d < whereFieldParamFlag.length; d++) {
                                        if (whereFieldParamFlag[d].type === 'Date' && whereFieldParamFlag[d].operator === ">=") {
                                            validateTotalHeader = true;
                                            valueDate = whereFieldParamFlag[d].value;
                                            idFieldDate = whereFieldParamFlag[d].idField;
                                        }

                                    }
                                    if (validateTotalHeader && valueDate && idFieldDate) {
                                        whereFieldParamFlag = whereFieldParamFlag.filter(obj => obj.type !== 'Date');

                                        whereFieldParamFlag.push({
                                            idField: idFieldDate,
                                            operator: '<',
                                            value: valueDate
                                        })


                                        informationService.searchViewListTotal(`${instance}.${data.list.view}`, fields, whereFieldParamFlag).then((response) => {
                                            setTotalHeader(response.data);
                                            setTotalSaldoAnteriorLoad(false);

                                        }).catch((error) => {
                                            console.log(error);
                                        });
                                    } else {
                                        setTotalHeader(null);
                                        setTotalSaldoAnteriorLoad(false);
                                    }

                                }).catch((error) => {
                                    console.log(error);
                                });


                            }).catch((error) => {
                                console.log(error);
                                //setLoad(false);
                                setLoadList(false);
                            });
                        }
                    }
                    if (e.target.type === 'file') {
                        changeValue = e.target.files[0]
                    }
                    if (mode === 'l' && item.function === null) {

                        //setLoad(true);
                        let whereFieldParam = whereFields;
                        let existe = false;
                        let value = null;
                        let validate = null;
                        let validateSearchView = true;
                        if (item.function === null) {
                            if (item.type === 'Select') {
                                if (newValue) {
                                    value = `'${newValue.id}'`;
                                    validate = newValue.id;
                                }
                            } else {
                                value = `'${changeValue}'`;
                                validate = changeValue
                            }

                            if (validate !== null) {
                                for (let t = 0; t < whereFieldParam.length; t++) {
                                    if (whereFieldParam[t].idField === item.idFieldTable && whereFieldParam[t].operator === item.operator) {
                                        existe = true;
                                        whereFieldParam[t].value = value;
                                        whereFieldParam[t].operator = item.operator;
                                    }
                                }
                                if (!existe) {
                                    whereFieldParam.push({
                                        'idField': item.idFieldTable,
                                        'operator': item.operator,
                                        'value': value,
                                        'idDom': id,
                                        'type': item.type,
                                        'sourceSelect': item.sourceSelect
                                    })
                                }
                            }
                            if (validate === null) {
                                let countBefore = whereFieldParam.length;
                                whereFieldParam = whereFieldParam.filter(obj =>
                                    !(obj.idField === item.idFieldTable && obj.operator === item.operator)
                                );
                                let countAfter = whereFieldParam.length;
                                if (countBefore === countAfter)
                                    validateSearchView = false;
                            }

                            setWhereFields(whereFieldParam);
                        }
                        if (validateSearchView) {
                            setLoadList(true);
                            let fieldsArray = [];
                            for (let p = 0; p < data.list.fields.length; p++) {
                                if (data.list.fields[p].idFieldTable !== null) {
                                    fieldsArray.push(data.list.fields[p].idFieldTable);
                                }
                            }
                            let fields = fieldsArray.join(",");
                            setRecordCountLoad(true);
                            setTotalFooterLoad(true)
                            setTotalSaldoAnteriorLoad(true)
                            let whereFieldsPF = JSON.parse(JSON.stringify(whereFieldParam))
                            filterByTradeAccountIdManagerId(whereFieldsPF);
                            informationService.searchViewList(`${instance}.${data.list.view}`, data.id, fields, 0, Number(listSegmentSize), whereFieldsPF).then((response) => {

                                let arrayResponse = [];
                                for (let i = 0; i < info.length; i++) {
                                    if (info[i].source !== data.list.view) {
                                        arrayResponse.push(info[i])
                                    }
                                }
                                let arrayInitialList = [];
                                for (let i = 0; i < response.data.length; i++) {
                                    arrayResponse.push(response.data[i]);
                                    arrayInitialList.push(response.data[i]);
                                }
                                setList(arrayInitialList);
                                setLoadList(false);


                                informationService.searchViewListRecordCount(`${instance}.${data.list.view}`, whereFieldsPF).then((response) => {
                                    setRecordCount(response.data.count)
                                    setRecordCountLoad(false);

                                    informationService.searchViewListTotal(`${instance}.${data.list.view}`, fields, whereFieldsPF).then((response) => {
                                        setTotalFooter(response.data);
                                        setTotalFooterLoad(false)
                                    }).catch((error) => {
                                        console.log(error);
                                    });

                                    let validateTotalHeader = false;
                                    let whereFieldParamFlag = JSON.parse(JSON.stringify(whereFieldsPF))
                                    let valueDate = null;
                                    let idFieldDate = null;
                                    for (let d = 0; d < whereFieldParamFlag.length; d++) {
                                        if (whereFieldParamFlag[d].type === 'Date' && whereFieldParamFlag[d].operator === ">=") {
                                            validateTotalHeader = true;
                                            valueDate = whereFieldParamFlag[d].value;
                                            idFieldDate = whereFieldParamFlag[d].idField;
                                        }
                                    }

                                    if (validateTotalHeader && valueDate && idFieldDate) {
                                        whereFieldParamFlag = whereFieldParamFlag.filter(obj => obj.type !== 'Date');

                                        whereFieldParamFlag.push({
                                            idField: idFieldDate,
                                            operator: '<',
                                            value: valueDate
                                        })

                                        informationService.searchViewListTotal(`${instance}.${data.list.view}`, fields, whereFieldParamFlag).then((response) => {
                                            setTotalHeader(response.data)
                                            setTotalSaldoAnteriorLoad(false)

                                        }).catch((error) => {
                                            console.log(error);
                                        });
                                    } else {
                                        setTotalHeader(null);
                                        setTotalSaldoAnteriorLoad(false)
                                    }

                                }).catch((error) => {
                                    console.log(error);
                                });


                            }).catch((error) => {
                                console.log(error);
                                //setLoad(false);
                                setLoadList(false);
                            });


                        }
                    }
                }

                if (item.type === 'Select') {//MODIFICACION
                    changeValue = newValue;
                }

                let newValueParameter = changeValue;
                let oldValueParameter = field[id];
                if (typeof newValueParameter === 'object' && newValueParameter !== null)
                    newValueParameter = changeValue.label;
                if (typeof oldValueParameter === 'object' && oldValueParameter !== null)
                    oldValueParameter = field[id].label;

                auditChange(id, newValueParameter, oldValueParameter, nameField, item, null, null);

                if (nameGroup)
                    auditChange(id, newValueParameter, oldValueParameter, nameField, item, doc, idRecordGroup);

                if (item.type.includes('Number') || item.type.includes('Percentage')) {
                    /*let decimalValueFlag;
                    if (item.type.includes('Percentage')) {
                        decimalValueFlag = item.type.split('age');

                    }*/
                    changeValue = changeValue.replace(/\./g, ',');
                    //let step = 0;

                    /*if (item.type.includes('Number'))
                        decimalValueFlag = item.type.split('ber');

                    if (decimalValueFlag.length > 1) {
                        step = (decimalValueFlag[1]);
                        let valueSplit = changeValue.split(',');
                        if (valueSplit.length > 1) {
                            changeValue = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                        }
                    }*/
                    if (mode === 'r')
                        changeValue = formatNumberWithThousandsSeparator(changeValue);
                }

                if (item.type === 'Currency') {
                    //buscar currencyId
                    changeValue = changeValue.replace(/\./g, ',');
                    //let valueSplit = changeValue.split(',');
                    //let step = 2;
                    if (!nameGroup) {
                        data.crud.boxes.forEach((itemBoxes) => {
                            itemBoxes.fields.forEach((itemFields) => {
                                if (itemFields.idFieldTable === 'currencyId') {
                                    let idfield = itemFields.id;

                                    if (field[idfield]) {
                                        for (let g = 0; g < currencys.length; g++) {
                                            if (Number(currencys[g].id) === Number(field[idfield].id)) {
                                                setFormatCurrency(prevState => ({
                                                    ...prevState,
                                                    [id]: currencys[g].symbol,
                                                }), []);
                                                //step = currencys[g].decimals;
                                            }
                                        }
                                    } else {
                                        setFormatCurrency(prevState => ({
                                            ...prevState,
                                            [id]: '',
                                        }), []);
                                        //step = 2;
                                    }
                                }
                            })
                        })
                    } else {
                        for (let y = 0; y < group[nameGroup].length; y++) {
                            for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                if (y === index) {
                                    if (group[nameGroup][y].fields[i].idFieldTable === 'currencyId') {
                                        let idfield = group[nameGroup][y].fields[i].id;
                                        if (field[idfield]) {
                                            for (let g = 0; g < currencys.length; g++) {
                                                if (Number(currencys[g].id) === Number(field[idfield].id)) {
                                                    setFormatCurrency(prevState => ({
                                                        ...prevState,
                                                        [id]: currencys[g].symbol,
                                                    }), []);
                                                    //step = currencys[g].decimals;
                                                }
                                            }
                                        } else {
                                            setFormatCurrency(prevState => ({
                                                ...prevState,
                                                [id]: '',
                                            }), []);
                                            //step = 2;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    /*if (valueSplit.length > 1) {
                        changeValue = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                    } else
                        changeValue = `${valueSplit[0] !== "" ? valueSplit[0] : "0"},00`;*/
                    if (mode === 'r')
                        changeValue = formatNumberWithThousandsSeparator(changeValue);
                }

                if (item.idFieldTable === 'currencyId') {
                    let objetCurrency = {};
                    if (changeValue !== null) {
                        for (let g = 0; g < currencys.length; g++) {
                            if (Number(currencys[g].id) === Number(changeValue.id)) {
                                objetCurrency = {
                                    symbol: currencys[g].symbol,
                                    decimals: currencys[g].decimals
                                }
                            }
                        }
                        if (!nameGroup) {
                            data.crud.boxes.forEach((itemBoxes) => {
                                itemBoxes.fields.forEach((itemFields) => {
                                    if (itemFields.type === 'Currency') {
                                        let idfield = itemFields.id;
                                        setFormatCurrency(prevState => ({
                                            ...prevState,
                                            [idfield]: objetCurrency.symbol
                                        }), []);
                                    }
                                })
                            })
                        } else {
                            for (let y = 0; y < group[nameGroup].length; y++) {
                                for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                    if (y === index) {
                                        let idfield = group[nameGroup][y].fields[i].id;
                                        setFormatCurrency(prevState => ({
                                            ...prevState,
                                            [idfield]: objetCurrency.symbol
                                        }), []);
                                    }
                                }
                            }
                        }
                    }
                }

                //MODIFICACION 22/08/25 !!!IMPORTANTE VER TEMA SOURCING*********
                if (mode === 'r' || mode === 'd') {
                    if (changeValue !== null) {
                        setField(prevState => ({
                            ...prevState,
                            [id]: changeValue,
                        }), []);

                        //function search field
                        searchFieldSource(item, changeValue);
                    }
                } else {

                    setField(prevState => ({
                        ...prevState,
                        [id]: changeValue,
                    }), []);
                    if (changeValue !== null) {
                        //function search field
                        searchFieldSource(item, changeValue);
                    }
                }

                //MODIFICACION 22/08/25 !!!IMPORTANTE VER TEMA SOURCING*********

                const user = AuthService.getCurrentUser();
                globalFunctions.globalFunctionsDocs(mode, load, loadGroup, item, nameGroup, user, changeValue, data, setField, instance, paymentTerm, orderBox, field, AuthService, group, id, index, info);

            }

        } catch (error) {
            console.log('error handle field change-< ' + error)
        }

    };

    const handlePucCuitChange = (responsePUC, nameGroup, index, uifsro, idField, item) => {
        if (responsePUC !== null) {
            setFieldPUCDatosPersonales(responsePUC.data, nameGroup, index, uifsro);
        }
        //validar si hay moneda en la linea, sino hay copia de la cabecera
        validateCurrencyFxRate(nameGroup, index);
        if (!nameGroup)
            updateImportes();
    }

    const setFieldPUCDatosPersonales = (pucAFIP, nameGroup, index, uifsro) => {

        let tipoPersonaafip;

        if (pucAFIP.personaReturn) {
            if (pucAFIP.personaReturn.datosGenerales) {
                tipoPersonaafip = pucAFIP.personaReturn.datosGenerales.tipoPersona;
            }
        }

        let tipoPersona;
        if (tipoPersonaafip === 'FISICA') {
            tipoPersona = { id: 1, label: 'Humana' }
        }
        if (tipoPersonaafip === 'JURIDICA') {
            tipoPersona = { id: 2, label: 'Jurídica' }
        }

        let tipoClave;
        info.forEach((item) => {
            if (item.name === pucAFIP.personaReturn.datosGenerales.tipoClave) {
                tipoClave = {
                    id: item.id,
                    label: item.nameAlt !== undefined ? `${item.name} ${item.nameAlt}` : `${item.name}`,
                }
            }
        })

        let impuestos = "";
        if (pucAFIP.personaReturn.datosRegimenGeneral) {
            for (let u = 0; u < pucAFIP.personaReturn.datosRegimenGeneral.impuesto.length; u++) {
                impuestos = `${pucAFIP.personaReturn.datosRegimenGeneral.impuesto[u].periodo} ${pucAFIP.personaReturn.datosRegimenGeneral.impuesto[u].descripcionImpuesto}, ${impuestos}`;
            }
        }
        let actividadAFIP = [];
        let actividades = "";
        if (pucAFIP.personaReturn.datosRegimenGeneral) {
            for (let u = 0; u < pucAFIP.personaReturn.datosRegimenGeneral.actividad.length; u++) {
                actividades = `${pucAFIP.personaReturn.datosRegimenGeneral.actividad[u].idActividad} | ${pucAFIP.personaReturn.datosRegimenGeneral.actividad[u].descripcionActividad} ${actividades}`
                info.forEach((item) => {
                    if (Number(item.name) === Number(pucAFIP.personaReturn.datosRegimenGeneral.actividad[u].idActividad)) {
                        actividadAFIP.push({
                            order: pucAFIP.personaReturn.datosRegimenGeneral.actividad[u].orden,
                            actividad: {
                                id: item.id,
                                label: item.nameAlt !== undefined ? `${item.name} ${item.nameAlt}` : `${item.name}`,
                            }
                        });
                    }
                })
            }
        }
        let dni = '';
        let tipoDocDni;
        if (pucAFIP.personaReturn.datosGenerales.idPersona.toString().substring(0, 1) !== '3') {
            dni = pucAFIP.personaReturn.datosGenerales.idPersona.toString().substring(2, Number(pucAFIP.personaReturn.datosGenerales.idPersona.toString().length) - 1);
            tipoDocDni = {
                id: 37,
                label: 'DNI',
            }
        }

        let monotributo;
        if (pucAFIP.personaReturn.datosMonotributo) {
            if (pucAFIP.personaReturn.datosMonotributo.categoriaMonotributo) {
                monotributo = {
                    id: 6,
                    label: 'Responsable Monotributo'
                }
            }
        }
        let isAutonomo = false;
        if (pucAFIP.personaReturn.datosRegimenGeneral)
            if (pucAFIP.personaReturn.datosRegimenGeneral.categoriaAutonomo)
                isAutonomo = true;

        if (nameGroup === null) {
            data.crud.boxes.forEach((itemBoxs) => {
                itemBoxs.fields.forEach((item) => {
                    if (item.group === null) {
                        let idField = item.id;
                        switch (item.idFieldTable) {
                            case 'argAfipVatConditionId':
                                if (monotributo)
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: monotributo
                                    }), []);
                                break;
                            case 'argCategoriaMonotributo':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosMonotributo != null ? `${pucAFIP.personaReturn.datosMonotributo.categoriaMonotributo.descripcionCategoria}` : '',
                                }), []);
                                break;
                            case 'isAutonomo':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: isAutonomo
                                }), []);
                                break;
                            case 'argCategoriaAutonomo':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosRegimenGeneral != null ? pucAFIP.personaReturn.datosRegimenGeneral.categoriaAutonomo : '',
                                }), []);
                                break;
                            case 'argUifSRO':
                                if (uifsro) {

                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: uifsro
                                    }), []);
                                }

                                break;
                            case 'argAfipPUC':
                                if (tipoDocDni)
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: pucAFIP
                                    }), []);
                                break;
                            case 'argAfipPinTypeId':
                                if (tipoDocDni)
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: tipoDocDni
                                    }), []);
                                break;
                            case 'firstName':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosGenerales.nombre
                                }), []);
                                break;
                            case 'argAfipNombre':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosGenerales.nombre
                                }), []);
                                break;
                            case 'lastName':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosGenerales.apellido,
                                }), []);
                                break;
                            case 'argAfipApellido':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosGenerales.apellido
                                }), []);
                                break;
                            case 'name':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosGenerales.razonSocial == null ? `${pucAFIP.personaReturn.datosGenerales.apellido}, ${pucAFIP.personaReturn.datosGenerales.nombre}` : pucAFIP.personaReturn.datosGenerales.razonSocial,
                                }), []);
                                break;
                            case 'fullName':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosGenerales.razonSocial == null ? `${pucAFIP.personaReturn.datosGenerales.apellido}, ${pucAFIP.personaReturn.datosGenerales.nombre}` : pucAFIP.personaReturn.datosGenerales.razonSocial,
                                }), []);
                                break;
                            case 'beneficiary':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosGenerales.razonSocial == null ? `${pucAFIP.personaReturn.datosGenerales.apellido}, ${pucAFIP.personaReturn.datosGenerales.nombre}` : pucAFIP.personaReturn.datosGenerales.razonSocial,
                                }), []);
                                break;
                            case 'argAfipEstadoClave':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosGenerales.estadoClave,
                                }), []);
                                break;
                            case 'argAfipTipoPersona':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: tipoPersonaafip
                                }), []);
                                break;
                            case 'argAfipRazonSocial':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosGenerales.razonSocial,
                                }), []);
                                break;
                            case 'argAfipDomicilio':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: `${pucAFIP.personaReturn.datosGenerales.domicilioFiscal.tipoDomicilio} ${pucAFIP.personaReturn.datosGenerales.domicilioFiscal.direccion} ${pucAFIP.personaReturn.datosGenerales.domicilioFiscal.codPostal} ${pucAFIP.personaReturn.datosGenerales.domicilioFiscal.descripcionProvincia}`,
                                }), []);
                                break;
                            case 'argAfipImpuesto':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: impuestos
                                }), []);
                                break;
                            case 'argAfipCategoriaAutonomo':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosRegimenGeneral != null ? pucAFIP.personaReturn.datosRegimenGeneral.categoriaAutonomo : '',
                                }), []);
                                break;
                            case 'argAfipActividad':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: actividades
                                }), []);
                                break;
                            case 'argAfipActividadMonotributista':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosMonotributo != null ? `${pucAFIP.personaReturn.datosMonotributo.actividadMonotributista.descripcionActividad}` : '',
                                }), []);
                                break;
                            case 'argAfipCategoriaMonotributo':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosMonotributo != null ? `${pucAFIP.personaReturn.datosMonotributo.categoriaMonotributo.descripcionCategoria}` : '',
                                }), []);
                                break;
                            case 'argAfipFechaContratoSocial':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosGenerales.fechaContratoSocial,
                                }), []);
                                break;
                            case 'entityTypeId':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: tipoPersona
                                }), []);
                                break;
                            case 'argAfipTinTypeId':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: tipoClave
                                }), []);
                                break;
                            case 'legalName':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosGenerales.razonSocial,
                                }), []);
                                break;
                            case 'argTin':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: pucAFIP.personaReturn.datosGenerales.idPersona,
                                }), []);
                                break;
                            case 'argPin':
                                setField(prevState => ({
                                    ...prevState,
                                    [idField]: dni,
                                }), []);
                                break;
                            default:
                                break;
                        }
                    } else {

                        item.group.forEach((item) => {
                            if (group[nameGroup]) {
                                for (let y = 0; y < group[nameGroup].length; y++) {
                                    for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                        let id = group[nameGroup][y].fields[i].id;
                                        switch (group[nameGroup][y].fields[i].idFieldTable) {
                                            case 'argAfipNaesId':
                                                for (let e = 0; e < actividadAFIP.length; e++) {
                                                    if (e === 0) {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [id]: actividadAFIP[e].actividad
                                                        }), []);
                                                    } else {

                                                        group[nameGroup][y].fields[i].value = actividadAFIP[e].actividad;
                                                    }
                                                }
                                                break;
                                            case 'order':
                                                for (let e = 0; e < actividadAFIP.length; e++) {
                                                    if (e === 0) {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [id]: actividadAFIP[e].order
                                                        }), []);
                                                    } else {
                                                        group[nameGroup][y].fields[i].value = actividadAFIP[e].order;
                                                    }
                                                }
                                                break;
                                            default:
                                                break;
                                        }
                                    }
                                }
                            }
                        })
                    }
                })
            })
        } else {
            let tipoClaveGrupo = tipoClave;
            for (let y = 0; y < group[nameGroup].length; y++) {
                for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                    if (y === index) {
                        let id = group[nameGroup][y].fields[i].id;
                        switch (group[nameGroup][y].fields[i].idFieldTable) {
                            case 'argAfipVatConditionId':
                                if (monotributo)
                                    setField(prevState => ({
                                        ...prevState,
                                        [id]: monotributo
                                    }), []);
                                break;
                            case 'argCategoriaMonotributo':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosMonotributo != null ? `${pucAFIP.personaReturn.datosMonotributo.categoriaMonotributo.descripcionCategoria}` : '',
                                }), []);
                                break;
                            case 'isAutonomo':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: isAutonomo
                                }), []);
                                break;
                            case 'argCategoriaAutonomo':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosRegimenGeneral != null ? pucAFIP.personaReturn.datosRegimenGeneral.categoriaAutonomo : '',
                                }), []);
                                break;
                            case 'argAfipNaesId':
                                for (let e = 0; e < actividadAFIP.length; e++) {
                                    if (e === 0) {
                                        setField(prevState => ({
                                            ...prevState,
                                            [id]: actividadAFIP[e].actividad
                                        }), []);
                                    }
                                }
                                break;
                            case 'order':
                                for (let e = 0; e < actividadAFIP.length; e++) {
                                    if (e === 0) {
                                        setField(prevState => ({
                                            ...prevState,
                                            [id]: actividadAFIP[e].order
                                        }), []);
                                    }
                                }
                                break;
                            case 'argAfipPinTypeId':
                                if (tipoDocDni)
                                    setField(prevState => ({
                                        ...prevState,
                                        [id]: tipoDocDni
                                    }), []);
                                break;
                            case 'firstName':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosGenerales.nombre
                                }), []);
                                break;
                            case 'argAfipNombre':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosGenerales.nombre
                                }), []);
                                break;
                            case 'lastName':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosGenerales.apellido,
                                }), []);
                                break;
                            case 'argAfipApellido':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosGenerales.apellido
                                }), []);
                                break;
                            case 'name':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosGenerales.razonSocial == null ? `${pucAFIP.personaReturn.datosGenerales.apellido}, ${pucAFIP.personaReturn.datosGenerales.nombre}` : pucAFIP.personaReturn.datosGenerales.razonSocial,
                                }), []);
                                break;
                            case 'fullName':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosGenerales.razonSocial == null ? `${pucAFIP.personaReturn.datosGenerales.apellido}, ${pucAFIP.personaReturn.datosGenerales.nombre}` : pucAFIP.personaReturn.datosGenerales.razonSocial,
                                }), []);
                                break;
                            case 'beneficiary':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosGenerales.razonSocial == null ? `${pucAFIP.personaReturn.datosGenerales.apellido}, ${pucAFIP.personaReturn.datosGenerales.nombre}` : pucAFIP.personaReturn.datosGenerales.razonSocial,
                                }), []);
                                break;
                            case 'argAfipEstadoClave':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosGenerales.estadoClave,
                                }), []);
                                break;
                            case 'argAfipTipoPersona':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: tipoPersonaafip
                                }), []);
                                break;
                            case 'argAfipRazonSocial':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosGenerales.razonSocial,
                                }), []);
                                break;
                            case 'argAfipDomicilio':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: `${pucAFIP.personaReturn.datosGenerales.domicilioFiscal.tipoDomicilio} ${pucAFIP.personaReturn.datosGenerales.domicilioFiscal.direccion} ${pucAFIP.personaReturn.datosGenerales.domicilioFiscal.codPostal} ${pucAFIP.personaReturn.datosGenerales.domicilioFiscal.descripcionProvincia}`,
                                }), []);
                                break;
                            case 'argAfipImpuesto':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: impuestos
                                }), []);
                                break;
                            case 'argAfipCategoriaAutonomo':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosRegimenGeneral != null ? pucAFIP.personaReturn.datosRegimenGeneral.categoriaAutonomo : '',
                                }), []);
                                break;
                            case 'argAfipActividad':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: actividades
                                }), []);
                                break;
                            case 'argAfipActividadMonotributista':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosMonotributo != null ? `${pucAFIP.personaReturn.datosMonotributo.actividadMonotributista.descripcionActividad}` : '',
                                }), []);
                                break;
                            case 'argAfipCategoriaMonotributo':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosMonotributo != null ? `${pucAFIP.personaReturn.datosMonotributo.categoriaMonotributo.descripcionCategoria}` : '',
                                }), []);
                                break;
                            case 'argAfipFechaContratoSocial':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosGenerales.fechaContratoSocial,
                                }), []);
                                break;
                            case 'entityTypeId':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: tipoPersona
                                }), []);
                                break;
                            case 'argAfipTinTypeId':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: tipoClaveGrupo
                                }), []);
                                break;
                            case 'legalName':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosGenerales.razonSocial,
                                }), []);
                                break;
                            case 'argTin':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: pucAFIP.personaReturn.datosGenerales.idPersona,
                                }), []);
                                break;
                            case 'argPin':
                                setField(prevState => ({
                                    ...prevState,
                                    [id]: dni,
                                }), []);
                                break;
                            default:
                                break;
                        }
                    }
                }
            }
        }
    }

    const searchOptions = (itemField, nameGroup, dataSource) => {
        let fieldsDs = [];
        if (dataSource === null || dataSource === undefined) {
            dataSource = [];
        }
        if (dataSource.length > 0) {
            data.crud.boxes.forEach((itemBoxes) => {
                itemBoxes.fields.forEach((itemFields) => {
                    if (itemFields.group !== null) {
                        itemFields.group.forEach((itemGroup) => {
                            let nameG = itemGroup.name;
                            group[nameG].forEach((item1) => {
                                if (item1.fields !== null) {
                                    item1.fields.forEach((itemFields1) => {
                                        for (let bv = 0; bv < dataSource.length; bv++) {
                                            if (itemFields1.id === dataSource[bv]) {
                                                fieldsDs.push({
                                                    idField: itemFields1.id,
                                                    idFieldT: itemFields1.idFieldTable
                                                });
                                            }
                                        }
                                    })
                                }
                            })
                        })
                    } else {
                        for (let bv = 0; bv < dataSource.length; bv++) {
                            if (itemFields.id === dataSource[bv]) {
                                fieldsDs.push({
                                    idField: itemFields.id,
                                    idFieldT: itemFields.idFieldTable
                                });
                            }
                        }
                    }
                })
            })
        }
        let options = [];

        info.forEach((itemInfo) => {
            if (itemField.sourceSelectDoc !== null) {
                itemField.sourceSelectDoc.forEach((itemSourceSelectDoc) => {

                    if (itemInfo.source === itemField.sourceSelect && !nameGroup && itemInfo.doc === itemSourceSelectDoc) {
                        if (dataSource.length === 0) {
                            options.push({
                                id: itemInfo.id,
                                label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                isInactive: itemInfo.isInactive,
                            })
                        }
                        else {

                            /*for (let h = 0; h < fieldsDs.length; h++) {

                                if (field[fieldsDs[h].idField] || field[fieldsDs[h].idField] === 0) {

                                    if (itemInfo[fieldsDs[h].idFieldT] !== undefined) {
                                        if (typeof field[fieldsDs[h].idField] === 'object') {
                                            if (Number(field[fieldsDs[h].idField].id) === Number(itemInfo[fieldsDs[h].idFieldT])) {
                                                options.push({
                                                    id: itemInfo.id,
                                                    label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                    isInactive: itemInfo.isInactive,

                                                })
                                            }
                                        } else {
                                            if (field[fieldsDs[h].idField].toString() === itemInfo[fieldsDs[h].idFieldT].toString()) {
                                                options.push({
                                                    id: itemInfo.id,
                                                    label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                    isInactive: itemInfo.isInactive,

                                                })
                                            }
                                        }

                                    }
                                }
                            }*/
                            let validate = true;
                            for (let h = 0; h < fieldsDs.length; h++) {
                                let valueField;
                                if (field[fieldsDs[h].idField] === null || field[fieldsDs[h].idField] === undefined)
                                    valueField = null;
                                else
                                    valueField = field[fieldsDs[h].idField];

                                let valueItemInfo;
                                if (itemInfo[fieldsDs[h].idFieldT] === null || itemInfo[fieldsDs[h].idFieldT] === undefined)
                                    valueItemInfo = null;
                                else
                                    valueItemInfo = itemInfo[fieldsDs[h].idFieldT];

                                if (typeof valueField === 'object') {
                                    if (valueField) {
                                        if (Number(valueField.id) !== Number(valueItemInfo)) {
                                            validate = false;
                                        }
                                    } else {
                                        if (valueField !== valueItemInfo) {
                                            validate = false;
                                        }
                                    }
                                } else {
                                    if (valueField.toString() !== valueItemInfo.toString()) {
                                        validate = false;
                                    }
                                }
                            }
                            if (validate) {
                                options.push({
                                    id: itemInfo.id,
                                    label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                    isInactive: itemInfo.isInactive,

                                })
                            }
                        }

                    } else {
                        if (itemInfo.source === itemField.sourceSelect && nameGroup === itemInfo.group && itemInfo.doc === itemSourceSelectDoc) {
                            if (dataSource.length === 0) {
                                options.push({
                                    id: itemInfo.id,
                                    label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                    isInactive: itemInfo.isInactive,

                                })
                            }
                            else {
                                /*for (let h = 0; h < fieldsDs.length; h++) {

                                    if (field[fieldsDs[h].idField] || field[fieldsDs[h].idField] === 0) {
                                        if (itemInfo[fieldsDs[h].idFieldT] !== undefined) {
                                            if (typeof field[fieldsDs[h].idField] === 'object') {
                                                if (Number(field[fieldsDs[h].idField].id) === Number(itemInfo[fieldsDs[h].idFieldT])) {
                                                    options.push({
                                                        id: itemInfo.id,
                                                        label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                        isInactive: itemInfo.isInactive,

                                                    })
                                                }
                                            } else {
                                                if (field[fieldsDs[h].idField].toString() === itemInfo[fieldsDs[h].idFieldT].toString()) {
                                                    options.push({
                                                        id: itemInfo.id,
                                                        label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                        isInactive: itemInfo.isInactive,

                                                    })
                                                }
                                            }
                                        }
                                    }
                                }*/
                                let validate = true;
                                for (let h = 0; h < fieldsDs.length; h++) {
                                    let valueField;
                                    if (field[fieldsDs[h].idField] === null || field[fieldsDs[h].idField] === undefined)
                                        valueField = null;
                                    else
                                        valueField = field[fieldsDs[h].idField];

                                    let valueItemInfo;
                                    if (itemInfo[fieldsDs[h].idFieldT] === null || itemInfo[fieldsDs[h].idFieldT] === undefined)
                                        valueItemInfo = null;
                                    else
                                        valueItemInfo = itemInfo[fieldsDs[h].idFieldT];

                                    if (typeof valueField === 'object') {
                                        if (valueField) {
                                            if (Number(valueField.id) !== Number(valueItemInfo)) {
                                                validate = false;
                                            }
                                        } else {
                                            if (valueField !== valueItemInfo) {
                                                validate = false;
                                            }
                                        }
                                    } else {
                                        if (valueField.toString() !== valueItemInfo.toString()) {
                                            validate = false;
                                        }
                                    }
                                }
                                if (validate) {
                                    options.push({
                                        id: itemInfo.id,
                                        label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                        isInactive: itemInfo.isInactive,

                                    })
                                }
                            }
                        } else {
                            if (itemInfo.source === itemField.sourceSelect && nameGroup && !itemInfo.group && itemInfo.doc === itemSourceSelectDoc) {
                                if (dataSource.length === 0) {
                                    options.push({
                                        id: itemInfo.id,
                                        label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                        isInactive: itemInfo.isInactive,

                                    })
                                }
                                else {
                                    /*for (let h = 0; h < fieldsDs.length; h++) {
                                        if (field[fieldsDs[h].idField] || field[fieldsDs[h].idField] === 0) {
                                            if (itemInfo[fieldsDs[h].idFieldT] !== undefined) {
                                                if (typeof field[fieldsDs[h].idField] === 'object') {
                                                    if (Number(field[fieldsDs[h].idField].id) === Number(itemInfo[fieldsDs[h].idFieldT])) {
                                                        options.push({
                                                            id: itemInfo.id,
                                                            label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                            isInactive: itemInfo.isInactive,

                                                        })
                                                    }
                                                } else {

                                                    if (field[fieldsDs[h].idField].toString() === itemInfo[fieldsDs[h].idFieldT].toString()) {
                                                        options.push({
                                                            id: itemInfo.id,
                                                            label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                            isInactive: itemInfo.isInactive,

                                                        })
                                                    }
                                                }
                                            }
                                        }
                                    }*/
                                    let validate = true;
                                    for (let h = 0; h < fieldsDs.length; h++) {
                                        let valueField;
                                        if (field[fieldsDs[h].idField] === null || field[fieldsDs[h].idField] === undefined)
                                            valueField = null;
                                        else
                                            valueField = field[fieldsDs[h].idField];

                                        let valueItemInfo;
                                        if (itemInfo[fieldsDs[h].idFieldT] === null || itemInfo[fieldsDs[h].idFieldT] === undefined)
                                            valueItemInfo = null;
                                        else
                                            valueItemInfo = itemInfo[fieldsDs[h].idFieldT];

                                        if (typeof valueField === 'object') {
                                            if (valueField) {
                                                if (Number(valueField.id) !== Number(valueItemInfo)) {
                                                    validate = false;
                                                }
                                            } else {
                                                if (valueField !== valueItemInfo) {
                                                    validate = false;
                                                }
                                            }
                                        } else {
                                            if (valueField.toString() !== valueItemInfo.toString()) {
                                                validate = false;
                                            }
                                        }
                                    }
                                    if (validate) {
                                        options.push({
                                            id: itemInfo.id,
                                            label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                            isInactive: itemInfo.isInactive,

                                        })
                                    }
                                }
                            }
                        }
                    }
                })

            } else {

                if (itemInfo.source === itemField.sourceSelect && !nameGroup) {
                    if (dataSource.length === 0) {
                        options.push({
                            id: itemInfo.id,
                            label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                            isInactive: itemInfo.isInactive,
                        })
                    }
                    else {
                        /*for (let h = 0; h < fieldsDs.length; h++) {
                            if (field[fieldsDs[h].idField] || field[fieldsDs[h].idField] === 0) {
                                if (itemInfo[fieldsDs[h].idFieldT] !== undefined) {
                                    if (typeof field[fieldsDs[h].idField] === 'object') {
                                        if (Number(field[fieldsDs[h].idField].id) === Number(itemInfo[fieldsDs[h].idFieldT])) {
                                            options.push({
                                                id: itemInfo.id,
                                                label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                isInactive: itemInfo.isInactive,

                                            })
                                        }
                                    } else {
                                        if (field[fieldsDs[h].idField].toString() === itemInfo[fieldsDs[h].idFieldT].toString()) {
                                            options.push({
                                                id: itemInfo.id,
                                                label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                isInactive: itemInfo.isInactive,

                                            })
                                        }
                                    }
                                }
                            }
                        }*/
                        let validate = true;
                        for (let h = 0; h < fieldsDs.length; h++) {
                            let valueField;
                            if (field[fieldsDs[h].idField] === null || field[fieldsDs[h].idField] === undefined)
                                valueField = null;
                            else
                                valueField = field[fieldsDs[h].idField];

                            let valueItemInfo;
                            if (itemInfo[fieldsDs[h].idFieldT] === null || itemInfo[fieldsDs[h].idFieldT] === undefined)
                                valueItemInfo = null;
                            else
                                valueItemInfo = itemInfo[fieldsDs[h].idFieldT];

                            if (typeof valueField === 'object') {
                                if (valueField) {
                                    if (Number(valueField.id) !== Number(valueItemInfo)) {
                                        validate = false;
                                    }
                                } else {
                                    if (valueField !== valueItemInfo) {
                                        validate = false;
                                    }
                                }
                            } else {
                                if (valueField.toString() !== valueItemInfo.toString()) {
                                    validate = false;
                                }
                            }
                        }
                        if (validate) {
                            options.push({
                                id: itemInfo.id,
                                label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                isInactive: itemInfo.isInactive,

                            })
                        }
                    }

                } else {
                    if (itemInfo.source === itemField.sourceSelect && nameGroup === itemInfo.group) {
                        if (dataSource.length === 0) {
                            options.push({
                                id: itemInfo.id,
                                label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                isInactive: itemInfo.isInactive,

                            })
                        }
                        else {

                            /*for (let h = 0; h < fieldsDs.length; h++) {
                                if (field[fieldsDs[h].idField] || field[fieldsDs[h].idField] === 0) {
                                    if (itemInfo[fieldsDs[h].idFieldT] !== undefined) {
                                        if (typeof field[fieldsDs[h].idField] === 'object') {
                                            if (Number(field[fieldsDs[h].idField].id) === Number(itemInfo[fieldsDs[h].idFieldT])) {
                                                options.push({
                                                    id: itemInfo.id,
                                                    label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                    isInactive: itemInfo.isInactive,

                                                })
                                            }
                                        } else {
                                            if (field[fieldsDs[h].idField].toString() === itemInfo[fieldsDs[h].idFieldT].toString()) {
                                                options.push({
                                                    id: itemInfo.id,
                                                    label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                    isInactive: itemInfo.isInactive,

                                                })
                                            }
                                        }
                                    }
                                }
                            }*/
                            let validate = true;
                            for (let h = 0; h < fieldsDs.length; h++) {
                                let valueField;
                                if (field[fieldsDs[h].idField] === null || field[fieldsDs[h].idField] === undefined)
                                    valueField = null;
                                else
                                    valueField = field[fieldsDs[h].idField];

                                let valueItemInfo;
                                if (itemInfo[fieldsDs[h].idFieldT] === null || itemInfo[fieldsDs[h].idFieldT] === undefined)
                                    valueItemInfo = null;
                                else
                                    valueItemInfo = itemInfo[fieldsDs[h].idFieldT];

                                if (typeof valueField === 'object') {
                                    if (valueField) {
                                        if (Number(valueField.id) !== Number(valueItemInfo)) {
                                            validate = false;
                                        }
                                    } else {
                                        if (valueField !== valueItemInfo) {
                                            validate = false;
                                        }
                                    }
                                } else {
                                    if (valueField.toString() !== valueItemInfo.toString()) {
                                        validate = false;
                                    }
                                }
                            }
                            if (validate) {
                                options.push({
                                    id: itemInfo.id,
                                    label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                    isInactive: itemInfo.isInactive,

                                })
                            }
                        }
                    } else {

                        if (itemInfo.source === itemField.sourceSelect && nameGroup && !itemInfo.group) {

                            if (dataSource.length === 0) {
                                options.push({
                                    id: itemInfo.id,
                                    label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                    isInactive: itemInfo.isInactive,

                                })
                            }
                            else {

                                /*for (let h = 0; h < fieldsDs.length; h++) {
                                    if (field[fieldsDs[h].idField] || field[fieldsDs[h].idField] === 0) {
                                        if (itemInfo[fieldsDs[h].idFieldT] !== undefined) {
                                            if (typeof field[fieldsDs[h].idField] === 'object') {
                                                if (Number(field[fieldsDs[h].idField].id) === Number(itemInfo[fieldsDs[h].idFieldT])) {
                                                    options.push({
                                                        id: itemInfo.id,
                                                        label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                        isInactive: itemInfo.isInactive,

                                                    })
                                                }
                                            } else {
                                                if (field[fieldsDs[h].idField].toString() === itemInfo[fieldsDs[h].idFieldT].toString()) {
                                                    options.push({
                                                        id: itemInfo.id,
                                                        label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                        isInactive: itemInfo.isInactive,

                                                    })
                                                }
                                            }
                                        }
                                    }
                                }*/
                                let validate = true;
                                for (let h = 0; h < fieldsDs.length; h++) {
                                    let valueField;
                                    if (field[fieldsDs[h].idField] === null || field[fieldsDs[h].idField] === undefined)
                                        valueField = null;
                                    else
                                        valueField = field[fieldsDs[h].idField];

                                    let valueItemInfo;
                                    if (itemInfo[fieldsDs[h].idFieldT] === null || itemInfo[fieldsDs[h].idFieldT] === undefined)
                                        valueItemInfo = null;
                                    else
                                        valueItemInfo = itemInfo[fieldsDs[h].idFieldT];

                                    if (typeof valueField === 'object') {
                                        if (valueField) {
                                            if (Number(valueField.id) !== Number(valueItemInfo)) {
                                                validate = false;
                                            }
                                        } else {
                                            if (valueField !== valueItemInfo) {
                                                validate = false;
                                            }
                                        }
                                    } else {
                                        if (valueField.toString() !== valueItemInfo.toString()) {
                                            validate = false;
                                        }
                                    }
                                }

                                if (validate) {
                                    options.push({
                                        id: itemInfo.id,
                                        label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                        isInactive: itemInfo.isInactive,

                                    })
                                }
                            }

                        } else {
                            if (itemInfo.source === itemField.sourceSelect && nameGroup && itemInfo.group) {
                                if (dataSource.length === 0) {
                                    options.push({
                                        id: itemInfo.id,
                                        label: (itemInfo.nameAlt !== undefined && itemInfo.nameAlt !== '') ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                        isInactive: itemInfo.isInactive,

                                    })
                                }
                            }
                        }
                    }
                }
            }
        })
        return options;
    }

    const handleLoadingChange = (isLoading) => {
    };

    const onValidationField = (error, helpText, idField) => {
        const newErrors = {};
        const newHelpText = {};
        newErrors[idField] = error;
        newHelpText[idField] = helpText;
        setError(newErrors);
        setHelpText(newHelpText);
    }

    const handleFieldClick = (itemField, value) => {
        if (value) {
            const baseUrl = window.location.origin;
            window.open(`${baseUrl}/${itemField.sourceSelect}?id=${value.id}&m=r`, '_blank');
        }
    };

    const renderFields = (itemField, indexField, arrayDoc, itemBoxs, nameGroup, defaultValueSelect, index, viewFieldFlag, subGroup, ultimaLinea, design, doc, idRecordGroup) => {
        let viewField = false;
        const user = AuthService.getCurrentUser();
        if (itemField.display !== 'hidden') {
            let view = true;
            if (itemField.where !== null && itemField.where !== undefined) {
                view = whereFunction(itemField);
            }
            let idField = itemField.id;
            let permision = false;
            if (mode === 'd' || mode === 'r') {
                permision = true;
            }
            if (view === true) {

                if (viewFieldFlag === false) {
                    if (subGroup === true) {
                        arrayDoc.push(<LabelIcon key={`subgroup-${idField}`} style={{ marginLeft: '25px' }} color="primary" />);

                    } else {
                        arrayDoc.push(<LabelIcon key={`group-${idField}`} color="primary" />);

                        //if ((mode === 'c' || mode === 'u') && group[nameGroup].length > 1 && (design !== 'fieldsNoAdd' && design !== 'tableNoAdd')) {
                        if ((mode === 'c' || mode === 'u') && (design !== 'fieldsNoAdd' && design !== 'tableNoAdd')) {
                            if (security({
                                linkto: pathParameter,
                                mode: 'd'
                            })) {
                                arrayDoc.push(<Button key={`buttondelete-${idField}`} onClick={() => { onDeleteElementGroup(index, nameGroup) }}>
                                    <DeleteIcon />
                                </Button>)
                            }
                        }

                        /*if (index === group[nameGroup].length - 1 && (mode === 'c' || mode === 'u') && design !== 'table' && design !== 'fieldsNoAdd' && design !== 'tableNoAdd') {
                            if (security({
                                linkto: pathParameter,
                                mode: 'c'
                            })) {
                                arrayDoc.push(<Button key={`buttonadd-${idField}`}>
                                    <AddCircleIcon style={{ fontSize: '20px' }} />
                                </Button>);
                            }
                        }*/

                    }
                }
                viewField = true;

                let nameField = itemField.name;
                if (itemField.mandatory) {
                    //nameField = `${nameField} *`
                    nameField = `${nameField}`
                }

                let fieldType = itemField.type;
                if (itemField.type.includes('Number')) {
                    fieldType = 'Number';
                }
                if (itemField.type.includes('Percentage')) {
                    fieldType = 'Percentage';
                }
                if (itemField.defaultValue)
                    ultimaLinea = false;

                let value = field[idField];
                switch (fieldType) {
                    case 'Percentage':
                        if (mode === 'r' || mode === 'u') {
                            if (itemField.valueTemporal) {
                                const isFieldEmpty =
                                    field[idField] === null ||
                                    field[idField] === undefined ||
                                    field[idField] === '';
                                if (isFieldEmpty)
                                    value = itemField.valueTemporal;
                            }
                        }
                        arrayDoc.push(
                            <div key={`percentaje-${idField}`} idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                    <Grid item>
                                        <PercentageComponente
                                            maxLength={itemField.maxLenght}
                                            disabled={itemField.display === 'viewOnly' && mode !== 'r' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={value}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField, nameGroup, index, itemField.name, ultimaLinea, design, itemBoxs.order, doc, idRecordGroup)}
                                            itemFunction={itemField.function}
                                            user={user}
                                            instance={instance}
                                            help={itemField.help}
                                            onLoadingChange={handleLoadingChange}
                                            error={error[idField]}
                                            errorHelpText={helpText[idField]}
                                            onValidationField={onValidationField}
                                            mode={false}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                            design={design}
                                            onBlur={(event) => formatListNumber(event, idField, itemField, nameGroup, index)}
                                            mandatory={itemField.mandatory}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'TextField':
                        if (mode === 'r' || mode === 'u') {
                            if (itemField.valueTemporal) {
                                const isFieldEmpty =
                                    field[idField] === null ||
                                    field[idField] === undefined ||
                                    field[idField] === '';
                                if (isFieldEmpty)
                                    value = itemField.valueTemporal;
                            }
                        }
                        let maxWidthParameter = Number(zoom) - 400;

                        arrayDoc.push(
                            <div key={`text-${idField}`} idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                    <Grid item>
                                        <TextFieldComponent
                                            maxLength={itemField.maxLenght}
                                            disabled={itemField.display === 'viewOnly' && mode !== 'r' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={value}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField, nameGroup, index, itemField.name, ultimaLinea, design, itemBoxs.order, doc, idRecordGroup)}
                                            itemFunction={itemField.function}
                                            onBlur={(dataPUC, uifsro) => handlePucCuitChange(dataPUC, nameGroup, index, uifsro, idField, itemField)}
                                            onFocus={() => handleFocus(idField, value)}
                                            user={user.client}
                                            instance={instance}
                                            help={itemField.help}
                                            onLoadingChange={handleLoadingChange}
                                            error={error[idField]}
                                            errorHelpText={helpText[idField]}
                                            onValidationField={onValidationField}
                                            mode={permision}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                            design={design}
                                            maxWidth={`${maxWidthParameter}px`}
                                            heightParam={null}
                                            widthParam={null}
                                            minWidthParam={null}
                                            mandatory={itemField.mandatory}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Password':
                        if (mode === 'r' || mode === 'u') {
                            if (itemField.valueTemporal) {
                                const isFieldEmpty =
                                    field[idField] === null ||
                                    field[idField] === undefined ||
                                    field[idField] === '';
                                if (isFieldEmpty)
                                    value = itemField.valueTemporal;
                            }
                        }
                        arrayDoc.push(
                            <div key={`password-${idField}`} idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                    <Grid item>
                                        <TextFieldComponent
                                            maxLength={itemField.maxLenght}
                                            disabled={itemField.display === 'viewOnly' && mode !== 'r' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={value}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField, nameGroup, index, itemField.name, ultimaLinea, design, itemBoxs.order, doc, idRecordGroup)}
                                            itemFunction={itemField.function}
                                            onBlur={(dataPUC, uifsro) => handlePucCuitChange(dataPUC, nameGroup, index, uifsro, idField, itemField)}
                                            onFocus={() => handleFocus(idField, value)}
                                            user={user.client}
                                            instance={instance}
                                            help={itemField.help}
                                            onLoadingChange={handleLoadingChange}
                                            error={error[idField]}
                                            errorHelpText={helpText[idField]}
                                            onValidationField={onValidationField}
                                            mode={permision}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                            type="password"
                                            design={design}
                                            heightParam={null}
                                            widthParam={null}
                                            minWidthParam={null}
                                            mandatory={itemField.mandatory}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Select':
                        let dataSource = [];

                        if (nameGroup && dataSource.length > 0) {
                            dataSource = itemField.dataSource;
                            let arrayFlagDataSource = [];

                            group[nameGroup].forEach((item1, indexG) => {
                                if (Number(index) === Number(indexG)) {
                                    if (item1.fields !== null) {
                                        item1.fields.forEach((itemFields) => {
                                            for (let g = 0; g < dataSource.length; g++) {
                                                if (itemFields.id.includes(dataSource[g])) {
                                                    arrayFlagDataSource.push(itemFields.id);
                                                }
                                            }
                                        })
                                    }
                                }
                            });

                            dataSource = arrayFlagDataSource;
                        }
                        //MODIFICACION 210725
                        data.crud.boxes.forEach((itemBoxes) => {
                            itemBoxes.fields.forEach((itemFields) => {
                                if (itemField.dataSource) {
                                    for (let g = 0; g < itemField.dataSource.length; g++) {
                                        if (itemField.dataSource[g] === itemFields.id) {
                                            dataSource.push(itemField.dataSource[g]);
                                        }
                                    }
                                }
                            })
                        })
                        //MODIFICACION 210725                      
                        let options = searchOptions(itemField, nameGroup, dataSource);
                        let defaultValue;
                        if (itemField.defaultValue) {
                            for (let r = 0; r < options.length; r++) {
                                if (options[r].id === itemField.defaultValue) {
                                    defaultValue = options[r];
                                }
                            }
                        }
                        if (defaultValueSelect)
                            defaultValue = defaultValueSelect;

                        let viewRedirectRole = false;
                        roles.forEach((itemRoles) => {
                            if (itemRoles.name === itemField.sourceSelect) {
                                viewRedirectRole = true
                            }
                        })
                        if (mode === 'r' || mode === 'u') {
                            if (itemField.valueTemporal) {
                                const isFieldEmpty =
                                    field[idField] === null ||
                                    field[idField] === undefined ||
                                    (typeof field[idField] === 'object' &&
                                        !Array.isArray(field[idField]) &&
                                        Object.values(field[idField]).every(value => value === undefined));
                                if (isFieldEmpty)
                                    value = itemField.valueTemporal;
                            }
                        }

                        if (mode === 'c' || mode === 'u')
                            options = options.filter(option => option.isInactive === "0");


                        if (itemField.searchSource !== null && options.length === 1) {
                            value = options[0];

                            const isFieldEmpty =
                                field[idField] === null ||
                                field[idField] === undefined ||
                                (typeof field[idField] === 'object' &&
                                    !Array.isArray(field[idField]) &&
                                    Object.values(field[idField]).every(value => value === undefined));


                            if (isFieldEmpty)
                                value = {
                                    id: options[0].id,
                                    label: options[0].label
                                };
                        }

                        arrayDoc.push(
                            <div key={`select-${idField}`} idfield={idField} className="mi-componente-material-ui" >
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid xs={3} item>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <SelectComponent
                                                disabled={itemField.display === 'viewOnly' && mode !== 'r' ? true : false}
                                                id={idField}
                                                name={nameField}
                                                value={value}
                                                onFocus={() => handleFocus(idField, value)}
                                                onChange={(event, newValue) => handleFieldChange(event, newValue, idField, itemField, nameGroup, index, itemField.name, ultimaLinea, design, itemBoxs.order, doc, idRecordGroup)}
                                                help={itemField.help}
                                                options={options}
                                                defaultValue={defaultValue}
                                                mode={permision}
                                                className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                                itemField={itemField}
                                                modeView={mode}
                                                viewRedirectRole={viewRedirectRole}
                                                design={design}
                                                onBlur={(event) => formatListNumber(event, idField, itemField, nameGroup, index)}
                                                mandatory={itemField.mandatory}
                                            />
                                            {mode !== 'r' && viewRedirectRole && (
                                                <OpenInNewIcon style={{ marginTop: '-15px', marginLeft: '10px', fontSize: '18px', cursor: 'pointer' }} onClick={() => handleFieldClick(itemField, value)} />
                                            )}
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'File':
                        arrayDoc.push(
                            <div key={`file-${idField}`} style={{ display: 'inline-block', margin: '0 0.2px' }}>
                                <Grid container xs={12} item>
                                    <Grid item>
                                        <FileComponent
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField, nameGroup, index, itemField.name, null, design, itemBoxs.order, doc, idRecordGroup)}
                                            onValidationField={onValidationField}
                                            help={itemField.help}
                                            id={idField}
                                            design={design}
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        );
                        break;
                    case 'Typography':
                        let paragraphType = 'body1';
                        //let fontSize = '0.8rem';
                        let fontSize = "inherit";
                        if (itemField.cssClass === 'titleStyle4') {
                            paragraphType = 'h4';
                            fontSize = "inherit";
                            //fontSize = '1.2rem';
                        }

                        arrayDoc.push(
                            <div key={`typography-${idField}`} style={{ display: 'inline-block', margin: '0 0.2px' }}>
                                <Grid container sx={{ m: 1 }} xs={12} item>
                                    <Grid item>
                                        <TypographyComponent
                                            value={itemField.defaultValue}
                                            paragraphType={paragraphType}
                                            text={itemField.defaultValue}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                            style={{ fontSize: fontSize, fontWeight: '600' }}
                                            design={design}
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        );
                        break;
                    case 'Json':
                        if (mode === 'r' || mode === 'u') {
                            if (itemField.valueTemporal) {
                                const isFieldEmpty =
                                    field[idField] === null ||
                                    field[idField] === undefined ||
                                    field[idField] === '';
                                if (isFieldEmpty)
                                    value = itemField.valueTemporal;
                            }
                        }
                        arrayDoc.push(
                            //<div style={{ display: 'inline-block' }}>
                            <div key={`json-${idField}`} idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                    <Grid item>
                                        <JsonComponent
                                            maxLength={itemField.maxLenght}
                                            disabled={itemField.display === 'viewOnly' && mode !== 'r' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={value}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField.idFieldTable, nameGroup, index, itemField.name, ultimaLinea, design, itemBoxs.order, doc, idRecordGroup)}
                                            itemFunction={itemField.function}
                                            onBlur={(dataPUC, uifsro) => handlePucCuitChange(dataPUC, nameGroup, index, uifsro, idField, itemField)}
                                            onFocus={() => handleFocus(idField, value)}
                                            user={user}
                                            instance={instance}
                                            help={itemField.help}
                                            onLoadingChange={handleLoadingChange}
                                            error={error[idField]}
                                            errorHelpText={helpText[idField]}
                                            onValidationField={onValidationField}
                                            mode={false}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                            design={design}
                                            mandatory={itemField.mandatory}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Number':
                        if (mode === 'r' || mode === 'u') {
                            if (itemField.valueTemporal) {
                                const isFieldEmpty =
                                    field[idField] === null ||
                                    field[idField] === undefined ||
                                    field[idField] === '';
                                if (isFieldEmpty)
                                    value = itemField.valueTemporal;
                            }
                        }
                        arrayDoc.push(
                            <div key={`number-${idField}`} idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                    <Grid item>
                                        <NumberComponent
                                            maxLength={itemField.maxLenght}
                                            disabled={itemField.display === 'viewOnly' && mode !== 'r' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={value}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField, nameGroup, index, itemField.name, ultimaLinea, design, itemBoxs.order, doc, idRecordGroup)}
                                            itemFunction={itemField.function}
                                            help={itemField.help}
                                            mode={permision}
                                            design={design}
                                            onBlur={(event) => formatListNumber(event, idField, itemField, nameGroup, index)}
                                            onFocus={() => handleFocus(idField, value)}
                                            mandatory={itemField.mandatory}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Currency':
                        if (mode === 'r' || mode === 'u') {
                            if (itemField.valueTemporal) {
                                const isFieldEmpty =
                                    field[idField] === null ||
                                    field[idField] === undefined ||
                                    field[idField] === '';
                                if (isFieldEmpty)
                                    value = itemField.valueTemporal;
                            }
                        }
                        arrayDoc.push(
                            <div key={`currency-${idField}`} idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                    <Grid item>
                                        <CurrencyComponent
                                            maxLength={itemField.maxLenght}
                                            disabled={itemField.display === 'viewOnly' && mode !== 'r' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={value}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField, nameGroup, index, itemField.name, ultimaLinea, design, itemBoxs.order, doc, idRecordGroup)}
                                            itemFunction={itemField.function}
                                            help={itemField.help}
                                            mode={permision}
                                            design={design}
                                            onBlur={(event) => formatListNumber(event, idField, itemField, nameGroup, index)}
                                            symbol={formatCurrency[idField]}
                                            onFocus={() => handleFocus(idField, value)}
                                            mandatory={itemField.mandatory}
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        )
                        break;
                    case 'Checkbox':
                        arrayDoc.push(
                            <div key={`checkbox-${idField}`} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                    <Grid xs={12} item>
                                        <CheckBoxComponent
                                            disabled={(itemField.display === 'viewOnly' && mode !== 'r') || permision === true ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField, nameGroup, index, itemField.name, ultimaLinea, design, itemBoxs.order, doc, idRecordGroup)}
                                            help={itemField.help}
                                            mode={permision}
                                            className={itemField.print === false ? constantsDesign.HIDE_IN_PRINT_CLASS : null}
                                            design={design}
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        )
                        break;
                    case 'Switch':
                        arrayDoc.push(
                            <div key={`switch-${idField}`} className="mi-componente-material-ui">
                                <Grid container xs={12} item>
                                    <Grid xs={8} item>
                                        <SwitchComponent
                                            disabled={(itemField.display === 'viewOnly' && mode !== 'r') || permision === true ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField, nameGroup, index, itemField.name, ultimaLinea, design, itemBoxs.order, doc, idRecordGroup)}
                                            help={itemField.help}
                                            design={design}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Radio':
                        arrayDoc.push(
                            <div key={`radio-${idField}`} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                    <Grid xs={12} item>
                                        <RadioComponent
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField, nameGroup, index, itemField.name, ultimaLinea, design, itemBoxs.order, doc, idRecordGroup)}
                                            help={itemField.help}
                                            options={itemField.radioGroup}
                                            mode={permision}
                                            design={design}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Date':
                        arrayDoc.push(
                            <div key={`date-${idField}`} idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                    <Grid item>
                                        <DateComponent
                                            disabled={itemField.display === 'viewOnly' && mode !== 'r' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(newDate) => handleFieldChange({ target: { value: newDate } }, null, idField, itemField, nameGroup, index, itemField.name, ultimaLinea, design, itemBoxs.order, doc, idRecordGroup)}
                                            //onChange={(event) => handleFieldChange(event, null, idField, itemField, nameGroup, index, itemField.name, ultimaLinea, design, itemBoxs.order, doc, idRecordGroup)}
                                            help={itemField.help}
                                            mode={permision}
                                            design={design}
                                            view={mode}
                                            mandatory={itemField.mandatory}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Datetime':
                        arrayDoc.push(
                            <div key={`datetime-${idField}`} idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                    <Grid item>
                                        <DateTimeComponent
                                            disabled={itemField.display === 'viewOnly' && mode !== 'r' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField, nameGroup, index, itemField.name, ultimaLinea, design, itemBoxs.order, doc, idRecordGroup)}
                                            help={itemField.help}
                                            mode={permision}
                                            design={design}
                                            view={mode}
                                            mandatory={itemField.mandatory}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Time':
                        arrayDoc.push(
                            <div key={`datetime-${idField}`} idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                    <Grid item>
                                        <TimeComponent
                                            disabled={itemField.display === 'viewOnly' && mode !== 'r' ? true : false}
                                            id={idField}
                                            name={nameField}
                                            value={field[idField]}
                                            onChange={(event) => handleFieldChange(event, null, idField, itemField, nameGroup, index, itemField.name, ultimaLinea, design, itemBoxs.order, doc, idRecordGroup)}
                                            help={itemField.help}
                                            mode={permision}
                                            design={design}
                                            view={mode}
                                            mandatory={itemField.mandatory}
                                        />
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Url':
                        arrayDoc.push(
                            <div key={`url-${idField}`} idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                    <Grid item>
                                        <a href={field[idField]} target="_blank" rel="noopener noreferrer" style={{ color: '#323B98', fontWeight: 'bold', textDecoration: 'none', fontSize: "inherit", lineHeight: "inherit", minWidth: "32ch" }}>{field[idField]}</a>
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    case 'Button':
                        arrayDoc.push(
                            <div key={`buttonprocess-${idField}`} idfield={idField} className="mi-componente-material-ui">
                                <Grid container sx={{ m: 0.5 }} xs={12} item>
                                    <Grid item>
                                        <Button style={{ minWidth: "4ch" }} variant='outlined' onClick={() => processFile(itemField, itemBoxs)}>{nameField}</Button>
                                    </Grid>
                                </Grid>
                            </div>)
                        break;
                    default:
                        break;
                }
                if (itemBoxs.fields) {
                    if (indexField < itemBoxs.fields.length - 1 && itemField.columnBreak) {
                        arrayDoc.push(<br key={`br-${idField}`} />);
                    }
                    return true;
                }
            }
        }
        return viewField;
    }

    const renderCrud = () => {
        let arrayDoc = [];
        data.crud.boxes.forEach((itemBoxs, indexBoxs) => {
            let arrayItemBoxs = [];
            let arrayItemBoxsFlag = [];
            itemBoxs.fields.forEach((itemField, indexField) => {
                if (itemField.group !== null) {
                    loadGroup && (
                        arrayItemBoxs.push(<div key={indexField} style={{ display: 'flex', justifyContent: 'center' }}>
                            <CircularProgress size={60} />
                        </div>)
                    )

                    !loadGroup && (
                        itemField.group.forEach((itemGroup, indexGroup) => {

                            if (indexGroup === 0) {
                                let nameGroup = itemGroup.name;
                                if (group[nameGroup]) {
                                    let viewGroup = true;
                                    if (mode === 'r' && group[nameGroup].length === 1) {
                                        viewGroup = false;
                                        group[nameGroup].forEach((item1) => {
                                            if (item1.fields !== null) {
                                                item1.fields.forEach((itemFields) => {
                                                    let idField = itemFields.id;
                                                    if ((itemFields.type === 'Select' || itemFields.type === 'TextField' || itemFields.type === 'Date' || itemFields.type === 'Currency' || itemFields.type.includes('Number')) && field[idField]) {
                                                        if (field[itemFields.id] && itemFields.display !== 'hidden') {

                                                            if (itemFields.where !== null) {
                                                                let view = whereFunction(itemFields);
                                                                if (view)
                                                                    viewGroup = true;
                                                            } else
                                                                viewGroup = true;
                                                        }
                                                    }
                                                })
                                            }
                                        })

                                    }
                                    if (viewGroup) {
                                        let arrayGroupTable = [];
                                        group[nameGroup].forEach((item1, index) => {
                                            let ultimaLinea = false;
                                            if (index === group[nameGroup].length - 1) {
                                                ultimaLinea = true;
                                            }
                                            let arrayItemGroup = [];

                                            if (item1.fields !== null) {
                                                let viewFieldFlag = false;
                                                let idRecordGroup;
                                                item1.fields.forEach((itemFields, indexFields) => {
                                                    let viewFlag = renderFields(itemFields, indexFields, arrayItemGroup, itemBoxs, itemGroup.name, null, index, viewFieldFlag, null, ultimaLinea, itemGroup.design, item1.doc, idRecordGroup);
                                                    if (viewFlag === true) {
                                                        viewFieldFlag = true;
                                                    }
                                                    if (itemFields.idFieldTable === 'id') {
                                                        idRecordGroup = field[itemFields.id];
                                                    }
                                                })
                                                if (viewFieldFlag === true) {
                                                    if (index === group[nameGroup].length - 1 && (mode === 'c' || mode === 'u') && itemGroup.design !== 'table' && itemGroup.design !== 'fieldsNoAdd' && itemGroup.design !== 'tableNoAdd') {
                                                        if (security({
                                                            linkto: pathParameter,
                                                            mode: 'c'
                                                        })) {
                                                            arrayItemGroup.push(<Button onClick={() => { addElementGroup(nameGroup, true) }}>
                                                                <AddCircleIcon style={{ fontSize: '20px' }} />
                                                            </Button>);
                                                        }
                                                    }
                                                }

                                                if (viewFieldFlag === true) {
                                                    if (mode !== 'c') {
                                                        arrayItemGroup.push(<Button key={`button-${idRecordGroup}`} onClick={() => { addRedirectRecord(item1.doc, idRecordGroup) }}>
                                                            <ArrowForwardIosIcon style={{ fontSize: '20px' }} />
                                                        </Button>);
                                                    }
                                                }

                                                //SUBGROUP
                                                let idRecordGroupSubgroup = idRecordGroup;
                                                if (item1.subGroup !== null && item1.subGroup !== undefined) {

                                                    item1.subGroup.forEach((item2, index2) => {

                                                        for (let key in item2) {

                                                            let nameSubGroup = key;
                                                            item2[nameSubGroup].forEach((itemSubGroupFields, indexItemSubGroupFields) => {

                                                                let arrayItemSubGroup = [];
                                                                let viewFieldFlag = false;
                                                                itemSubGroupFields.fields.forEach((itemFields, indexFields) => {
                                                                    let nameSG = nameSubGroup;

                                                                    let viewFlag = renderFields(itemFields, indexFields, arrayItemSubGroup, itemBoxs, nameSG, null, index, viewFieldFlag, true, itemGroup.design, itemGroup.name, idRecordGroupSubgroup);
                                                                    if (viewFlag === true) {
                                                                        viewFieldFlag = true;
                                                                    }
                                                                })
                                                                if (viewFieldFlag === true) {
                                                                    if (mode !== 'c')
                                                                        arrayItemGroup.push(<Button key={`button-${idRecordGroupSubgroup}`} onClick={() => { addRedirectRecord(itemGroup.name, idRecordGroupSubgroup) }}>
                                                                            <ArrowForwardIosIcon style={{ fontSize: '20px' }} />
                                                                        </Button>);
                                                                }
                                                                if (arrayItemSubGroup.length > 0) {
                                                                    arrayItemGroup.push(<Box key={`box-${indexGroup}`} border={1} borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>
                                                                        {arrayItemSubGroup}
                                                                    </Box>);
                                                                    arrayItemGroup.push(<div key={`box1-${indexGroup}`} style={{ height: '4px' }} />);
                                                                }
                                                            })
                                                        }
                                                    })
                                                }
                                            }
                                            if (arrayItemGroup.length > 0) {
                                                arrayGroupTable.push(arrayItemGroup);
                                                if (itemGroup.design !== 'table') {
                                                    arrayItemBoxsFlag.push(<Box key={`box_${index}`} border={1} borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>
                                                        {arrayItemGroup}
                                                    </Box>);
                                                    arrayItemBoxsFlag.push(<div key={`div_${index}`} style={{ height: '4px' }} />);
                                                }
                                            }
                                        })
                                        if (itemGroup.design === 'table') {
                                            arrayItemBoxsFlag.push(<TableContainer key={`table_${indexGroup}`} component={Paper}>
                                                <Table sx={{ minWidth: 650, height: '100%' }} aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>

                                                            {(mode === 'r' || mode === 'd') && <TableCell></TableCell>}
                                                            {(mode === 'u' || mode === 'c') && <TableCell></TableCell>}
                                                            {(mode === 'u' || (mode === 'c' && group[nameGroup].length > 1)) && <TableCell></TableCell>}
                                                            {
                                                                group[nameGroup].map((item1, index) =>

                                                                    item1.fields.map((row) => {
                                                                        if (row.display !== 'hidden' && index === 0) {
                                                                            let view = true;
                                                                            if (row.where !== null && row.where !== undefined) {
                                                                                view = whereFunction(row);
                                                                            }
                                                                            if (view)
                                                                                return <TableCell key={row.id}>{row.name}</TableCell>;
                                                                            else
                                                                                return null;
                                                                        }
                                                                        return null;
                                                                    })
                                                                )
                                                            }
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            arrayGroupTable.map((row) => {
                                                                return (
                                                                    <TableRow key={row.id}
                                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                    >
                                                                        {
                                                                            row.map((row) => {
                                                                                return <TableCell key={row.id}>{row}</TableCell>
                                                                            })
                                                                        }
                                                                    </TableRow>)
                                                            })
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            )
                                        }

                                    }
                                }
                            }

                        })
                    )


                } else {
                    renderFields(itemField, indexField, arrayItemBoxsFlag, itemBoxs, null, null, null, null, null, null, null, null);
                }
            })

            if (arrayItemBoxsFlag.length > 0) {
                for (let d = 0; d < arrayItemBoxsFlag.length; d++) {
                    arrayItemBoxs.push(arrayItemBoxsFlag[d]);
                }
            }

            if (arrayItemBoxs.length >= 1) {
                arrayDoc.push(
                    <Box key={`box-${indexBoxs}`} border={1} borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>
                        <Box display="flex" alignItems="center">
                            <IconButton onClick={() => handleToggleCollapse(indexBoxs)}>
                                {collapsedStates[indexBoxs] ? (<ExpandMoreIcon />) : (<ExpandLessIcon />)}
                            </IconButton>
                            <TypographyComponent
                                //paragraphType='body1'
                                fontSize='0.8rem'
                                text={itemBoxs.box}
                            />
                        </Box>
                        {!collapsedStates[indexBoxs] && (
                            <div>
                                {arrayItemBoxs}
                            </div>
                        )}
                    </Box>
                );
                if (data.crud.boxes.length - 1 !== indexBoxs)
                    arrayDoc.push(<div key={`spacer-${indexBoxs}`} style={{ height: '8px' }} />);
            }
        })

        return (
            <>
                {arrayDoc.length > 0 && (
                    <Box border={1} borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>
                        {arrayDoc}
                    </Box>
                )}
            </>
        );
    }


    const processFile = async (item, box) => {
        let validation = true;
        setErrorSave('');
        setMessageFileUpload('')
        let groupFlag = JSON.parse(JSON.stringify(group));
        for (let key in groupFlag) {
            let arrayFlag = [];
            for (let f = 0; f < groupFlag[key].length; f++) {
                if (f !== groupFlag[key].length - 1)
                    arrayFlag.push(groupFlag[key][f]);
            }
            groupFlag[key] = arrayFlag;
        }
        for (let g = 0; g < box.fields.length; g++) {

            if (box.fields[g].type === 'File' && box.fields[g].display !== 'hidden' && box.fields[g].mandatory === true && !field[box.fields[g].id]) {
                validation = false;
            }
            if (box.fields[g].type !== 'Switch' && box.fields[g].display !== 'hidden' && box.fields[g].mandatory === true && !field[box.fields[g].id]) {

                if (box.fields[g].where !== null && box.fields[g].where !== undefined) {
                    let view = whereFunction(box.fields[g]);
                    if (view === true) {
                        validation = false
                    }
                } else {
                    validation = false;
                }
            }

            if (box.fields[g].group !== null) {
                for (let a = 0; a < box.fields[g].group.length; a++) {
                    let nameGroup = box.fields[g].group[a].name;
                    for (let u = 0; u < groupFlag[nameGroup].length; u++) {
                        for (let b = 0; b < groupFlag[nameGroup][u].fields.length; b++) {
                            if (groupFlag[nameGroup][u].fields[b].type === 'File' && groupFlag[nameGroup][u].fields[b].display !== 'hidden' && groupFlag[nameGroup][u].fields[b].mandatory === true && !field[groupFlag[nameGroup][u].fields[b].id]) {
                                validation = false;
                            }
                            if (groupFlag[nameGroup][u].fields[b].type !== 'Switch' && groupFlag[nameGroup][u].fields[b].display !== 'hidden' && groupFlag[nameGroup][u].fields[b].mandatory === true && !field[groupFlag[nameGroup][u].fields[b].id]) {
                                validation = false;
                            }
                        }
                    }
                }
            }
        }

        if (validation === false) {
            setErrorSave('Complete todos los campos obligatorios');
            return false;
        }

        const user = AuthService.getCurrentUser();
        if (user) {
            try {
                let response = await uploadFile(item, box, field, user.data.instance, user.email, setField);
                if (response) {
                    setMessageFileUpload({ code: 'error', description: response.error })
                } else {
                    setMessageFileUpload({ code: 'success', description: 'Archivo en proceso. Se informa por email el resultado.' })
                }
            } catch (error) {
                setMessageFileUpload({ code: 'error', description: error })
            }
        }
    }

    const security = (item) => {

        if (item.linkto) {
            for (const rolFlag of roles) {
                if (rolFlag.name === item.linkto) {

                    switch (rolFlag.level) {
                        case 'full':
                            return true;
                        case 'edit':
                            if (item.mode === 'c' || item.mode === 'u' || item.mode === 'r' || item.mode === 'l') {
                                return true;
                            }
                            break;
                        case 'viewOnly':
                            if (item.mode === 'r' || item.mode === 'l') {
                                return true;
                            }
                            break;
                        default:
                            return false
                    }
                }
            }
            return false;
        } else
            return true;
    }

    const updateImportes = () => {
        let nameGroupInitial = null;
        for (let key in group) {
            for (let r = 0; r < group[key].length; r++) {
                let trxLineTypeId = null;
                for (let d = 0; d < group[key][r].fields.length; d++) {
                    if (group[key][r].fields[d].idFieldTable === 'trxLineTypeId') {
                        if (field[group[key][r].fields[d].id]) {
                            trxLineTypeId = field[group[key][r].fields[d].id].id
                            if (Number(trxLineTypeId) === 0) {
                                trxLineTypeId = group[key][r].fields[d].defaultValue
                            }
                        } else {
                            trxLineTypeId = group[key][r].fields[d].defaultValue
                        }
                    }
                }
                if (Number(trxLineTypeId) === 2) {
                    nameGroupInitial = key;
                }
            }
        }
        if (nameGroupInitial)
            trxLine.setTrxLine3(null, field, null, 'trxLine2', data, group, addElementGroup, setField, info, setGroup, setArrayGroupDelete, id, null, true, searchFieldSource, setValueSearchSource, mode, [], [])
    }

    const getRowStyle = (isSubtotal, rowIndex) => {
        let baseColor = "white";

        if (isSubtotal) {
            baseColor = "rgba(0, 0, 0, 0.04)";
        } else {
            baseColor = rowIndex % 2 === 0 ? "white" : "rgba(0, 0, 0, 0.02)";
        }

        return {
            backgroundColor: baseColor,
            "&:hover": {
                backgroundColor: "#e6ffff", // color al pasar con el mouse
            },
        };
    };

    return (
        <ThemeProvider theme={constantsDesign.CUSTOM_MUI_GENERAL_THEME}>
            <div className="App">
                <CssBaseline />
                <header className="App-header">
                    <Box ref={boxRef} sx={{ width: "100%", flexGrow: 1 }}>
                        <Grid container xs={12} item>
                            <Grid container sx={{ m: 1 }} xs={12} item>
                                <ThemeProvider theme={constantsDesign.CUSTOM_MUI_TEXT_FIELD_THEME}>
                                    <Box sx={{ width: '100%' }}>
                                        <MenuApp />
                                        <br></br>

                                        {mode === 'l' && availabity && (
                                            <div>
                                                <div style={{ width: '100%', position: 'sticky', top: 0, zIndex: 1 }}>
                                                    <Typography
                                                        sx={{
                                                            mt: 4,
                                                            mb: 2,
                                                        }}
                                                        variant="h6"
                                                        component="div"
                                                    >
                                                        {data.list.title}
                                                    </Typography>
                                                    <div>
                                                        {messageFileUpload && (<TimedAlert message={messageFileUpload.description} duration={5000} type={messageFileUpload.code} />)}
                                                    </div>

                                                    <Stack
                                                        spacing={2}
                                                        //width="100%"
                                                        direction="row"
                                                        justifyContent="space-between"
                                                        alignItems="center"
                                                        sx={{
                                                            width: '100%',
                                                            //overflowX: 'auto',        // Habilita scroll horizontal
                                                            //whiteSpace: 'nowrap',     // Evita que los items se envuelvan
                                                        }}
                                                    >
                                                        {/* Botones y filtros alineados a la izquierda */}
                                                        <Stack
                                                            direction="row"
                                                            spacing={2}
                                                            alignItems="center"
                                                        >
                                                            {data.list.buttonsHeader.map((item) => {

                                                                let view = true;
                                                                if (item.where !== null && item.where !== undefined) {
                                                                    view = whereFunction(item);
                                                                }

                                                                if (view && security(item)) {
                                                                    return (
                                                                        <Button
                                                                            style={{ fontSize: "inherit", lineHeight: "inherit" }}
                                                                            key={item.id}
                                                                            variant="outlined"
                                                                            onClick={() => buttonHeaderActionList(item.linkto, item.mode, item.function, true)}
                                                                        >
                                                                            {item.name}
                                                                        </Button>
                                                                    );
                                                                }
                                                                return null;
                                                            })}

                                                            {filterAvailable ? data.list.filters.map((item, index) => {
                                                                let arrayDoc = [];
                                                                renderFields(item, index, arrayDoc, data.list.filters, null, null, null, null, null, null);
                                                                return arrayDoc;
                                                            }) : <CircularProgress size={10} />}

                                                        </Stack>

                                                        <Stack
                                                            spacing={2}
                                                            direction="row"
                                                            justifyContent="flex-end"
                                                            alignItems="center"
                                                        >
                                                            <Button
                                                                variant="text"
                                                                size="small"
                                                                onClick={updateList}
                                                                style={{ fontSize: "inherit", lineHeight: "inherit", color: 'black', textDecoration: "underline" }}
                                                            >
                                                                <RefreshIcon />
                                                            </Button>
                                                            <p style={{ fontSize: "inherit", lineHeight: "inherit", fontWeight: '600' }}>
                                                                {recortCountTotalLoad ? <CircularProgress size={10} /> : `${_DATA.currentData().length}/${recordCount}`}
                                                            </p>
                                                            {!recortCountTotalLoad && !isMobile && (
                                                                <Pagination
                                                                    style={{ fontSize: "inherit", fontWeight: '600', lineHeight: "inherit" }}
                                                                    count={count}
                                                                    page={page}
                                                                    color="primary"
                                                                    onChange={handleChangePagination}
                                                                    size="small"
                                                                />
                                                            )}
                                                        </Stack>
                                                    </Stack>
                                                </div>
                                                {load && (
                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <CircularProgress size={150} />
                                                    </div>
                                                )}
                                                {!load && (
                                                    <div>

                                                        <TableContainer component={Paper} sx={{ maxHeight: '84vh', overflowY: 'auto' }}>

                                                            <Table sx={{ minWidth: 650, height: '100%' }} aria-label="simple table">

                                                                <TableHead>

                                                                    <TableRow style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#ffffffff' }}>
                                                                        {posted && (
                                                                            <TableCell> </TableCell>
                                                                        )}
                                                                        {data.list.fields.map((row, index) => {
                                                                            if (isMobile && index > 5) {
                                                                                // Si es móvil y no es una de las primeras dos columnas, no mostrarla
                                                                                return null;
                                                                            }
                                                                            let minWidth;
                                                                            switch (row.type) {
                                                                                case 'TextField':
                                                                                    minWidth = "12ch"
                                                                                    break;
                                                                                case 'Password':
                                                                                    minWidth = "12ch"
                                                                                    break;
                                                                                case 'Date':
                                                                                    minWidth = "10ch"
                                                                                    break;
                                                                                case 'Currency':
                                                                                    minWidth = "16ch"
                                                                                    break;
                                                                                case 'Number':
                                                                                    minWidth = "12ch"
                                                                                    break;
                                                                                case 'Percentage':
                                                                                    minWidth = "7ch"
                                                                                    break;
                                                                                case 'Checkbox':
                                                                                    minWidth = "4ch"
                                                                                    break;
                                                                                case 'Switch':
                                                                                    minWidth = "4ch"
                                                                                    break;
                                                                                case 'Radio':
                                                                                    minWidth = "4ch"
                                                                                    break;
                                                                                case 'Select':
                                                                                    minWidth = "12ch"
                                                                                    break;
                                                                                case 'Button':
                                                                                    minWidth = "4ch"
                                                                                    break;
                                                                                case 'Typography':
                                                                                    minWidth = "12ch"
                                                                                    break;
                                                                                case 'File':
                                                                                    minWidth = "12ch"
                                                                                    break;
                                                                                case 'Json':
                                                                                    minWidth = "12ch"
                                                                                    break;
                                                                                case 'Time':
                                                                                    minWidth = "8ch"
                                                                                    break;
                                                                                case 'Datetime':
                                                                                    minWidth = "19ch"
                                                                                    break;
                                                                                case 'Url':
                                                                                    minWidth = "32ch"
                                                                                    break;
                                                                                default:
                                                                                    minWidth = "16ch"
                                                                                    break;
                                                                            }
                                                                            if (!row.linkto && row.display !== 'hidden') {
                                                                                return <TableCell key={row.id}>
                                                                                    <TextFieldComponent
                                                                                        id={row.id}
                                                                                        name={''}
                                                                                        value={field[row.id]}
                                                                                        onChange={(event) => handleFieldFilterChange(event, row.idFieldTable, row.type, row.id, row.sourceSelect)}
                                                                                        onValidationField={onValidationField}
                                                                                        heightParam='0px'
                                                                                        widthParam='100%'
                                                                                        minWidthParam={minWidth}
                                                                                    />
                                                                                </TableCell>
                                                                            } else {
                                                                                if (row.display !== 'hidden') {
                                                                                    if (security(row)) {
                                                                                        return <TableCell key={row.id}></TableCell>
                                                                                    }
                                                                                } else {
                                                                                    if (row.idFieldTable === 'id' && row.display === 'hidden' && viewId === true) {
                                                                                        return <TableCell key={row.id}>

                                                                                            <TextFieldComponent
                                                                                                id={row.id}
                                                                                                name={''}
                                                                                                value={field[row.id]}
                                                                                                onChange={(event) => handleFieldFilterChange(event, row.idFieldTable, row.type, row.id, row.sourceSelect)}
                                                                                                onValidationField={onValidationField}
                                                                                                heightParam='0px'
                                                                                                widthParam='100%'
                                                                                                minWidthParam={minWidth}
                                                                                            />
                                                                                        </TableCell>
                                                                                    }
                                                                                }
                                                                            }
                                                                            return null;
                                                                        })}
                                                                    </TableRow>

                                                                    <TableRow style={{ position: 'sticky', top: 20, zIndex: 1, backgroundColor: 'rgb(50 59 152)' }}>
                                                                        {posted && (
                                                                            <TableCell style={{ color: 'white' }}>
                                                                                Todos <Checkbox
                                                                                    checked={selectedIds.length === _DATA.currentData().length}
                                                                                    indeterminate={
                                                                                        selectedIds.length > 0 &&
                                                                                        selectedIds.length < _DATA.currentData().length
                                                                                    }
                                                                                    onChange={(e) => {
                                                                                        const isChecked = e.target.checked;
                                                                                        if (isChecked) {
                                                                                            setSelectedIds(_DATA.currentData().map((row) => row.id));
                                                                                        } else {
                                                                                            setSelectedIds([]);
                                                                                        }
                                                                                    }}
                                                                                    color="primary"
                                                                                />
                                                                            </TableCell>
                                                                        )}

                                                                        {data.list.fields.map((row, index) => {

                                                                            if (isMobile && index > 5) {
                                                                                // Si es móvil y no es una de las primeras dos columnas, no mostrarla
                                                                                return null;
                                                                            }
                                                                            if (!row.linkto && row.display !== 'hidden') {
                                                                                if (row.type.includes('Number') || row.type === 'Currency') {
                                                                                    return <TableCell style={{ color: 'white', textAlign: 'center' }} key={row.id}>{row.name}</TableCell>
                                                                                } else {
                                                                                    return <TableCell style={{ color: 'white' }} key={row.id}>{row.name}</TableCell>
                                                                                }
                                                                            } else {
                                                                                if (row.display !== 'hidden') {
                                                                                    if (security(row)) {
                                                                                        return <TableCell style={{ color: 'white' }} key={row.id}></TableCell>
                                                                                    }
                                                                                } else {
                                                                                    if (row.idFieldTable === 'id' && row.display === 'hidden' && viewId === true) {
                                                                                        return <TableCell style={{ color: 'white' }} key={row.id}>{row.name}</TableCell>
                                                                                    }
                                                                                }
                                                                            }
                                                                            return null;
                                                                        })}
                                                                    </TableRow>

                                                                </TableHead>
                                                                {loadList && (
                                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                        <CircularProgress size={50} />
                                                                    </div>
                                                                )}
                                                                <TableBody>

                                                                    {!loadList && (
                                                                        _DATA.currentData().map((row, index) => {

                                                                            return (
                                                                                <TableRow key={`${index}_${row.id}`}
                                                                                    sx={getRowStyle(false, index)}
                                                                                >

                                                                                    {posted && (
                                                                                        <TableCell>
                                                                                            <Checkbox
                                                                                                checked={selectedIds.includes(row.id)}
                                                                                                onChange={(e) =>
                                                                                                    handleCheckboxChange(row.id, e.target.checked)
                                                                                                }
                                                                                                color="primary"
                                                                                            />
                                                                                        </TableCell>
                                                                                    )}

                                                                                    {data.list.fields.map((item, index) => {
                                                                                        if (isMobile && index > 5) {
                                                                                            return null;
                                                                                        }
                                                                                        if (item.linkto !== null) {

                                                                                            let view = true;
                                                                                            if (item.where !== null && item.where !== undefined) {
                                                                                                view = whereFunctionList(item, row);
                                                                                            }

                                                                                            if (security(item)) {
                                                                                                if (view) {
                                                                                                    return (<TableCell key={item.id} component="th" scope="row" width={7}>
                                                                                                        <Tooltip title={item.name}>
                                                                                                            <Button onClick={() => buttonFieldsActionList(item.linkto, item.mode, row.id)}>
                                                                                                                <Icons iconName={item.icon} />
                                                                                                            </Button>
                                                                                                        </Tooltip>
                                                                                                    </TableCell>)
                                                                                                } else {
                                                                                                    return <TableCell key={item.id}></TableCell>
                                                                                                }
                                                                                            }
                                                                                        } else {
                                                                                            var keyNames = Object.keys(row);
                                                                                            let existe = false;
                                                                                            for (let g = 0; g < keyNames.length; g++) {
                                                                                                if (keyNames[g] === item.idFieldTable) {
                                                                                                    existe = keyNames[g];
                                                                                                }
                                                                                            }
                                                                                            if (existe) {
                                                                                                if (item.display !== 'hidden') {
                                                                                                    if (item.type.includes('Number') || item.type === 'Currency') {
                                                                                                        let valueNumber = row[existe].replace(/\./g, ',');
                                                                                                        if (item.type.includes('Number')) {
                                                                                                            let step = 0;
                                                                                                            let decimalValueFlag = item.type.split('ber');
                                                                                                            if (decimalValueFlag.length > 1) {
                                                                                                                step = (decimalValueFlag[1]);
                                                                                                                let valueSplit = valueNumber.split(',');
                                                                                                                if (valueSplit.length > 1) {
                                                                                                                    valueNumber = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, step)}`;
                                                                                                                }
                                                                                                            }
                                                                                                        }
                                                                                                        if (item.type === 'Currency') {
                                                                                                            let valueSplit = valueNumber.split(',');
                                                                                                            if (valueSplit.length > 1) {
                                                                                                                valueNumber = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                                                                                                            }
                                                                                                        }
                                                                                                        return (
                                                                                                            <TableCell key={item.id} component="th" scope="row" align='right' style={{ letterSpacing: "0.01rem", color: Number(row[existe]) < 0 ? "red" : "black" }}>
                                                                                                                {valueNumber}
                                                                                                            </TableCell>
                                                                                                        )
                                                                                                    } else {
                                                                                                        if (item.type === 'Switch' || item.type === 'Checkbox') {
                                                                                                            return (
                                                                                                                <TableCell key={item.id} component="th" scope="row">
                                                                                                                    {row[existe] === '0' ? 'No' : 'Si'}
                                                                                                                </TableCell>
                                                                                                            )
                                                                                                        } else {
                                                                                                            return (
                                                                                                                <TableCell key={item.id} component="th" scope="row">
                                                                                                                    {row[existe]}
                                                                                                                </TableCell>
                                                                                                            )
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    if (item.idFieldTable === 'id' && item.display === 'hidden' && viewId === true) {
                                                                                                        return <TableCell key={item.id}>{row[existe]}</TableCell>
                                                                                                    }
                                                                                                }
                                                                                            } else {
                                                                                                if (item.display !== 'hidden') {
                                                                                                    return <TableCell key={item.id}></TableCell>
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        return null;
                                                                                    })}
                                                                                </TableRow>
                                                                            )
                                                                        })
                                                                    )}
                                                                    {!loadList && totalHeader && (
                                                                        <TableRow
                                                                            sx={getRowStyle(true, 500)}
                                                                        >
                                                                            <TableCell style={{ fontSize: "inherit", fontWeight: '600', lineHeight: "inherit" }}>
                                                                                Saldo Anterior
                                                                            </TableCell>

                                                                            {
                                                                                data.list.fields.map((item, index) => {
                                                                                    if (index === 0) {
                                                                                        if (posted)
                                                                                            return <TableCell key={`empty_${item.id}`}></TableCell>
                                                                                    }
                                                                                    if ((item.type.includes('Number') || item.type === 'Currency') && item.display !== 'hidden' && item.linkto === null &&
                                                                                        //(item.idFieldTable.toUpperCase().includes('QTY') || item.idFieldTable.toUpperCase().includes('AMOUNT'))) {
                                                                                        (item.idFieldTable.toUpperCase().includes('AMOUNT'))) {
                                                                                        let total = 0;
                                                                                        if (totalHeader[item.idFieldTable] !== null && totalHeader[item.idFieldTable] !== undefined) {
                                                                                            total = totalHeader[item.idFieldTable];
                                                                                            total = Number(total).toFixed(2);
                                                                                            total = total.toString().replace(/\./g, ',')
                                                                                            let valueSplit = total.split(',');
                                                                                            if (valueSplit.length > 1) {
                                                                                                total = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1]}`;
                                                                                            }
                                                                                        }
                                                                                        return (
                                                                                            <TableCell key={`total_${item.id}`} component="th" scope="row" align='right' style={{ fontSize: "inherit", fontWeight: '600', lineHeight: "inherit", letterSpacing: "0.01rem", color: Number(totalHeader[item.idFieldTable]) < 0 ? "red" : "black" }} >
                                                                                                {totalSaldoAnteriorLoad ? <CircularProgress size={10} /> : total}
                                                                                            </TableCell>
                                                                                        );
                                                                                    } else {
                                                                                        if (item.linkto !== null && index > 0) {
                                                                                            let cantFlag = 0;
                                                                                            data.list.fields.forEach((item1) => {
                                                                                                if (item1.linkto !== null) {
                                                                                                    if (security(item1)) {
                                                                                                        cantFlag++;
                                                                                                    }
                                                                                                }
                                                                                            })
                                                                                            if (security(item) && cantFlag > 1) {
                                                                                                return <TableCell key={item.id}></TableCell>
                                                                                            }
                                                                                        } else {
                                                                                            if (item.display !== 'hidden' && item.linkto === null) {
                                                                                                return <TableCell key={`empty_${item.id}`}></TableCell>;
                                                                                            } else {
                                                                                                if (item.idFieldTable === 'id' && item.display === 'hidden' && viewId === true && item.linkto === null) {
                                                                                                    return <TableCell key={`empty_${item.id}`}></TableCell>
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }

                                                                                    return null;
                                                                                })
                                                                            }
                                                                        </TableRow>
                                                                    )}

                                                                </TableBody>
                                                                {total && (
                                                                    <TableRow
                                                                        key="totals"
                                                                        style={{
                                                                            position: 'sticky',
                                                                            bottom: 0,
                                                                            backgroundColor: 'white',
                                                                            zIndex: 1000,
                                                                            boxShadow: '0px -2px 5px rgba(0,0,0,0.1)'
                                                                        }}
                                                                    //sx={getRowStyle(true, 500)}
                                                                    >
                                                                        <TableCell style={{ fontSize: "inherit", fontWeight: '600', lineHeight: "inherit" }}>
                                                                            Total
                                                                        </TableCell>
                                                                        {totalFooter && (

                                                                            data.list.fields.map((item, index) => {
                                                                                if (index === 0) {
                                                                                    if (posted)
                                                                                        return <TableCell key={`empty_${item.id}`}></TableCell>
                                                                                }
                                                                                if ((item.type.includes('Number') || item.type === 'Currency') && item.display !== 'hidden' && item.linkto === null &&
                                                                                    //(item.idFieldTable.toUpperCase().includes('QTY') || item.idFieldTable.toUpperCase().includes('AMOUNT'))) {
                                                                                    (item.idFieldTable.toUpperCase().includes('AMOUNT'))) {
                                                                                    let total = 0;
                                                                                    if (totalFooter[item.idFieldTable] !== null && totalFooter[item.idFieldTable] !== undefined) {
                                                                                        total = totalFooter[item.idFieldTable];
                                                                                        total = Number(total).toFixed(2);
                                                                                        total = total.toString().replace(/\./g, ',')
                                                                                        let valueSplit = total.split(',');
                                                                                        if (valueSplit.length > 1) {
                                                                                            total = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1]}`;
                                                                                        }
                                                                                    }
                                                                                    return (
                                                                                        <TableCell key={`total_${item.id}`} component="th" scope="row" align='right' style={{ fontSize: "inherit", fontWeight: '600', lineHeight: "inherit", letterSpacing: "0.01rem", color: Number(totalFooter[item.idFieldTable]) < 0 ? "red" : "black" }} >
                                                                                            {totalFooterLoad ? <CircularProgress size={10} /> : total}
                                                                                        </TableCell>
                                                                                    );
                                                                                } else {
                                                                                    if (item.linkto !== null && index > 0) {
                                                                                        let cantFlag = 0;
                                                                                        data.list.fields.forEach((item1) => {
                                                                                            if (item1.linkto !== null) {
                                                                                                if (security(item1)) {
                                                                                                    cantFlag++;
                                                                                                }
                                                                                            }
                                                                                        })
                                                                                        if (security(item) && cantFlag > 1) {
                                                                                            return <TableCell key={item.id}></TableCell>
                                                                                        }
                                                                                    } else {
                                                                                        if (item.display !== 'hidden' && item.linkto === null) {
                                                                                            return <TableCell key={`empty_${item.id}`}></TableCell>;
                                                                                        } else {
                                                                                            if (item.idFieldTable === 'id' && item.display === 'hidden' && viewId === true && item.linkto === null) {
                                                                                                return <TableCell key={`empty_${item.id}`}></TableCell>
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }

                                                                                return null;
                                                                            })

                                                                        )}
                                                                    </TableRow>
                                                                )}
                                                            </Table>
                                                        </TableContainer>
                                                    </div>
                                                )}
                                            </div>
                                        )}


                                        {mode !== 'l' && availabity && (
                                            <div>
                                                <Dialog
                                                    open={open}
                                                    onClose={handleClose}
                                                    aria-labelledby="alert-dialog-title"
                                                    aria-describedby="alert-dialog-description">
                                                    <DialogTitle id="alert-dialog-title">{"¿Desea eliminar el registro?"}</DialogTitle>
                                                    <DialogActions>
                                                        <Button onClick={handleClose} color="primary">
                                                            Cancelar
                                                        </Button>
                                                        <Button onClick={() => deleteRecord(path, mode)} color="primary" autoFocus>
                                                            Confirmar
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>

                                                <Box
                                                    component="form"
                                                    sx={{
                                                        '& .MuiTextField-root': { m: 1, },
                                                    }}
                                                    noValidate
                                                    autoComplete="off"
                                                >
                                                    <Typography sx={{ mt: 4, mb: 2 }} fontSize={'1rem'} lineHeight={'1.25'} fontWeight={'600'} component="div">
                                                        {data.crud.title}
                                                    </Typography>
                                                    <Typography fontSize={'1rem'} lineHeight={'1.25'} fontWeight={'600'}>
                                                        {title}
                                                    </Typography>
                                                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                                                    <div>
                                                        {message.error === true && message.message !== '' && (<Alert severity="error">{message.message}</Alert>)}
                                                        {message.error === false && message.message !== '' && (<Alert severity="success">{message.message}</Alert>)}
                                                        {erroresIntegracion && (<TimedAlert message={erroresIntegracion} duration={5000} type="error" />)}
                                                        {messageFileUpload && (<TimedAlert message={messageFileUpload.description} duration={5000} type={messageFileUpload.code} />)}
                                                    </div>
                                                    {load && (
                                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                            <CircularProgress size={150} />
                                                        </div>
                                                    )}
                                                    {!load && (
                                                        <div>
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                                                    {data.crud.buttonsHeader.map((item, index) => {
                                                                        if (item.visibility) {
                                                                            for (var r = 0; r < item.visibility.length; r++) {
                                                                                if ((mode === item.visibility[r])) {

                                                                                    let view = true;
                                                                                    if (item.where !== null && item.where !== undefined) {
                                                                                        view = whereFunction(item);
                                                                                    }
                                                                                    if (view && security(item)) {
                                                                                        switch (item.function) {
                                                                                            case 'deleteRecord':
                                                                                                return <Button style={{ marginRight: index !== data.crud.buttonsHeader.length - 1 ? '8px' : '0px' }} key={item.id} variant='outlined' onClick={() => handleClickOpen(item.linkto)}>{item.name}</Button>
                                                                                            case 'saveRecord':
                                                                                                return <Button style={{ marginRight: index !== data.crud.buttonsHeader.length - 1 ? '8px' : '0px' }} key={item.id} variant='outlined' onClick={() => saveRecord(item.linkto, item.mode)}>{item.name}</Button>
                                                                                            case 'back':
                                                                                                return <Button style={{ marginRight: index !== data.crud.buttonsHeader.length - 1 ? '8px' : '0px' }} key={item.id} variant="outlined" onClick={() => back(item.linkto, item.mode)}>{item.name}</Button>
                                                                                            case 'fciAlta':
                                                                                                return !loadIntegration ? (<Button style={{ marginRight: index !== data.crud.buttonsHeader.length - 1 ? '8px' : '0px' }} key={item.id} variant="outlined" onClick={fciAlta}>{item.name}</Button>) : <CircularProgress size={30} />
                                                                                            case 'fciIngresar':
                                                                                                return !loadIntegration ? (<Button style={{ marginRight: index !== data.crud.buttonsHeader.length - 1 ? '8px' : '0px' }} key={item.id} variant="outlined" onClick={fciIngresar}>{item.name}</Button>) : <CircularProgress size={30} />
                                                                                            case 'fciEliminar':
                                                                                                return !loadIntegration ? (<Button style={{ marginRight: index !== data.crud.buttonsHeader.length - 1 ? '8px' : '0px' }} key={item.id} variant="outlined" onClick={fciEliminar}>{item.name}</Button>) : <CircularProgress size={30} />
                                                                                            case 'fciAnular':
                                                                                                return !loadIntegration ? (<Button style={{ marginRight: index !== data.crud.buttonsHeader.length - 1 ? '8px' : '0px' }} key={item.id} variant="outlined" onClick={fciAnular}>{item.name}</Button>) : <CircularProgress size={30} />
                                                                                            default:
                                                                                                return !loadButtonAction ? (<Button style={{ marginRight: index !== data.crud.buttonsHeader.length - 1 ? '8px' : '0px' }} key={item.id} variant="outlined" onClick={() => buttonHeaderActionList(item.linkto, item.mode, item.function, false)}>{item.name}</Button>) : <CircularProgress size={30} />
                                                                                        }
                                                                                    }


                                                                                }
                                                                            }
                                                                        }
                                                                        return null;
                                                                    })}
                                                                    {isTrxPropId && (mode === 'c' || mode === 'u') && (
                                                                        <Tooltip title='Actualizar Importes'>
                                                                            <Button
                                                                                variant="text"
                                                                                size="small"
                                                                                onClick={updateImportes}
                                                                                style={{ fontSize: "inherit", lineHeight: "inherit", color: 'black', textDecoration: "underline" }}
                                                                            >
                                                                                <RefreshIcon />
                                                                            </Button>
                                                                        </Tooltip>
                                                                    )}
                                                                </div>

                                                                {mode !== 'c' && redirectId.length > 0 && (
                                                                    <div style={{ marginLeft: 'auto', display: 'flex', gap: '4px' }}>
                                                                        <KeyboardArrowLeftIcon onClick={() => goToRecordList(data.id, 'prev')} />
                                                                        <KeyboardArrowRightIcon onClick={() => goToRecordList(data.id, 'next')} />
                                                                    </div>
                                                                )}

                                                            </div>


                                                            <br></br>
                                                            {
                                                                renderCrud()
                                                            }

                                                            {isTrxPropId && (
                                                                <Contability
                                                                    user={AuthService.getCurrentUser()}
                                                                    id={id}
                                                                />
                                                            )}

                                                            {id && (
                                                                <Audit
                                                                    user={AuthService.getCurrentUser()}
                                                                    data={data}
                                                                    id={id}
                                                                />
                                                            )}

                                                            {<div>
                                                                {errorSave && (<h6 style={{ color: 'red' }}>{errorSave}</h6>)}
                                                                {
                                                                    data.crud.buttonsFooter && (
                                                                        data.crud.buttonsFooter.map((item) => {
                                                                            if (item.visibility) {
                                                                                for (var r = 0; r < item.visibility.length; r++) {
                                                                                    if ((mode === item.visibility[r])) {
                                                                                        if (security(item)) {
                                                                                            switch (item.function) {
                                                                                                case 'deleteRecord':
                                                                                                    return <Button style={{ fontSize: "inherit", lineHeight: "inherit" }} key={item.id} variant="contained" onClick={() => handleClickOpen(item.linkto)}>{item.name}</Button>
                                                                                                case 'saveRecord':
                                                                                                    return <Button style={{ fontSize: "inherit", lineHeight: "inherit" }} key={item.id} variant="contained" onClick={() => saveRecord(item.linkto, item.mode)}>{item.name}</Button>
                                                                                                case 'back':
                                                                                                    return <Button style={{ fontSize: "inherit", lineHeight: "inherit" }} key={item.id} variant="outlined" onClick={() => back(item.linkto, item.mode)}>{item.name}</Button>
                                                                                                default:
                                                                                                    break;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                            return null;
                                                                        })
                                                                    )
                                                                }
                                                            </div>}
                                                        </div>
                                                    )}
                                                </Box>
                                            </div >
                                        )}

                                        {!availabity && !load && (
                                            <h4>Error de permisos</h4>
                                        )}
                                    </Box>
                                </ThemeProvider>
                            </Grid>
                        </Grid>
                    </Box>
                </header>
            </div>
        </ThemeProvider>
    )
}

export default SystemPages